

// // import React, { useState, useEffect, useRef } from "react";
// // import * as XLSX from "xlsx";

// // import { getCandidates, createCandidate, updateCandidate, deleteCandidate } from "../../services/api";

// // import { useAuth } from "../../contexts/AuthContext";

// // import "./Candidates.css";

// // const Candidates = () => {
// //   // Get current user from AuthContext
// //    const { currentUser } = useAuth(); // Change this line
  
// //   const [candidates, setCandidates] = useState([]);
// //   const [loading, setLoading] = useState(true);
// //   const [showModal, setShowModal] = useState(false);
// //   const [showViewModal, setShowViewModal] = useState(false);
// //   const [viewingCandidate, setViewingCandidate] = useState(null);
// //   const [editingCandidate, setEditingCandidate] = useState(null);
// //   const [searchTerm, setSearchTerm] = useState("");
// //   const [filterSkills, setFilterSkills] = useState("all");
// //   const [filterExperience, setFilterExperience] = useState("all");
// //   const [filterStatus, setFilterStatus] = useState("all");
// //   const [filterRegistration, setFilterRegistration] = useState("all");
// //   const [filterQualification, setFilterQualification] = useState("all");
// //   const [filterBranch, setFilterBranch] = useState("all");
// //   const [sortOrder, setSortOrder] = useState("newest");
// //   const [formErrors, setFormErrors] = useState({});
// //   const [isHeaderScrolled, setIsHeaderScrolled] = useState(false);
  
// //   // Pagination states
// //   const [currentPage, setCurrentPage] = useState(1);
// //   const [itemsPerPage, setItemsPerPage] = useState(10);
// //   const [itemsPerPageOptions] = useState([5, 10, 25, 50, 100]);
  
// //   // Excel import states
// //   const [showImportModal, setShowImportModal] = useState(false);
// //   const [importData, setImportData] = useState([]);
// //   const [importErrors, setImportErrors] = useState([]);
// //   const [importLoading, setImportLoading] = useState(false);
// //   const [importStep, setImportStep] = useState('upload');
// //   const fileInputRef = useRef(null);
// //   const headerRef = useRef(null);

// //   // Check if user is admin
// //   const isAdmin = currentUser && currentUser.role === "admin";

// //   const [formData, setFormData] = useState({
// //     name: "",
// //     email: "",
// //     phone: "",
// //     alternatePhone: "",
// //     skills: "",
// //     experience: "",
// //     qualification: "",
// //     branch: "Ankleshwar",
// //     currentCompany: "",
// //     currentSalary: "",
// //     expectedSalary: "",
// //     noticePeriod: "",
// //     location: "",
// //     resumeUrl: "",
// //     status: "Active",
// //     registrationStatus: "Registered",
// //     createdDate: new Date().toISOString().split('T')[0],
// //   });

// //   useEffect(() => {
// //     loadCandidates();
    
// //     const handleScroll = () => {
// //       if (headerRef.current) {
// //         const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
// //         setIsHeaderScrolled(scrollTop > 50);
// //       }
// //     };

// //     window.addEventListener('scroll', handleScroll);
// //     return () => window.removeEventListener('scroll', handleScroll);
// //   }, []);

// //   // Reset to first page when filters change
// //   useEffect(() => {
// //     setCurrentPage(1);
// //   }, [searchTerm, filterSkills, filterExperience, filterStatus, 
// //       filterRegistration, filterQualification, filterBranch, sortOrder]);

// //   const loadCandidates = async () => {
// //   setLoading(true);

// //   try {
// //     const res = await getCandidates();
// //     setCandidates(res.data);
// //   } catch (error) {
// //     console.error(error);
// //   }

// //   setLoading(false);
// // };

// //   const handleInputChange = (e) => {
// //     const { name, value } = e.target;
// //     setFormData((prev) => ({ ...prev, [name]: value }));
// //     if (formErrors[name]) {
// //       setFormErrors(prev => ({ ...prev, [name]: "" }));
// //     }
// //   };

// //   const validateForm = () => {
// //     const errors = {};
    
// //     if (!formData.name || formData.name.trim() === "") {
// //       errors.name = "Name is required";
// //     }
    
// //     if (!formData.email || formData.email.trim() === "") {
// //       errors.email = "Email is required";
// //     } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
// //       errors.email = "Email is invalid";
// //     }
    
// //     if (!formData.skills || formData.skills.trim() === "") {
// //       errors.skills = "Skills are required";
// //     }
    
// //     if (!formData.experience || formData.experience === "") {
// //       errors.experience = "Experience is required";
// //     }

// //     if (formData.phone && !/^[\d\s\+\-\(\)]{10,}$/.test(formData.phone)) {
// //       errors.phone = "Please enter a valid phone number";
// //     }

// //     setFormErrors(errors);
// //     return Object.keys(errors).length === 0;
// //   };

// //   const handleSubmit = async (e) => {
// //     e.preventDefault();

// //     if (!validateForm()) {
// //       return;
// //     }

// //     const candidateData = {
// //       ...formData,
// //       id: editingCandidate ? editingCandidate.id : Date.now().toString(),
// //       createdDate: editingCandidate ? formData.createdDate : new Date().toISOString().split('T')[0],
// //       skills: formData.skills.split(',').map(s => s.trim()).filter(Boolean).join(', ')
// //     };

// //     if (editingCandidate) {
// //       await updateCandidate(editingCandidate.id, candidateData);
// //     } else {
// //       await createCandidate(candidateData);
// //     }

// //     resetForm();
// //     loadCandidates();
// //     setShowModal(false);
// //   };

// //   const handleView = (candidate) => {
// //     setViewingCandidate(candidate);
// //     setShowViewModal(true);
// //   };

// //   const handleEdit = (candidate) => {
// //     // Only admin can edit
// //     if (!isAdmin) {
// //       alert("You don't have permission to edit candidates");
// //       return;
// //     }
// //     setEditingCandidate(candidate);
// //     setFormData({
// //       ...candidate,
// //       skills: candidate.skills || "",
// //     });
// //     setShowModal(true);
// //   };

// //   const handleDelete = async (id) => {
// //     // Only admin can delete
// //     if (!isAdmin) {
// //       alert("You don't have permission to delete candidates");
// //       return;
// //     }
// //     if (window.confirm("Are you sure you want to delete this candidate?")) {
// //       await deleteCandidate(id);
// //       loadCandidates();
// //     }
// //   };

// //   const resetForm = () => {
// //     setFormData({
// //       name: "",
// //       email: "",
// //       phone: "",
// //       alternatePhone: "",
// //       skills: "",
// //       experience: "",
// //       qualification: "",
// //       branch: "Ankleshwar",
// //       currentCompany: "",
// //       currentSalary: "",
// //       expectedSalary: "",
// //       noticePeriod: "",
// //       location: "",
// //       resumeUrl: "",
// //       status: "Active",
// //       registrationStatus: "Unregistered",
// //       createdDate: new Date().toISOString().split('T')[0],
// //     });
// //     setEditingCandidate(null);
// //     setFormErrors({});
// //   };

// //   // ===== EXCEL IMPORT FUNCTIONS =====
  
// //   const handleFileUpload = (e) => {
// //     const file = e.target.files[0];
// //     if (!file) return;

// //     setImportLoading(true);
// //     setImportErrors([]);

// //     const reader = new FileReader();
// //     reader.onload = (event) => {
// //       try {
// //         const data = new Uint8Array(event.target.result);
// //         const workbook = XLSX.read(data, { type: 'array' });
        
// //         const sheetName = workbook.SheetNames[0];
// //         const worksheet = workbook.Sheets[sheetName];
        
// //         const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
        
// //         const parsedData = parseExcelData(jsonData);
// //         setImportData(parsedData.validData);
// //         setImportErrors(parsedData.errors);
        
// //         if (parsedData.validData.length > 0) {
// //           setImportStep('preview');
// //         }
// //       } catch (error) {
// //         setImportErrors([{ row: 0, error: 'Failed to parse Excel file: ' + error.message }]);
// //       } finally {
// //         setImportLoading(false);
// //       }
// //     };
    
// //     reader.readAsArrayBuffer(file);
// //   };

// //   const parseExcelData = (rows) => {
// //     if (rows.length < 2) {
// //       return { validData: [], errors: [{ row: 0, error: 'File is empty or has no data rows' }] };
// //     }

// //     const headers = rows[0].map(h => String(h || '').toLowerCase().trim());
    
// //     const fieldMap = {
// //       name: findColumnIndex(headers, ['name', 'full name', 'candidate name']),
// //       email: findColumnIndex(headers, ['email', 'e-mail', 'email address']),
// //       phone: findColumnIndex(headers, ['phone', 'mobile', 'contact', 'phone number']),
// //       alternatePhone: findColumnIndex(headers, ['alternate phone', 'alt phone', 'secondary phone']),
// //       skills: findColumnIndex(headers, ['skills', 'skill', 'technologies']),
// //       experience: findColumnIndex(headers, ['experience', 'exp', 'total experience', 'years']),
// //       qualification: findColumnIndex(headers, ['qualification', 'education', 'degree']),
// //       branch: findColumnIndex(headers, ['branch', 'location branch', 'office']),
// //       currentCompany: findColumnIndex(headers, ['current company', 'company', 'employer']),
// //       currentSalary: findColumnIndex(headers, ['current salary', 'current ctc', 'salary']),
// //       expectedSalary: findColumnIndex(headers, ['expected salary', 'expected ctc', 'expectation']),
// //       noticePeriod: findColumnIndex(headers, ['notice period', 'notice', 'np']),
// //       location: findColumnIndex(headers, ['location', 'city', 'place']),
// //       status: findColumnIndex(headers, ['status']),
// //       registrationStatus: findColumnIndex(headers, ['registration status', 'registration', 'reg status'])
// //     };

// //     const validData = [];
// //     const errors = [];

// //     for (let i = 1; i < rows.length; i++) {
// //       const row = rows[i];
// //       if (!row || row.length === 0 || row.every(cell => !cell)) continue;

// //       const branchValue = getCellValue(row, fieldMap.branch);
// //       const validBranch = branchValue && ['Ankleshwar', 'Bharuch'].includes(branchValue) 
// //         ? branchValue 
// //         : 'Ankleshwar';

// //       const candidate = {
// //         id: Date.now().toString() + i,
// //         createdDate: new Date().toISOString().split('T')[0],
// //         name: getCellValue(row, fieldMap.name) || '',
// //         email: getCellValue(row, fieldMap.email) || '',
// //         phone: getCellValue(row, fieldMap.phone) || '',
// //         alternatePhone: getCellValue(row, fieldMap.alternatePhone) || '',
// //         skills: getCellValue(row, fieldMap.skills) || '',
// //         experience: getCellValue(row, fieldMap.experience) || '',
// //         qualification: getCellValue(row, fieldMap.qualification) || '',
// //         branch: validBranch,
// //         currentCompany: getCellValue(row, fieldMap.currentCompany) || '',
// //         currentSalary: getCellValue(row, fieldMap.currentSalary) || '',
// //         expectedSalary: getCellValue(row, fieldMap.expectedSalary) || '',
// //         noticePeriod: getCellValue(row, fieldMap.noticePeriod) || '',
// //         location: getCellValue(row, fieldMap.location) || '',
// //         status: mapStatus(getCellValue(row, fieldMap.status)) || 'Active',
// //        registrationStatus: mapRegistrationStatus(getCellValue(row, fieldMap.registrationStatus)).trim()
// //       };

// //       const rowErrors = [];
// //       if (!candidate.name) rowErrors.push('Name is required');
// //       if (!candidate.email) rowErrors.push('Email is required');
// //       else if (!/\S+@\S+\.\S+/.test(candidate.email)) rowErrors.push('Invalid email format');
// //       if (!candidate.skills) rowErrors.push('Skills are required');
// //       if (!candidate.experience) rowErrors.push('Experience is required');

// //       if (rowErrors.length > 0) {
// //         errors.push({
// //           row: i + 1,
// //           name: candidate.name || 'Unknown',
// //           errors: rowErrors
// //         });
// //       } else {
// //         validData.push(candidate);
// //       }
// //     }

// //     return { validData, errors };
// //   };

// //   const findColumnIndex = (headers, possibleNames) => {
// //     for (let i = 0; i < headers.length; i++) {
// //       if (possibleNames.some(name => headers[i].includes(name))) {
// //         return i;
// //       }
// //     }
// //     return -1;
// //   };

// //   const getCellValue = (row, index) => {
// //     if (index === -1 || index >= row.length) return '';
// //     const value = row[index];
// //     return value !== undefined && value !== null ? String(value).trim() : '';
// //   };

// //   const mapStatus = (value) => {
// //     if (!value) return 'Active';
// //     const status = value.toLowerCase();
// //     if (status.includes('inactive')) return 'Inactive';
// //     if (status.includes('placed')) return 'Placed';
// //     return 'Active';
// //   };

// //   const mapRegistrationStatus = (value) => {
// //     if (!value) return 'Registered';
// //     const reg = value.toLowerCase();
// //     if (reg.includes('unreg')) return 'Unregistered';
// //     return 'Registered';
// //   };

// //   const handleImportConfirm = async () => {
// //   setImportLoading(true);

// //   try {

// //     for (const candidate of importData) {
// //       await createCandidate(candidate);
// //     }

// //     loadCandidates();
// //     setImportStep('complete');

// //     setTimeout(() => {
// //       resetImport();
// //       setShowImportModal(false);
// //     }, 2000);

// //   } catch (error) {
// //     setImportErrors([{ row: 0, error: 'Failed to save candidates: ' + error.message }]);
// //   }

// //   setImportLoading(false);
// // };

// //   const resetImport = () => {
// //     setImportData([]);
// //     setImportErrors([]);
// //     setImportStep('upload');
// //     if (fileInputRef.current) {
// //       fileInputRef.current.value = '';
// //     }
// //   };

// //   const downloadTemplate = () => {
// //     const template = [
// //       ['Name', 'Email', 'Phone', 'Alternate Phone', 'Skills', 'Experience', 'Qualification', 'Branch', 'Current Company', 'Current Salary', 'Expected Salary', 'Notice Period', 'Location', 'Status', 'Registration Status'],
// //       ['John Doe', 'john@example.com', '+1234567890', '+1234567891', 'React, JavaScript, Node.js', '3-5 years', 'B.Tech Computer Science', 'Ankleshwar', 'Tech Corp', '12', '15', '30 days', 'New York', 'Active', 'Registered'],
// //       ['Jane Smith', 'jane@example.com', '+1234567892', '', 'Python, Django, SQL', '5-8 years', 'MCA', 'Bharuch', 'Data Inc', '18', '22', '45 days', 'San Francisco', 'Active', 'Registered']
// //     ];

// //     const wb = XLSX.utils.book_new();
// //     const ws = XLSX.utils.aoa_to_sheet(template);
// //     XLSX.utils.book_append_sheet(wb, ws, 'Template');
// //     XLSX.writeFile(wb, 'candidates_template.xlsx');
// //   };

// //   // Filter and sort candidates
// //   const filteredCandidates = candidates
// //     .filter((candidate) => {
// //       const search = searchTerm.toLowerCase();
// //       const name = candidate.name?.toLowerCase() || "";
// //       const email = candidate.email?.toLowerCase() || "";
// //       const skills = candidate.skills?.toLowerCase() || "";
// //       const company = candidate.currentCompany?.toLowerCase() || "";
// //       const qualification = candidate.qualification?.toLowerCase() || "";

// //       const matchesSearch = !searchTerm || 
// //         name.includes(search) ||
// //         email.includes(search) ||
// //         skills.includes(search) ||
// //         company.includes(search) ||
// //         qualification.includes(search);

// //       const matchesSkills = filterSkills === "all" || 
// //         (candidate.skills?.toLowerCase() || "").includes(filterSkills.toLowerCase());

// //       const matchesExperience = filterExperience === "all" || 
// //         candidate.experience === filterExperience;

// //         const normalize = (val) => (val || "").toLowerCase().trim();

// // const matchesStatus =
// //   filterStatus === "all" ||
// //   normalize(candidate.status) === normalize(filterStatus);

// // const matchesRegistration =
// //   filterRegistration === "all" ||
// //   // normalize(candidate.registrationStatus) === normalize(filterRegistration);
// //   normalize(candidate.registrationStatus).includes(normalize(filterRegistration));

// //       // const matchesStatus = filterStatus === "all" || 
// //       //   candidate.status === filterStatus;

// //       // const matchesRegistration = filterRegistration === "all" || 
// //       //   candidate.registrationStatus === filterRegistration;

// //       const matchesQualification = filterQualification === "all" || 
// //         candidate.qualification === filterQualification;

// //       const matchesBranch = filterBranch === "all" || 
// //         candidate.branch === filterBranch;

// //       return matchesSearch && matchesSkills && matchesExperience && 
// //              matchesStatus && matchesRegistration && 
// //              matchesQualification && matchesBranch;
// //     })
// //     .sort((a, b) => {
// //       const dateA = new Date(a.createdDate || 0);
// //       const dateB = new Date(b.createdDate || 0);
// //       return sortOrder === "newest" ? dateB - dateA : dateA - dateB;
// //     });

// //   // Pagination logic
// //   const indexOfLastItem = currentPage * itemsPerPage;
// //   const indexOfFirstItem = indexOfLastItem - itemsPerPage;
// //   const currentItems = filteredCandidates.slice(indexOfFirstItem, indexOfLastItem);
// //   const totalPages = Math.ceil(filteredCandidates.length / itemsPerPage);

// //   // Change page
// //   const paginate = (pageNumber) => setCurrentPage(pageNumber);
  
// //   // Go to previous page
// //   const goToPreviousPage = () => {
// //     if (currentPage > 1) {
// //       setCurrentPage(currentPage - 1);
// //     }
// //   };
  
// //   // Go to next page
// //   const goToNextPage = () => {
// //     if (currentPage < totalPages) {
// //       setCurrentPage(currentPage + 1);
// //     }
// //   };
  
// //   // Handle items per page change
// //   const handleItemsPerPageChange = (e) => {
// //     setItemsPerPage(Number(e.target.value));
// //     setCurrentPage(1); // Reset to first page
// //   };

// //   const allSkills = [
// //     ...new Set(
// //       candidates.flatMap((c) =>
// //         (c.skills || "")
// //           .split(",")
// //           .map((s) => s.trim())
// //           .filter(Boolean)
// //       )
// //     ),
// //   ];

// //   const allQualifications = [
// //     ...new Set(candidates.map((c) => c.qualification).filter(Boolean)),
// //   ];

// //   const experienceLevels = [
// //     ...new Set(candidates.map((c) => c.experience).filter(Boolean)),
// //   ];

// //   const activeCandidates = candidates.filter(
// //     (c) => c.status === "Active"
// //   ).length;
  
// //   const registeredCandidates = candidates.filter(
// //     (c) => c.registrationStatus === "Registered"
// //   ).length;

// //   const ankleshwarCandidates = candidates.filter(
// //     (c) => c.branch === "Ankleshwar"
// //   ).length;

// //   const bharuchCandidates = candidates.filter(
// //     (c) => c.branch === "Bharuch"
// //   ).length;

// //   const getInitials = (name) => {
// //     if (!name) return "?";
// //     return name
// //       .split(" ")
// //       .map((n) => n[0])
// //       .join("")
// //       .toUpperCase()
// //       .slice(0, 2);
// //   };

// //   const formatDate = (dateString) => {
// //     if (!dateString) return "-";
// //     try {
// //       const options = { year: 'numeric', month: 'short', day: 'numeric' };
// //       return new Date(dateString).toLocaleDateString(undefined, options);
// //     } catch (e) {
// //       return dateString;
// //     }
// //   };

// //   const formatCurrency = (value) => {
// //     if (!value) return "-";
// //     return `₹${value}`;
// //   };

// //   if (loading) {
// //     return (
// //       <div className="loading-container">
// //         <div className="spinner"></div>
// //         <p>Loading candidates...</p>
// //       </div>
// //     );
// //   }

// //   return (
// //     <div className="candidates-page">
// //       <div id="candidates-top"></div>

// //       {/* Fixed Header with Import Button */}
// //       <div 
// //         ref={headerRef}
// //         className={`page-header ${isHeaderScrolled ? 'scrolled' : ''}`}
// //       >
// //         <div>
// //           <h1>Candidates</h1>
// //           <p>Manage candidate profiles and information</p>
// //           {!isAdmin && (
// //             <small style={{ color: '#666', fontSize: '12px' }}>View Only Mode</small>
// //           )}
// //         </div>
// //         <div className="header-actions">
// //           <button
// //             onClick={() => setShowImportModal(true)}
// //             className="btn-secondary"
// //             title="Import from Excel"
// //           >
// //             📥 Import Excel
// //           </button>
// //           <button
// //             onClick={() => setShowModal(true)}
// //             className="btn-primary"
// //           >
// //             + Add Candidate
// //           </button>
// //         </div>
// //       </div>

// //       {/* Stats Cards */}
// //       <div className="stats-cards">
// //         <div className="stat-card">
// //           <div className="stat-icon">👥</div>
// //           <div className="stat-content">
// //             <h3>{candidates.length}</h3>
// //             <p>Total Candidates</p>
// //           </div>
// //         </div>
// //         <div className="stat-card">
// //           <div className="stat-icon">✅</div>
// //           <div className="stat-content">
// //             <h3>{activeCandidates}</h3>
// //             <p>Active Candidates</p>
// //           </div>
// //         </div>
// //         <div className="stat-card">
// //           <div className="stat-icon">📝</div>
// //           <div className="stat-content">
// //             <h3>{registeredCandidates}</h3>
// //             <p>Registered</p>
// //           </div>
// //         </div>
// //         <div className="stat-card">
// //           <div className="stat-icon">🏢</div>
// //           <div className="stat-content">
// //             <h3>{ankleshwarCandidates} | {bharuchCandidates}</h3>
// //             <p>Ankleshwar | Bharuch</p>
// //           </div>
// //         </div>
// //       </div>

// //       {/* Filters */}
// //       <div className="filters-section">
// //         <div className="search-box">
// //           <span className="search-icon">🔍</span>
// //           <input
// //             type="text"
// //             placeholder="Search candidates..."
// //             value={searchTerm}
// //             onChange={(e) => setSearchTerm(e.target.value)}
// //             className="search-input"
// //           />
// //         </div>

// //         <div className="filter-controls">
// //           <select
// //             value={filterQualification}
// //             onChange={(e) => setFilterQualification(e.target.value)}
// //             className="filter-select"
// //           >
// //             <option value="all">All Qualifications</option>
// //             {allQualifications.map((qual) => (
// //               <option key={qual} value={qual}>
// //                 {qual}
// //               </option>
// //             ))}
// //           </select>

// //           <select
// //             value={filterBranch}
// //             onChange={(e) => setFilterBranch(e.target.value)}
// //             className="filter-select"
// //           >
// //             <option value="all">All Branches</option>
// //             <option value="Ankleshwar">Ankleshwar</option>
// //             <option value="Bharuch">Bharuch</option>
// //           </select>

// //           <select
// //             value={filterSkills}
// //             onChange={(e) => setFilterSkills(e.target.value)}
// //             className="filter-select"
// //           >
// //             <option value="all">All Skills</option>
// //             {allSkills.map((skill) => (
// //               <option key={skill} value={skill}>
// //                 {skill}
// //               </option>
// //             ))}
// //           </select>

// //           <select
// //             value={filterExperience}
// //             onChange={(e) => setFilterExperience(e.target.value)}
// //             className="filter-select"
// //           >
// //             <option value="all">All Experience</option>
// //             {experienceLevels.map((exp) => (
// //               <option key={exp} value={exp}>
// //                 {exp}
// //               </option>
// //             ))}
// //           </select>

// //           <select
// //             value={filterStatus}
// //             onChange={(e) => setFilterStatus(e.target.value)}
// //             className="filter-select"
// //           >
// //             <option value="all">All Status</option>
// //             <option value="Active">Active</option>
// //             <option value="Inactive">Inactive</option>
// //             <option value="Placed">Placed</option>
// //           </select>

// //           <select
// //             value={filterRegistration}
// //             onChange={(e) => setFilterRegistration(e.target.value)}
// //             className="filter-select"
// //           >
// //             <option value="all">All Registration</option>
// //             <option value="Registered">Registered</option>
// //             <option value="Unregistered">Unregistered</option>
// //           </select>

// //           <select
// //             value={sortOrder}
// //             onChange={(e) => setSortOrder(e.target.value)}
// //             className="filter-select"
// //           >
// //             <option value="newest">Newest First</option>
// //             <option value="oldest">Oldest First</option>
// //           </select>
// //         </div>
// //       </div>

// //       {/* Table with Pagination */}
// //       <div className="table-container">
// //         {filteredCandidates.length > 0 ? (
// //           <>
// //             <div className="table-responsive">
// //               <table className="data-table">
// //                 <thead>
// //                   <tr>
// //                     <th>Candidate</th>
// //                     <th>Qualification</th>
// //                     <th>Branch</th>
// //                     <th>Skills & Experience</th>
// //                     <th>Contact</th>
// //                     <th>Salary</th>
// //                     <th>Status</th>
// //                     <th>Actions</th>
// //                   </tr>
// //                 </thead>

// //                 <tbody>
// //                   {currentItems.map((candidate) => (
// //                     <tr key={candidate.id}>
// //                       <td>
// //                         <div className="candidate-cell">
// //                           <div className="candidate-avatar">
// //                             {getInitials(candidate.name)}
// //                           </div>
// //                           <div>
// //                             <div className="candidate-name">
// //                               {candidate.name || "N/A"}
// //                             </div>
// //                             <div className="candidate-company">
// //                               {candidate.currentCompany || "Not Specified"}
// //                             </div>
// //                             <div className="candidate-meta">
// //                               📅 {formatDate(candidate.createdDate)}
// //                             </div>
// //                           </div>
// //                         </div>
// //                       </td>
                      
// //                       <td>
// //                         <div className="qualification-cell">
// //                           <span className="qualification-badge">
// //                             {candidate.qualification || "-"}
// //                           </span>
// //                         </div>
// //                       </td>
                      
// //                       <td>
// //                         <div className="branch-cell">
// //                           <span className={`branch-badge ${candidate.branch?.toLowerCase() || ''}`}>
// //                             {candidate.branch || "-"}
// //                           </span>
// //                         </div>
// //                       </td>
                      
// //                       <td>
// //                         <div className="skills-experience-cell">
// //                           <span className="experience-badge">
// //                             {candidate.experience || "Exp N/A"}
// //                           </span>
// //                           <div className="skills-cell">
// //                             {(candidate.skills || "")
// //                               .split(",")
// //                               .map(s => s.trim())
// //                               .filter(Boolean)
// //                               .slice(0, 2)
// //                               .map((skill, i) => (
// //                                 <span key={i} className="skill-tag">
// //                                   {skill}
// //                                 </span>
// //                               ))}
// //                             {(candidate.skills || "").split(",").filter(Boolean).length > 2 && (
// //                               <span className="more-tag">
// //                                 +{(candidate.skills || "").split(",").filter(Boolean).length - 2}
// //                               </span>
// //                             )}
// //                           </div>
// //                         </div>
// //                       </td>
                      
// //                       <td>
// //                         <div className="compact-contact">
// //                           <a href={`mailto:${candidate.email}`} className="email-link" title={candidate.email}>
// //                             {candidate.email?.length > 20 
// //                               ? candidate.email.substring(0, 18) + "..." 
// //                               : candidate.email || "-"}
// //                           </a>
// //                           {candidate.phone && (
// //                             <div className="contact-phone" title={`Primary: ${candidate.phone}${candidate.alternatePhone ? `\nAlternate: ${candidate.alternatePhone}` : ''}`}>
// //                               📞 {candidate.phone}
// //                             </div>
// //                           )}
// //                         </div>
// //                       </td>
                      
// //                       <td>
// //                         <div className="salary-info">
// //                           {candidate.currentSalary ? (
// //                             <>
// //                               <span className="current-salary">
// //                                 💰 {formatCurrency(candidate.currentSalary)}
// //                               </span>
// //                               {candidate.expectedSalary && (
// //                                 <span className="expected-salary" title="Expected Salary">
// //                                   → {formatCurrency(candidate.expectedSalary)}
// //                                 </span>
// //                               )}
// //                             </>
// //                           ) : (
// //                             <span className="salary-na">Not specified</span>
// //                           )}
// //                         </div>
// //                       </td>
                      
// //                       <td>
// //                         <div className="status-group">
// //                           <span className={`status-badge ${(candidate.status || "inactive").toLowerCase()}`}>
// //                             {candidate.status || "Inactive"}
// //                           </span>
// //                           <span className={`registration-badge ${(candidate.registrationStatus || "unregistered").toLowerCase()}`}>
// //                             {candidate.registrationStatus === "Registered" ? "✓" : "✗"} 
// //                             {candidate.registrationStatus === "Registered" ? " Reg" : " Unreg"}
// //                           </span>
// //                         </div>
// //                       </td>
                      
// //                       <td>
// //                         <div className="action-buttons">
// //                           <button
// //                             onClick={() => handleView(candidate)}
// //                             className="action-btn view"
// //                             title="View Details"
// //                           >
// //                             👁️
// //                           </button>
                          
// //                           {/* Edit Button - Only visible to admin */}
// //                           {isAdmin && (
// //                             <button
// //                               onClick={() => handleEdit(candidate)}
// //                               className="action-btn edit"
// //                               title="Edit"
// //                             >
// //                               ✏️
// //                             </button>
// //                           )}
                          
// //                           {/* Delete Button - Only visible to admin */}
// //                           {isAdmin && (
// //                             <button
// //                               onClick={() => handleDelete(candidate.id)}
// //                               className="action-btn delete"
// //                               title="Delete"
// //                             >
// //                               🗑️
// //                             </button>
// //                           )}
// //                         </div>
// //                       </td>
// //                     </tr>
// //                   ))}
// //                 </tbody>
// //               </table>
// //             </div>

// //             {/* Pagination Controls */}
// //             <div className="pagination-container">
// //               <div className="pagination-info">
// //                 Showing {indexOfFirstItem + 1} to {Math.min(indexOfLastItem, filteredCandidates.length)} of {filteredCandidates.length} entries
// //               </div>
              
// //               <div className="pagination-controls">
// //                 <div className="items-per-page">
// //                   <label>Show:</label>
// //                   <select 
// //                     value={itemsPerPage} 
// //                     onChange={handleItemsPerPageChange}
// //                     className="items-per-page-select"
// //                   >
// //                     {itemsPerPageOptions.map(option => (
// //                       <option key={option} value={option}>{option}</option>
// //                     ))}
// //                   </select>
// //                 </div>
                
// //                 <div className="pagination-buttons">
// //                   <button 
// //                     onClick={goToPreviousPage} 
// //                     disabled={currentPage === 1}
// //                     className="pagination-btn prev"
// //                   >
// //                     &laquo; Previous
// //                   </button>
                  
// //                   {/* Page Numbers */}
// //                   <div className="page-numbers">
// //                     {[...Array(totalPages)].map((_, index) => {
// //                       const pageNumber = index + 1;
// //                       // Show limited page numbers with ellipsis
// //                       if (
// //                         pageNumber === 1 ||
// //                         pageNumber === totalPages ||
// //                         (pageNumber >= currentPage - 2 && pageNumber <= currentPage + 2)
// //                       ) {
// //                         return (
// //                           <button
// //                             key={pageNumber}
// //                             onClick={() => paginate(pageNumber)}
// //                             className={`page-number ${currentPage === pageNumber ? 'active' : ''}`}
// //                           >
// //                             {pageNumber}
// //                           </button>
// //                         );
// //                       } else if (
// //                         pageNumber === currentPage - 3 ||
// //                         pageNumber === currentPage + 3
// //                       ) {
// //                         return <span key={pageNumber} className="page-ellipsis">...</span>;
// //                       }
// //                       return null;
// //                     })}
// //                   </div>
                  
// //                   <button 
// //                     onClick={goToNextPage} 
// //                     disabled={currentPage === totalPages}
// //                     className="pagination-btn next"
// //                   >
// //                     Next &raquo;
// //                   </button>
// //                 </div>
// //               </div>
// //             </div>
// //           </>
// //         ) : (
// //           <div className="empty-state">
// //             <div className="empty-icon">👥</div>
// //             <h3>No candidates found</h3>
// //             <p>Try adjusting your search or add a new candidate</p>
// //             <button
// //               onClick={() => setShowModal(true)}
// //               className="btn-primary"
// //             >
// //               + Add Candidate
// //             </button>
// //           </div>
// //         )}
// //       </div>

// //       {/* View Candidate Modal */}
// //       {showViewModal && viewingCandidate && (
// //         <div className="modal-overlay">
// //           <div className="modal-content modal-lg">
// //             <div className="modal-header">
// //               <h2>Candidate Details</h2>
// //               <button
// //                 className="modal-close"
// //                 onClick={() => {
// //                   setViewingCandidate(null);
// //                   setShowViewModal(false);
// //                 }}
// //               >
// //                 ×
// //               </button>
// //             </div>

// //             <div className="modal-body">
// //               <div className="view-candidate-header">
// //                 <div className="view-candidate-avatar">
// //                   {getInitials(viewingCandidate.name)}
// //                 </div>
// //                 <div className="view-candidate-title">
// //                   <h3>{viewingCandidate.name || "N/A"}</h3>
// //                   <p>{viewingCandidate.currentCompany || "No current company"}</p>
// //                 </div>
// //                 <div className="view-candidate-badges">
// //                   <span className={`status-badge ${(viewingCandidate.status || "inactive").toLowerCase()}`}>
// //                     {viewingCandidate.status || "Inactive"}
// //                   </span>
// //                   <span className={`registration-badge ${(viewingCandidate.registrationStatus || "unregistered").toLowerCase()}`}>
// //                     {viewingCandidate.registrationStatus || "Unregistered"}
// //                   </span>
// //                 </div>
// //               </div>

// //               <div className="view-details-grid">
// //                 <div className="view-details-section">
// //                   <h4>Contact Information</h4>
// //                   <div className="view-details-row">
// //                     <span className="detail-label">Email:</span>
// //                     <span className="detail-value">
// //                       <a href={`mailto:${viewingCandidate.email}`}>{viewingCandidate.email || "-"}</a>
// //                     </span>
// //                   </div>
// //                   <div className="view-details-row">
// //                     <span className="detail-label">Primary Phone:</span>
// //                     <span className="detail-value">{viewingCandidate.phone || "-"}</span>
// //                   </div>
// //                   <div className="view-details-row">
// //                     <span className="detail-label">Alternate Phone:</span>
// //                     <span className="detail-value">{viewingCandidate.alternatePhone || "-"}</span>
// //                   </div>
// //                   <div className="view-details-row">
// //                     <span className="detail-label">Location:</span>
// //                     <span className="detail-value">{viewingCandidate.location || "-"}</span>
// //                   </div>
// //                 </div>

// //                 <div className="view-details-section">
// //                   <h4>Professional Details</h4>
// //                   <div className="view-details-row">
// //                     <span className="detail-label">Qualification:</span>
// //                     <span className="detail-value">{viewingCandidate.qualification || "-"}</span>
// //                   </div>
// //                   <div className="view-details-row">
// //                     <span className="detail-label">Branch:</span>
// //                     <span className="detail-value">
// //                       <span className={`branch-badge ${viewingCandidate.branch?.toLowerCase() || ''}`}>
// //                         {viewingCandidate.branch || "-"}
// //                       </span>
// //                     </span>
// //                   </div>
// //                   <div className="view-details-row">
// //                     <span className="detail-label">Experience:</span>
// //                     <span className="detail-value">{viewingCandidate.experience || "-"}</span>
// //                   </div>
// //                   <div className="view-details-row">
// //                     <span className="detail-label">Current Company:</span>
// //                     <span className="detail-value">{viewingCandidate.currentCompany || "-"}</span>
// //                   </div>
// //                   <div className="view-details-row">
// //                     <span className="detail-label">Notice Period:</span>
// //                     <span className="detail-value">{viewingCandidate.noticePeriod || "-"}</span>
// //                   </div>
// //                 </div>

// //                 <div className="view-details-section">
// //                   <h4>Salary Information</h4>
// //                   <div className="view-details-row">
// //                     <span className="detail-label">Current Salary:</span>
// //                     <span className="detail-value">{formatCurrency(viewingCandidate.currentSalary)}</span>
// //                   </div>
// //                   <div className="view-details-row">
// //                     <span className="detail-label">Expected Salary:</span>
// //                     <span className="detail-value">{formatCurrency(viewingCandidate.expectedSalary)}</span>
// //                   </div>
// //                 </div>

// //                 <div className="view-details-section full-width">
// //                   <h4>Skills</h4>
// //                   <div className="skills-container">
// //                     {(viewingCandidate.skills || "")
// //                       .split(",")
// //                       .map(s => s.trim())
// //                       .filter(Boolean)
// //                       .map((skill, index) => (
// //                         <span key={index} className="skill-tag large">
// //                           {skill}
// //                         </span>
// //                       ))}
// //                     {!viewingCandidate.skills && <span className="detail-value">-</span>}
// //                   </div>
// //                 </div>

// //                 <div className="view-details-section full-width">
// //                   <h4>Additional Information</h4>
// //                   <div className="view-details-row">
// //                     <span className="detail-label">Resume URL:</span>
// //                     <span className="detail-value">
// //                       {viewingCandidate.resumeUrl ? (
// //                         <a href={viewingCandidate.resumeUrl} target="_blank" rel="noopener noreferrer">
// //                           View Resume ↗
// //                         </a>
// //                       ) : "-"}
// //                     </span>
// //                   </div>
// //                   <div className="view-details-row">
// //                     <span className="detail-label">Created Date:</span>
// //                     <span className="detail-value">{formatDate(viewingCandidate.createdDate)}</span>
// //                   </div>
// //                 </div>
// //               </div>
// //             </div>

// //             <div className="modal-footer">
// //               <button
// //                 type="button"
// //                 className="btn-secondary"
// //                 onClick={() => {
// //                   setViewingCandidate(null);
// //                   setShowViewModal(false);
// //                 }}
// //               >
// //                 Close
// //               </button>
              
// //               {/* Edit button in modal - Only visible to admin */}
// //               {isAdmin && (
// //                 <button
// //                   type="button"
// //                   className="btn-primary"
// //                   onClick={() => {
// //                     setViewingCandidate(null);
// //                     setShowViewModal(false);
// //                     handleEdit(viewingCandidate);
// //                   }}
// //                 >
// //                   Edit Candidate
// //                 </button>
// //               )}
// //             </div>
// //           </div>
// //         </div>
// //       )}

// //       {/* Add/Edit Modal */}
// //       {showModal && (
// //         <div className="modal-overlay">
// //           <div className="modal-content modal-lg">
// //             <div className="modal-header">
// //               <h2>
// //                 {editingCandidate ? "Edit Candidate" : "Add New Candidate"}
// //               </h2>
// //               <button
// //                 className="modal-close"
// //                 onClick={() => {
// //                   resetForm();
// //                   setShowModal(false);
// //                 }}
// //               >
// //                 ×
// //               </button>
// //             </div>

// //             <form onSubmit={handleSubmit}>
// //               <div className="modal-body">
// //                 <div className="form-grid">
// //                   <div className="form-group">
// //                     <label>Full Name *</label>
// //                     <input
// //                       type="text"
// //                       name="name"
// //                       value={formData.name}
// //                       onChange={handleInputChange}
// //                       className={`form-input ${formErrors.name ? 'error' : ''}`}
// //                       placeholder="John Doe"
// //                     />
// //                     {formErrors.name && <span className="error-message">{formErrors.name}</span>}
// //                   </div>

// //                   <div className="form-group">
// //                     <label>Email *</label>
// //                     <input
// //                       type="email"
// //                       name="email"
// //                       value={formData.email}
// //                       onChange={handleInputChange}
// //                       className={`form-input ${formErrors.email ? 'error' : ''}`}
// //                       placeholder="john@example.com"
// //                     />
// //                     {formErrors.email && <span className="error-message">{formErrors.email}</span>}
// //                   </div>

// //                   <div className="form-group">
// //                     <label>Primary Phone</label>
// //                     <input
// //                       type="tel"
// //                       name="phone"
// //                       value={formData.phone}
// //                       onChange={handleInputChange}
// //                       className={`form-input ${formErrors.phone ? 'error' : ''}`}
// //                       placeholder="+1 234 567 890"
// //                     />
// //                     {formErrors.phone && <span className="error-message">{formErrors.phone}</span>}
// //                   </div>

// //                   <div className="form-group">
// //                     <label>Alternate Phone</label>
// //                     <input
// //                       type="tel"
// //                       name="alternatePhone"
// //                       value={formData.alternatePhone}
// //                       onChange={handleInputChange}
// //                       className="form-input"
// //                       placeholder="+1 234 567 891"
// //                     />
// //                   </div>

// //                   <div className="form-group">
// //                     <label>Qualification</label>
// //                     <input
// //                       type="text"
// //                       name="qualification"
// //                       value={formData.qualification}
// //                       onChange={handleInputChange}
// //                       className="form-input"
// //                       placeholder="e.g., B.Tech, MCA, MBA"
// //                     />
// //                   </div>

// //                   <div className="form-group">
// //                     <label>Branch *</label>
// //                     <select
// //                       name="branch"
// //                       value={formData.branch}
// //                       onChange={handleInputChange}
// //                       className="form-select"
// //                     >
// //                       <option value="Ankleshwar">Ankleshwar</option>
// //                       <option value="Bharuch">Bharuch</option>
// //                     </select>
// //                   </div>

// //                   <div className="form-group">
// //                     <label>Experience *</label>
// //                     <select
// //                       name="experience"
// //                       value={formData.experience}
// //                       onChange={handleInputChange}
// //                       className={`form-select ${formErrors.experience ? 'error' : ''}`}
// //                     >
// //                       <option value="">Select Experience</option>
// //                       <option value="Fresher">Fresher</option>
// //                       <option value="1-2 years">1-2 years</option>
// //                       <option value="3-5 years">3-5 years</option>
// //                       <option value="5-8 years">5-8 years</option>
// //                       <option value="8+ years">8+ years</option>
// //                     </select>
// //                     {formErrors.experience && <span className="error-message">{formErrors.experience}</span>}
// //                   </div>

// //                   <div className="form-group">
// //                     <label>Current Company</label>
// //                     <input
// //                       type="text"
// //                       name="currentCompany"
// //                       value={formData.currentCompany}
// //                       onChange={handleInputChange}
// //                       className="form-input"
// //                       placeholder="Current Company"
// //                     />
// //                   </div>

// //                   <div className="form-group">
// //                     <label>Current Salary (LPA)</label>
// //                     <input
// //                       type="text"
// //                       name="currentSalary"
// //                       value={formData.currentSalary}
// //                       onChange={handleInputChange}
// //                       className="form-input"
// //                       placeholder="e.g., 12"
// //                     />
// //                   </div>

// //                   <div className="form-group">
// //                     <label>Expected Salary (LPA)</label>
// //                     <input
// //                       type="text"
// //                       name="expectedSalary"
// //                       value={formData.expectedSalary}
// //                       onChange={handleInputChange}
// //                       className="form-input"
// //                       placeholder="e.g., 15"
// //                     />
// //                   </div>

// //                   <div className="form-group">
// //                     <label>Notice Period</label>
// //                     <select
// //                       name="noticePeriod"
// //                       value={formData.noticePeriod}
// //                       onChange={handleInputChange}
// //                       className="form-select"
// //                     >
// //                       <option value="">Select Notice Period</option>
// //                       <option value="Immediate">Immediate</option>
// //                       <option value="15 days">15 days</option>
// //                       <option value="30 days">30 days</option>
// //                       <option value="45 days">45 days</option>
// //                       <option value="60 days">60 days</option>
// //                       <option value="90 days">90 days</option>
// //                     </select>
// //                   </div>

// //                   <div className="form-group">
// //                     <label>Location</label>
// //                     <input
// //                       type="text"
// //                       name="location"
// //                       value={formData.location}
// //                       onChange={handleInputChange}
// //                       className="form-input"
// //                       placeholder="City, Country"
// //                     />
// //                   </div>

// //                   <div className="form-group">
// //                     <label>Status</label>
// //                     <select
// //                       name="status"
// //                       value={formData.status}
// //                       onChange={handleInputChange}
// //                       className="form-select"
// //                     >
// //                       <option value="Active">Active</option>
// //                       <option value="Inactive">Inactive</option>
// //                       <option value="Placed">Placed</option>
// //                     </select>
// //                   </div>

// //                   <div className="form-group">
// //                     <label>Registration Status</label>
// //                     <select
// //                       name="registrationStatus"
// //                       value={formData.registrationStatus}
// //                       onChange={handleInputChange}
// //                       className="form-select"
// //                     >
// //                       <option value="Registered">Registered</option>
// //                       <option value="Unregistered">Unregistered</option>
// //                     </select>
// //                   </div>

// //                   {editingCandidate && (
// //                     <div className="form-group">
// //                       <label>Created Date</label>
// //                       <input
// //                         type="date"
// //                         name="createdDate"
// //                         value={formData.createdDate}
// //                         onChange={handleInputChange}
// //                         className="form-input"
// //                       />
// //                     </div>
// //                   )}
// //                 </div>

// //                 <div className="form-group">
// //                   <label>Skills *</label>
// //                   <textarea
// //                     name="skills"
// //                     value={formData.skills}
// //                     onChange={handleInputChange}
// //                     className={`form-textarea ${formErrors.skills ? 'error' : ''}`}
// //                     placeholder="React, JavaScript, Node.js (comma separated)"
// //                     rows="3"
// //                   />
// //                   {formErrors.skills && <span className="error-message">{formErrors.skills}</span>}
// //                   <span className="form-hint">
// //                     Enter skills separated by commas
// //                   </span>
// //                 </div>

// //                 <div className="form-group">
// //                   <label>Resume URL</label>
// //                   <input
// //                     type="url"
// //                     name="resumeUrl"
// //                     value={formData.resumeUrl}
// //                     onChange={handleInputChange}
// //                     className="form-input"
// //                     placeholder="https://example.com/resume.pdf"
// //                   />
// //                 </div>
// //               </div>

// //               <div className="modal-footer">
// //                 <button
// //                   type="button"
// //                   className="btn-secondary"
// //                   onClick={() => {
// //                     resetForm();
// //                     setShowModal(false);
// //                   }}
// //                 >
// //                   Cancel
// //                 </button>
// //                 <button type="submit" className="btn-primary">
// //                   {editingCandidate ? "Update Candidate" : "Save Candidate"}
// //                 </button>
// //               </div>
// //             </form>
// //           </div>
// //         </div>
// //       )}

// //       {/* Excel Import Modal */}
// //       {showImportModal && (
// //         <div className="modal-overlay">
// //           <div className="modal-content modal-lg">
// //             <div className="modal-header">
// //               <h2>Import Candidates from Excel</h2>
// //               <button
// //                 className="modal-close"
// //                 onClick={() => {
// //                   resetImport();
// //                   setShowImportModal(false);
// //                 }}
// //               >
// //                 ×
// //               </button>
// //             </div>

// //             <div className="modal-body">
// //               {importStep === 'upload' && (
// //                 <div className="import-upload-section">
// //                   <div className="import-instructions">
// //                     <h3>Instructions:</h3>
// //                     <ul>
// //                       <li>Download the template file first</li>
// //                       <li>Fill in your candidate data</li>
// //                       <li>Required columns: Name, Email, Skills, Experience</li>
// //                       <li>Branch must be either "Ankleshwar" or "Bharuch"</li>
// //                       <li>Upload the filled Excel file (.xlsx, .xls)</li>
// //                     </ul>
// //                   </div>

// //                   <div className="import-actions">
// //                     <button
// //                       onClick={downloadTemplate}
// //                       className="btn-secondary"
// //                     >
// //                       📥 Download Template
// //                     </button>
                    
// //                     <div className="file-upload-area">
// //                       <input
// //                         type="file"
// //                         ref={fileInputRef}
// //                         accept=".xlsx,.xls,.csv"
// //                         onChange={handleFileUpload}
// //                         className="file-input"
// //                         id="excel-upload"
// //                       />
// //                       <label htmlFor="excel-upload" className="file-upload-label">
// //                         {importLoading ? 'Processing...' : 'Choose Excel File'}
// //                       </label>
// //                     </div>
// //                   </div>

// //                   {importLoading && (
// //                     <div className="import-loading">
// //                       <div className="spinner-small"></div>
// //                       <p>Processing file...</p>
// //                     </div>
// //                   )}
// //                 </div>
// //               )}

// //               {importStep === 'preview' && (
// //                 <div className="import-preview-section">
// //                   <div className="import-summary">
// //                     <h3>Import Summary</h3>
// //                     <div className="summary-stats">
// //                       <div className="stat-item success">
// //                         <span className="stat-value">{importData.length}</span>
// //                         <span className="stat-label">Valid Records</span>
// //                       </div>
// //                       <div className="stat-item error">
// //                         <span className="stat-value">{importErrors.length}</span>
// //                         <span className="stat-label">Errors</span>
// //                       </div>
// //                     </div>
// //                   </div>

// //                   {importErrors.length > 0 && (
// //                     <div className="import-errors">
// //                       <h4>Errors Found:</h4>
// //                       <div className="errors-list">
// //                         {importErrors.map((error, idx) => (
// //                           <div key={idx} className="error-item">
// //                             <strong>Row {error.row}:</strong> {error.name} - {error.errors.join(', ')}
// //                           </div>
// //                         ))}
// //                       </div>
// //                     </div>
// //                   )}

// //                   {importData.length > 0 && (
// //                     <div className="import-preview">
// //                       <h4>Preview (First 5 Records)</h4>
// //                       <div className="preview-table-container">
// //                         <table className="preview-table">
// //                           <thead>
// //                             <tr>
// //                               <th>Name</th>
// //                               <th>Email</th>
// //                               <th>Qualification</th>
// //                               <th>Branch</th>
// //                               <th>Skills</th>
// //                               <th>Experience</th>
// //                               <th>Status</th>
// //                             </tr>
// //                           </thead>
// //                           <tbody>
// //                             {importData.slice(0, 5).map((candidate, idx) => (
// //                               <tr key={idx}>
// //                                 <td>{candidate.name}</td>
// //                                 <td>{candidate.email}</td>
// //                                 <td>{candidate.qualification || '-'}</td>
// //                                 <td>
// //                                   <span className={`branch-badge ${candidate.branch?.toLowerCase()}`}>
// //                                     {candidate.branch}
// //                                   </span>
// //                                 </td>
// //                                 <td>{candidate.skills}</td>
// //                                 <td>{candidate.experience}</td>
// //                                 <td>
// //                                   <span className={`status-badge ${candidate.status.toLowerCase()}`}>
// //                                     {candidate.status}
// //                                   </span>
// //                                 </td>
// //                               </tr>
// //                             ))}
// //                           </tbody>
// //                         </table>
// //                       </div>
// //                     </div>
// //                   )}
// //                 </div>
// //               )}

// //               {importStep === 'complete' && (
// //                 <div className="import-complete">
// //                   <div className="success-icon">✅</div>
// //                   <h3>Import Successful!</h3>
// //                   <p>{importData.length} candidates have been added.</p>
// //                 </div>
// //               )}
// //             </div>

// //             {importStep === 'preview' && (
// //               <div className="modal-footer">
// //                 <button
// //                   type="button"
// //                   className="btn-secondary"
// //                   onClick={resetImport}
// //                 >
// //                   Back
// //                 </button>
// //                 <button
// //                   type="button"
// //                   className="btn-primary"
// //                   onClick={handleImportConfirm}
// //                   disabled={importData.length === 0 || importLoading}
// //                 >
// //                   {importLoading ? 'Importing...' : `Import ${importData.length} Candidates`}
// //                 </button>
// //               </div>
// //             )}
// //           </div>
// //         </div>
// //       )}
// //     </div>
// //   );
// // };

// // export default Candidates;




// import React, { useState, useEffect, useRef } from "react";
// import * as XLSX from "xlsx";

// import { getCandidates, createCandidate, updateCandidate, deleteCandidate } from "../../services/api";

// import { useAuth } from "../../contexts/AuthContext";

// import "./Candidates.css";

// const Candidates = () => {
//   // Get current user from AuthContext
//   const { currentUser } = useAuth();
  
//   const [candidates, setCandidates] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [showModal, setShowModal] = useState(false);
//   const [showViewModal, setShowViewModal] = useState(false);
//   const [viewingCandidate, setViewingCandidate] = useState(null);
//   const [editingCandidate, setEditingCandidate] = useState(null);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [filterSkills, setFilterSkills] = useState("all");
//   const [filterExperience, setFilterExperience] = useState("all");
//   const [filterStatus, setFilterStatus] = useState("all");
//   const [filterRegistration, setFilterRegistration] = useState("all");
//   const [filterQualification, setFilterQualification] = useState("all");
//   const [filterBranch, setFilterBranch] = useState("all");
//   const [sortOrder, setSortOrder] = useState("newest");
//   const [formErrors, setFormErrors] = useState({});
//   const [isHeaderScrolled, setIsHeaderScrolled] = useState(false);
  
//   // Pagination states
//   const [currentPage, setCurrentPage] = useState(1);
//   const [itemsPerPage, setItemsPerPage] = useState(10);
//   const [itemsPerPageOptions] = useState([5, 10, 25, 50, 100]);
  
//   // Excel import states
//   const [showImportModal, setShowImportModal] = useState(false);
//   const [importData, setImportData] = useState([]);
//   const [importErrors, setImportErrors] = useState([]);
//   const [importLoading, setImportLoading] = useState(false);
//   const [importStep, setImportStep] = useState('upload');
//   const fileInputRef = useRef(null);
//   const headerRef = useRef(null);

//   // Check if user is admin
//   const isAdmin = currentUser && currentUser.role === "admin";

//   const [formData, setFormData] = useState({
//     name: "",
//     email: "",
//     phone: "",
//     alternatePhone: "",
//     skills: "",
//     experience: "",
//     qualification: "",
//     branch: "Ankleshwar",
//     currentCompany: "",
//     currentSalary: "",
//     expectedSalary: "",
//     noticePeriod: "",
//     location: "",
//     resumeUrl: "",
//     status: "Active",
//     registrationStatus: "",
//     createdDate: new Date().toISOString().split('T')[0],
//   });

//   useEffect(() => {
//     loadCandidates();
    
//     const handleScroll = () => {
//       if (headerRef.current) {
//         const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
//         setIsHeaderScrolled(scrollTop > 50);
//       }
//     };

//     window.addEventListener('scroll', handleScroll);
//     return () => window.removeEventListener('scroll', handleScroll);
//   }, []);

//   // Reset to first page when filters change
//   useEffect(() => {
//     setCurrentPage(1);
//   }, [searchTerm, filterSkills, filterExperience, filterStatus, 
//       filterRegistration, filterQualification, filterBranch, sortOrder]);

//   const loadCandidates = async () => {
//     setLoading(true);

//     try {
//       const res = await getCandidates();
//       const normalizedCandidates = res.data.map(candidate => ({
//         ...candidate,
//         registrationStatus: candidate.registrationStatus || "Unregistered"
//       }));
//       setCandidates(normalizedCandidates);
//     } catch (error) {
//       console.error(error);
//     }

//     setLoading(false);
//   };

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({ ...prev, [name]: value }));
//     if (formErrors[name]) {
//       setFormErrors(prev => ({ ...prev, [name]: "" }));
//     }
//   };

//   const validateForm = () => {
//     const errors = {};
    
//     if (!formData.name || formData.name.trim() === "") {
//       errors.name = "Name is required";
//     }
    
//     if (!formData.email || formData.email.trim() === "") {
//       errors.email = "Email is required";
//     } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
//       errors.email = "Email is invalid";
//     }
    
//     // REMOVED: Skills required validation
//     // Skills is now optional
    
//     if (!formData.experience || formData.experience === "") {
//       errors.experience = "Experience is required";
//     }

//     if (formData.phone && !/^[\d\s\+\-\(\)]{10,}$/.test(formData.phone)) {
//       errors.phone = "Please enter a valid phone number";
//     }

//     setFormErrors(errors);
//     return Object.keys(errors).length === 0;
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (!validateForm()) {
//       return;
//     }

//     const candidateData = {
//       ...formData,
//       registrationStatus: formData.registrationStatus || "Unregistered",
//       id: editingCandidate ? editingCandidate.id : Date.now().toString(),
//       createdDate: editingCandidate ? formData.createdDate : new Date().toISOString(),
//       skills: formData.skills ? formData.skills.split(',').map(s => s.trim()).filter(Boolean).join(', ') : "",
//     };

//     if (editingCandidate) {
//       await updateCandidate(editingCandidate.id, candidateData);
//     } else {
//       await createCandidate(candidateData);
//     }

//     resetForm();
//     loadCandidates();
//     setShowModal(false);
//   };

//   const handleView = (candidate) => {
//     setViewingCandidate(candidate);
//     setShowViewModal(true);
//   };

//   const handleEdit = (candidate) => {
//     if (!isAdmin) {
//       alert("You don't have permission to edit candidates");
//       return;
//     }
//     setEditingCandidate(candidate);
//     setFormData({
//       ...candidate,
//       skills: candidate.skills || "",
//     });
//     setShowModal(true);
//   };

//   const handleDelete = async (id) => {
//     if (!isAdmin) {
//       alert("You don't have permission to delete candidates");
//       return;
//     }
//     if (window.confirm("Are you sure you want to delete this candidate?")) {
//       await deleteCandidate(id);
//       loadCandidates();
//     }
//   };

//   const resetForm = () => {
//     setFormData({
//       name: "",
//       email: "",
//       phone: "",
//       alternatePhone: "",
//       skills: "",
//       experience: "",
//       qualification: "",
//       branch: "Ankleshwar",
//       currentCompany: "",
//       currentSalary: "",
//       expectedSalary: "",
//       noticePeriod: "",
//       location: "",
//       resumeUrl: "",
//       status: "Active",
//       registrationStatus: "",
//       createdDate: new Date().toISOString().split('T')[0],
//     });
//     setEditingCandidate(null);
//     setFormErrors({});
//   };

//   // ===== EXCEL IMPORT FUNCTIONS =====
  
//   const handleFileUpload = (e) => {
//     const file = e.target.files[0];
//     if (!file) return;

//     setImportLoading(true);
//     setImportErrors([]);

//     const reader = new FileReader();
//     reader.onload = (event) => {
//       try {
//         const data = new Uint8Array(event.target.result);
//         const workbook = XLSX.read(data, { type: 'array' });
        
//         const sheetName = workbook.SheetNames[0];
//         const worksheet = workbook.Sheets[sheetName];
        
//         const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
        
//         const parsedData = parseExcelData(jsonData);
//         setImportData(parsedData.validData);
//         setImportErrors(parsedData.errors);
        
//         if (parsedData.validData.length > 0) {
//           setImportStep('preview');
//         }
//       } catch (error) {
//         setImportErrors([{ row: 0, error: 'Failed to parse Excel file: ' + error.message }]);
//       } finally {
//         setImportLoading(false);
//       }
//     };
    
//     reader.readAsArrayBuffer(file);
//   };

//   const parseExcelData = (rows) => {
//     if (rows.length < 2) {
//       return { validData: [], errors: [{ row: 0, error: 'File is empty or has no data rows' }] };
//     }

//     const headers = rows[0].map(h => String(h || '').toLowerCase().trim());
    
//     const fieldMap = {
//       name: findColumnIndex(headers, ['name', 'full name', 'candidate name']),
//       email: findColumnIndex(headers, ['email', 'e-mail', 'email address']),
//       phone: findColumnIndex(headers, ['phone', 'mobile', 'contact', 'phone number']),
//       alternatePhone: findColumnIndex(headers, ['alternate phone', 'alt phone', 'secondary phone']),
//       skills: findColumnIndex(headers, ['skills', 'skill', 'technologies']),
//       experience: findColumnIndex(headers, ['experience', 'exp', 'total experience', 'years']),
//       qualification: findColumnIndex(headers, ['qualification', 'education', 'degree']),
//       branch: findColumnIndex(headers, ['branch', 'location branch', 'office']),
//       currentCompany: findColumnIndex(headers, ['current company', 'company', 'employer']),
//       currentSalary: findColumnIndex(headers, ['current salary', 'current ctc', 'salary']),
//       expectedSalary: findColumnIndex(headers, ['expected salary', 'expected ctc', 'expectation']),
//       noticePeriod: findColumnIndex(headers, ['notice period', 'notice', 'np']),
//       location: findColumnIndex(headers, ['location', 'city', 'place']),
//       status: findColumnIndex(headers, ['status']),
//       registrationStatus: findColumnIndex(headers, ['registration status', 'registration', 'reg status'])
//     };

//     const validData = [];
//     const errors = [];

//     for (let i = 1; i < rows.length; i++) {
//       const row = rows[i];
//       if (!row || row.length === 0 || row.every(cell => !cell)) continue;

//       const branchValue = getCellValue(row, fieldMap.branch);
//       const validBranch = branchValue && ['Ankleshwar', 'Bharuch'].includes(branchValue) 
//         ? branchValue 
//         : 'Ankleshwar';

//       const registrationStatusValue = getCellValue(row, fieldMap.registrationStatus);
      
//       const candidate = {
//         id: Date.now().toString() + i,
//         createdDate: new Date().toISOString(),
//         name: getCellValue(row, fieldMap.name) || '',
//         email: getCellValue(row, fieldMap.email) || '',
//         phone: getCellValue(row, fieldMap.phone) || '',
//         alternatePhone: getCellValue(row, fieldMap.alternatePhone) || '',
//         skills: getCellValue(row, fieldMap.skills) || '',
//         experience: getCellValue(row, fieldMap.experience) || '',
//         qualification: getCellValue(row, fieldMap.qualification) || '',
//         branch: validBranch,
//         currentCompany: getCellValue(row, fieldMap.currentCompany) || '',
//         currentSalary: getCellValue(row, fieldMap.currentSalary) || '',
//         expectedSalary: getCellValue(row, fieldMap.expectedSalary) || '',
//         noticePeriod: getCellValue(row, fieldMap.noticePeriod) || '',
//         location: getCellValue(row, fieldMap.location) || '',
//         status: mapStatus(getCellValue(row, fieldMap.status)) || 'Active',
//         registrationStatus: mapRegistrationStatus(registrationStatusValue) || "Unregistered"
//       };

//       const rowErrors = [];
//       if (!candidate.name) rowErrors.push('Name is required');
//       if (!candidate.email) rowErrors.push('Email is required');
//       else if (!/\S+@\S+\.\S+/.test(candidate.email)) rowErrors.push('Invalid email format');
//       // REMOVED: Skills validation from Excel import
//       if (!candidate.experience) rowErrors.push('Experience is required');

//       if (rowErrors.length > 0) {
//         errors.push({
//           row: i + 1,
//           name: candidate.name || 'Unknown',
//           errors: rowErrors
//         });
//       } else {
//         validData.push(candidate);
//       }
//     }

//     return { validData, errors };
//   };

//   const findColumnIndex = (headers, possibleNames) => {
//     for (let i = 0; i < headers.length; i++) {
//       if (possibleNames.some(name => headers[i].includes(name))) {
//         return i;
//       }
//     }
//     return -1;
//   };

//   const getCellValue = (row, index) => {
//     if (index === -1 || index >= row.length) return '';
//     const value = row[index];
//     return value !== undefined && value !== null ? String(value).trim() : '';
//   };

//   const mapStatus = (value) => {
//     if (!value) return 'Active';
//     const status = value.toLowerCase();
//     if (status.includes('inactive')) return 'Inactive';
//     if (status.includes('placed')) return 'Placed';
//     return 'Active';
//   };

//   const mapRegistrationStatus = (value) => {
//     if (!value) return '';
//     const reg = value.toLowerCase();
//     if (reg.includes('unreg')) return 'Unregistered';
//     if (reg.includes('reg')) return 'Registered';
//     return '';
//   };

//   const handleImportConfirm = async () => {
//     setImportLoading(true);

//     try {
//       for (const candidate of importData) {
//         const candidateToSave = {
//           ...candidate,
//           registrationStatus: candidate.registrationStatus || "Unregistered"
//         };
//         await createCandidate(candidateToSave);
//       }

//       loadCandidates();
//       setImportStep('complete');

//       setTimeout(() => {
//         resetImport();
//         setShowImportModal(false);
//       }, 2000);

//     } catch (error) {
//       setImportErrors([{ row: 0, error: 'Failed to save candidates: ' + error.message }]);
//     }

//     setImportLoading(false);
//   };

//   const resetImport = () => {
//     setImportData([]);
//     setImportErrors([]);
//     setImportStep('upload');
//     if (fileInputRef.current) {
//       fileInputRef.current.value = '';
//     }
//   };

//   const downloadTemplate = () => {
//     const template = [
//       ['Name', 'Email', 'Phone', 'Alternate Phone', 'Skills', 'Experience', 'Qualification', 'Branch', 'Current Company', 'Current Salary', 'Expected Salary', 'Notice Period', 'Location', 'Status', 'Registration Status'],
//       ['John Doe', 'john@example.com', '+1234567890', '+1234567891', 'React, JavaScript, Node.js', '3-5 years', 'B.Tech Computer Science', 'Ankleshwar', 'Tech Corp', '12', '15', '30 days', 'New York', 'Active', 'Registered'],
//       ['Jane Smith', 'jane@example.com', '+1234567892', '', '', '5-8 years', 'MCA', 'Bharuch', 'Data Inc', '18', '22', '45 days', 'San Francisco', 'Active', '']
//     ];

//     const wb = XLSX.utils.book_new();
//     const ws = XLSX.utils.aoa_to_sheet(template);
//     XLSX.utils.book_append_sheet(wb, ws, 'Template');
//     XLSX.writeFile(wb, 'candidates_template.xlsx');
//   };

//   // FIXED: Sort with date and time together
//   const filteredCandidates = candidates
//     .filter((candidate) => {
//       const search = searchTerm.toLowerCase();
//       const name = candidate.name?.toLowerCase() || "";
//       const email = candidate.email?.toLowerCase() || "";
//       const skills = candidate.skills?.toLowerCase() || "";
//       const company = candidate.currentCompany?.toLowerCase() || "";
//       const qualification = candidate.qualification?.toLowerCase() || "";

//       const matchesSearch = !searchTerm || 
//         name.includes(search) ||
//         email.includes(search) ||
//         skills.includes(search) ||
//         company.includes(search) ||
//         qualification.includes(search);

//       const matchesSkills = filterSkills === "all" || 
//         (candidate.skills?.toLowerCase() || "").includes(filterSkills.toLowerCase());

//       const matchesExperience = filterExperience === "all" || 
//         candidate.experience === filterExperience;

//       const normalize = (val) => (val || "").toLowerCase().trim();

//       const matchesStatus =
//         filterStatus === "all" ||
//         normalize(candidate.status) === normalize(filterStatus);

//       let matchesRegistration = true;
//       if (filterRegistration !== "all") {
//         const candidateRegStatus = candidate.registrationStatus || "Unregistered";
//         matchesRegistration = normalize(candidateRegStatus) === normalize(filterRegistration);
//       }

//       const matchesQualification = filterQualification === "all" || 
//         candidate.qualification === filterQualification;

//       const matchesBranch = filterBranch === "all" || 
//         candidate.branch === filterBranch;

//       return matchesSearch && matchesSkills && matchesExperience && 
//              matchesStatus && matchesRegistration && 
//              matchesQualification && matchesBranch;
//     })
//     .sort((a, b) => {
//       // Parse dates with time properly
//       const dateA = new Date(a.createdDate);
//       const dateB = new Date(b.createdDate);
      
//       // Check if dates are valid
//       const timeA = isNaN(dateA.getTime()) ? 0 : dateA.getTime();
//       const timeB = isNaN(dateB.getTime()) ? 0 : dateB.getTime();
      
//       return sortOrder === "newest" ? timeB - timeA : timeA - timeB;
//     });

//   // Pagination logic
//   const indexOfLastItem = currentPage * itemsPerPage;
//   const indexOfFirstItem = indexOfLastItem - itemsPerPage;
//   const currentItems = filteredCandidates.slice(indexOfFirstItem, indexOfLastItem);
//   const totalPages = Math.ceil(filteredCandidates.length / itemsPerPage);

//   const paginate = (pageNumber) => setCurrentPage(pageNumber);
  
//   const goToPreviousPage = () => {
//     if (currentPage > 1) {
//       setCurrentPage(currentPage - 1);
//     }
//   };
  
//   const goToNextPage = () => {
//     if (currentPage < totalPages) {
//       setCurrentPage(currentPage + 1);
//     }
//   };
  
//   const handleItemsPerPageChange = (e) => {
//     setItemsPerPage(Number(e.target.value));
//     setCurrentPage(1);
//   };

//   const allSkills = [
//     ...new Set(
//       candidates.flatMap((c) =>
//         (c.skills || "")
//           .split(",")
//           .map((s) => s.trim())
//           .filter(Boolean)
//       )
//     ),
//   ];

//   const allQualifications = [
//     ...new Set(candidates.map((c) => c.qualification).filter(Boolean)),
//   ];

//   const experienceLevels = [
//     ...new Set(candidates.map((c) => c.experience).filter(Boolean)),
//   ];

//   const activeCandidates = candidates.filter(
//     (c) => c.status === "Active"
//   ).length;
  
//   const registeredCandidates = candidates.filter(
//     (c) => (c.registrationStatus || "Unregistered") === "Registered"
//   ).length;

//   const ankleshwarCandidates = candidates.filter(
//     (c) => c.branch === "Ankleshwar"
//   ).length;

//   const bharuchCandidates = candidates.filter(
//     (c) => c.branch === "Bharuch"
//   ).length;

//   const getInitials = (name) => {
//     if (!name) return "?";
//     return name
//       .split(" ")
//       .map((n) => n[0])
//       .join("")
//       .toUpperCase()
//       .slice(0, 2);
//   };

//   const formatDate = (dateString) => {
//     if (!dateString) return "-";
//     try {
//       const date = new Date(dateString);
//       const options = { year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' };
//       return date.toLocaleDateString(undefined, options);
//     } catch (e) {
//       return dateString;
//     }
//   };

//   const formatCurrency = (value) => {
//     if (!value) return "-";
//     return `₹${value}`;
//   };

//   if (loading) {
//     return (
//       <div className="loading-container">
//         <div className="spinner"></div>
//         <p>Loading candidates...</p>
//       </div>
//     );
//   }

//   return (
//     <div className="candidates-page">
//       <div id="candidates-top"></div>

//       <div 
//         ref={headerRef}
//         className={`page-header ${isHeaderScrolled ? 'scrolled' : ''}`}
//       >
//         <div>
//           <h1>Candidates</h1>
//           <p>Manage candidate profiles and information</p>
//           {!isAdmin && (
//             <small style={{ color: '#666', fontSize: '12px' }}>View Only Mode</small>
//           )}
//         </div>
//         <div className="header-actions">
//           <button
//             onClick={() => setShowImportModal(true)}
//             className="btn-secondary"
//             title="Import from Excel"
//           >
//             📥 Import Excel
//           </button>
//           <button
//             onClick={() => setShowModal(true)}
//             className="btn-primary"
//           >
//             + Add Candidate
//           </button>
//         </div>
//       </div>

//       <div className="stats-cards">
//         <div className="stat-card">
//           <div className="stat-icon">👥</div>
//           <div className="stat-content">
//             <h3>{candidates.length}</h3>
//             <p>Total Candidates</p>
//           </div>
//         </div>
//         <div className="stat-card">
//           <div className="stat-icon">✅</div>
//           <div className="stat-content">
//             <h3>{activeCandidates}</h3>
//             <p>Active Candidates</p>
//           </div>
//         </div>
//         <div className="stat-card">
//           <div className="stat-icon">📝</div>
//           <div className="stat-content">
//             <h3>{registeredCandidates}</h3>
//             <p>Registered</p>
//           </div>
//         </div>
//         <div className="stat-card">
//           <div className="stat-icon">🏢</div>
//           <div className="stat-content">
//             <h3>{ankleshwarCandidates} | {bharuchCandidates}</h3>
//             <p>Ankleshwar | Bharuch</p>
//           </div>
//         </div>
//       </div>

//       <div className="filters-section">
//         <div className="search-box">
//           <span className="search-icon">🔍</span>
//           <input
//             type="text"
//             placeholder="Search candidates..."
//             value={searchTerm}
//             onChange={(e) => setSearchTerm(e.target.value)}
//             className="search-input"
//           />
//         </div>

//         <div className="filter-controls">
//           <select
//             value={filterQualification}
//             onChange={(e) => setFilterQualification(e.target.value)}
//             className="filter-select"
//           >
//             <option value="all">All Qualifications</option>
//             {allQualifications.map((qual) => (
//               <option key={qual} value={qual}>
//                 {qual}
//               </option>
//             ))}
//           </select>

//           <select
//             value={filterBranch}
//             onChange={(e) => setFilterBranch(e.target.value)}
//             className="filter-select"
//           >
//             <option value="all">All Branches</option>
//             <option value="Ankleshwar">Ankleshwar</option>
//             <option value="Bharuch">Bharuch</option>
//           </select>

//           <select
//             value={filterSkills}
//             onChange={(e) => setFilterSkills(e.target.value)}
//             className="filter-select"
//           >
//             <option value="all">All Skills</option>
//             {allSkills.map((skill) => (
//               <option key={skill} value={skill}>
//                 {skill}
//               </option>
//             ))}
//           </select>

//           <select
//             value={filterExperience}
//             onChange={(e) => setFilterExperience(e.target.value)}
//             className="filter-select"
//           >
//             <option value="all">All Experience</option>
//             {experienceLevels.map((exp) => (
//               <option key={exp} value={exp}>
//                 {exp}
//               </option>
//             ))}
//           </select>

//           <select
//             value={filterStatus}
//             onChange={(e) => setFilterStatus(e.target.value)}
//             className="filter-select"
//           >
//             <option value="all">All Status</option>
//             <option value="Active">Active</option>
//             <option value="Inactive">Inactive</option>
//             <option value="Placed">Placed</option>
//           </select>

//           <select
//             value={filterRegistration}
//             onChange={(e) => setFilterRegistration(e.target.value)}
//             className="filter-select"
//           >
//             <option value="all">All Registration</option>
//             <option value="Registered">Registered</option>
//             <option value="Unregistered">Unregistered</option>
//           </select>

//           <select
//             value={sortOrder}
//             onChange={(e) => setSortOrder(e.target.value)}
//             className="filter-select"
//           >
//             <option value="newest">Newest First</option>
//             <option value="oldest">Oldest First</option>
//           </select>
//         </div>
//       </div>

//       <div className="table-container">
//         {filteredCandidates.length > 0 ? (
//           <>
//             <div className="table-responsive">
//               <table className="data-table">
//                 <thead>
//                   <tr>
//                     <th>Candidate</th>
//                     <th>Qualification</th>
//                     <th>Branch</th>
//                     <th>Skills & Experience</th>
//                     <th>Contact</th>
//                     <th>Salary</th>
//                     <th>Status</th>
//                     <th>Actions</th>
//                   </tr>
//                 </thead>

//                 <tbody>
//                   {currentItems.map((candidate) => (
//                     <tr key={candidate.id}>
//                       <td>
//                         <div className="candidate-cell">
//                           <div className="candidate-avatar">
//                             {getInitials(candidate.name)}
//                           </div>
//                           <div>
//                             <div className="candidate-name">
//                               {candidate.name || "N/A"}
//                             </div>
//                             <div className="candidate-company">
//                               {candidate.currentCompany || "Not Specified"}
//                             </div>
//                             <div className="candidate-meta">
//                               📅 {formatDate(candidate.createdDate)}
//                             </div>
//                           </div>
//                         </div>
//                       </td>
                      
//                       <td>
//                         <div className="qualification-cell">
//                           <span className="qualification-badge">
//                             {candidate.qualification || "-"}
//                           </span>
//                         </div>
//                       </td>
                      
//                       <td>
//                         <div className="branch-cell">
//                           <span className={`branch-badge ${candidate.branch?.toLowerCase() || ''}`}>
//                             {candidate.branch || "-"}
//                           </span>
//                         </div>
//                       </td>
                      
//                       <td>
//                         <div className="skills-experience-cell">
//                           <span className="experience-badge">
//                             {candidate.experience || "Exp N/A"}
//                           </span>
//                           <div className="skills-cell">
//                             {(candidate.skills || "")
//                               .split(",")
//                               .map(s => s.trim())
//                               .filter(Boolean)
//                               .slice(0, 2)
//                               .map((skill, i) => (
//                                 <span key={i} className="skill-tag">
//                                   {skill}
//                                 </span>
//                               ))}
//                             {(candidate.skills || "").split(",").filter(Boolean).length > 2 && (
//                               <span className="more-tag">
//                                 +{(candidate.skills || "").split(",").filter(Boolean).length - 2}
//                               </span>
//                             )}
//                             {!candidate.skills && <span className="no-skills">No skills</span>}
//                           </div>
//                         </div>
//                       </td>
                      
//                       <td>
//                         <div className="compact-contact">
//                           <a href={`mailto:${candidate.email}`} className="email-link" title={candidate.email}>
//                             {candidate.email?.length > 20 
//                               ? candidate.email.substring(0, 18) + "..." 
//                               : candidate.email || "-"}
//                           </a>
//                           {candidate.phone && (
//                             <div className="contact-phone" title={`Primary: ${candidate.phone}${candidate.alternatePhone ? `\nAlternate: ${candidate.alternatePhone}` : ''}`}>
//                               📞 {candidate.phone}
//                             </div>
//                           )}
//                         </div>
//                       </td>
                      
//                       <td>
//                         <div className="salary-info">
//                           {candidate.currentSalary ? (
//                             <>
//                               <span className="current-salary">
//                                 💰 {formatCurrency(candidate.currentSalary)}
//                               </span>
//                               {candidate.expectedSalary && (
//                                 <span className="expected-salary" title="Expected Salary">
//                                   → {formatCurrency(candidate.expectedSalary)}
//                                 </span>
//                               )}
//                             </>
//                           ) : (
//                             <span className="salary-na">Not specified</span>
//                           )}
//                         </div>
//                       </td>
                      
//                       <td>
//                         <div className="status-group">
//                           <span className={`status-badge ${(candidate.status || "inactive").toLowerCase()}`}>
//                             {candidate.status || "Inactive"}
//                           </span>
//                           <span className={`registration-badge ${(candidate.registrationStatus || "unregistered").toLowerCase()}`}>
//                             {candidate.registrationStatus === "Registered" ? "✓" : "✗"} 
//                             {candidate.registrationStatus === "Registered" ? " Reg" : " Unreg"}
//                           </span>
//                         </div>
//                       </td>
                      
//                       <td>
//                         <div className="action-buttons">
//                           <button
//                             onClick={() => handleView(candidate)}
//                             className="action-btn view"
//                             title="View Details"
//                           >
//                             👁️
//                           </button>
                          
//                           {isAdmin && (
//                             <button
//                               onClick={() => handleEdit(candidate)}
//                               className="action-btn edit"
//                               title="Edit"
//                             >
//                               ✏️
//                             </button>
//                           )}
                          
//                           {isAdmin && (
//                             <button
//                               onClick={() => handleDelete(candidate.id)}
//                               className="action-btn delete"
//                               title="Delete"
//                             >
//                               🗑️
//                             </button>
//                           )}
//                         </div>
//                       </td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//             </div>

//             <div className="pagination-container">
//               <div className="pagination-info">
//                 Showing {indexOfFirstItem + 1} to {Math.min(indexOfLastItem, filteredCandidates.length)} of {filteredCandidates.length} entries
//               </div>
              
//               <div className="pagination-controls">
//                 <div className="items-per-page">
//                   <label>Show:</label>
//                   <select 
//                     value={itemsPerPage} 
//                     onChange={handleItemsPerPageChange}
//                     className="items-per-page-select"
//                   >
//                     {itemsPerPageOptions.map(option => (
//                       <option key={option} value={option}>{option}</option>
//                     ))}
//                   </select>
//                 </div>
                
//                 <div className="pagination-buttons">
//                   <button 
//                     onClick={goToPreviousPage} 
//                     disabled={currentPage === 1}
//                     className="pagination-btn prev"
//                   >
//                     &laquo; Previous
//                   </button>
                  
//                   <div className="page-numbers">
//                     {[...Array(totalPages)].map((_, index) => {
//                       const pageNumber = index + 1;
//                       if (
//                         pageNumber === 1 ||
//                         pageNumber === totalPages ||
//                         (pageNumber >= currentPage - 2 && pageNumber <= currentPage + 2)
//                       ) {
//                         return (
//                           <button
//                             key={pageNumber}
//                             onClick={() => paginate(pageNumber)}
//                             className={`page-number ${currentPage === pageNumber ? 'active' : ''}`}
//                           >
//                             {pageNumber}
//                           </button>
//                         );
//                       } else if (
//                         pageNumber === currentPage - 3 ||
//                         pageNumber === currentPage + 3
//                       ) {
//                         return <span key={pageNumber} className="page-ellipsis">...</span>;
//                       }
//                       return null;
//                     })}
//                   </div>
                  
//                   <button 
//                     onClick={goToNextPage} 
//                     disabled={currentPage === totalPages}
//                     className="pagination-btn next"
//                   >
//                     Next &raquo;
//                   </button>
//                 </div>
//               </div>
//             </div>
//           </>
//         ) : (
//           <div className="empty-state">
//             <div className="empty-icon">👥</div>
//             <h3>No candidates found</h3>
//             <p>Try adjusting your search or add a new candidate</p>
//             <button
//               onClick={() => setShowModal(true)}
//               className="btn-primary"
//             >
//               + Add Candidate
//             </button>
//           </div>
//         )}
//       </div>

//       {/* View Candidate Modal - Same as before */}
//       {showViewModal && viewingCandidate && (
//         <div className="modal-overlay">
//           <div className="modal-content modal-lg">
//             <div className="modal-header">
//               <h2>Candidate Details</h2>
//               <button
//                 className="modal-close"
//                 onClick={() => {
//                   setViewingCandidate(null);
//                   setShowViewModal(false);
//                 }}
//               >
//                 ×
//               </button>
//             </div>

//             <div className="modal-body">
//               <div className="view-candidate-header">
//                 <div className="view-candidate-avatar">
//                   {getInitials(viewingCandidate.name)}
//                 </div>
//                 <div className="view-candidate-title">
//                   <h3>{viewingCandidate.name || "N/A"}</h3>
//                   <p>{viewingCandidate.currentCompany || "No current company"}</p>
//                 </div>
//                 <div className="view-candidate-badges">
//                   <span className={`status-badge ${(viewingCandidate.status || "inactive").toLowerCase()}`}>
//                     {viewingCandidate.status || "Inactive"}
//                   </span>
//                   <span className={`registration-badge ${(viewingCandidate.registrationStatus || "unregistered").toLowerCase()}`}>
//                     {viewingCandidate.registrationStatus || "Unregistered"}
//                   </span>
//                 </div>
//               </div>

//               <div className="view-details-grid">
//                 <div className="view-details-section">
//                   <h4>Contact Information</h4>
//                   <div className="view-details-row">
//                     <span className="detail-label">Email:</span>
//                     <span className="detail-value">
//                       <a href={`mailto:${viewingCandidate.email}`}>{viewingCandidate.email || "-"}</a>
//                     </span>
//                   </div>
//                   <div className="view-details-row">
//                     <span className="detail-label">Primary Phone:</span>
//                     <span className="detail-value">{viewingCandidate.phone || "-"}</span>
//                   </div>
//                   <div className="view-details-row">
//                     <span className="detail-label">Alternate Phone:</span>
//                     <span className="detail-value">{viewingCandidate.alternatePhone || "-"}</span>
//                   </div>
//                   <div className="view-details-row">
//                     <span className="detail-label">Location:</span>
//                     <span className="detail-value">{viewingCandidate.location || "-"}</span>
//                   </div>
//                 </div>

//                 <div className="view-details-section">
//                   <h4>Professional Details</h4>
//                   <div className="view-details-row">
//                     <span className="detail-label">Qualification:</span>
//                     <span className="detail-value">{viewingCandidate.qualification || "-"}</span>
//                   </div>
//                   <div className="view-details-row">
//                     <span className="detail-label">Branch:</span>
//                     <span className="detail-value">
//                       <span className={`branch-badge ${viewingCandidate.branch?.toLowerCase() || ''}`}>
//                         {viewingCandidate.branch || "-"}
//                       </span>
//                     </span>
//                   </div>
//                   <div className="view-details-row">
//                     <span className="detail-label">Experience:</span>
//                     <span className="detail-value">{viewingCandidate.experience || "-"}</span>
//                   </div>
//                   <div className="view-details-row">
//                     <span className="detail-label">Current Company:</span>
//                     <span className="detail-value">{viewingCandidate.currentCompany || "-"}</span>
//                   </div>
//                   <div className="view-details-row">
//                     <span className="detail-label">Notice Period:</span>
//                     <span className="detail-value">{viewingCandidate.noticePeriod || "-"}</span>
//                   </div>
//                 </div>

//                 <div className="view-details-section">
//                   <h4>Salary Information</h4>
//                   <div className="view-details-row">
//                     <span className="detail-label">Current Salary:</span>
//                     <span className="detail-value">{formatCurrency(viewingCandidate.currentSalary)}</span>
//                   </div>
//                   <div className="view-details-row">
//                     <span className="detail-label">Expected Salary:</span>
//                     <span className="detail-value">{formatCurrency(viewingCandidate.expectedSalary)}</span>
//                   </div>
//                 </div>

//                 <div className="view-details-section full-width">
//                   <h4>Skills</h4>
//                   <div className="skills-container">
//                     {(viewingCandidate.skills || "")
//                       .split(",")
//                       .map(s => s.trim())
//                       .filter(Boolean)
//                       .map((skill, index) => (
//                         <span key={index} className="skill-tag large">
//                           {skill}
//                         </span>
//                       ))}
//                     {!viewingCandidate.skills && <span className="detail-value">No skills added</span>}
//                   </div>
//                 </div>

//                 <div className="view-details-section full-width">
//                   <h4>Additional Information</h4>
//                   <div className="view-details-row">
//                     <span className="detail-label">Resume URL:</span>
//                     <span className="detail-value">
//                       {viewingCandidate.resumeUrl ? (
//                         <a href={viewingCandidate.resumeUrl} target="_blank" rel="noopener noreferrer">
//                           View Resume ↗
//                         </a>
//                       ) : "-"}
//                     </span>
//                   </div>
//                   <div className="view-details-row">
//                     <span className="detail-label">Created Date:</span>
//                     <span className="detail-value">{formatDate(viewingCandidate.createdDate)}</span>
//                   </div>
//                 </div>
//               </div>
//             </div>

//             <div className="modal-footer">
//               <button
//                 type="button"
//                 className="btn-secondary"
//                 onClick={() => {
//                   setViewingCandidate(null);
//                   setShowViewModal(false);
//                 }}
//               >
//                 Close
//               </button>
              
//               {isAdmin && (
//                 <button
//                   type="button"
//                   className="btn-primary"
//                   onClick={() => {
//                     setViewingCandidate(null);
//                     setShowViewModal(false);
//                     handleEdit(viewingCandidate);
//                   }}
//                 >
//                   Edit Candidate
//                 </button>
//               )}
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Add/Edit Modal */}
//       {showModal && (
//         <div className="modal-overlay">
//           <div className="modal-content modal-lg">
//             <div className="modal-header">
//               <h2>
//                 {editingCandidate ? "Edit Candidate" : "Add New Candidate"}
//               </h2>
//               <button
//                 className="modal-close"
//                 onClick={() => {
//                   resetForm();
//                   setShowModal(false);
//                 }}
//               >
//                 ×
//               </button>
//             </div>

//             <form onSubmit={handleSubmit}>
//               <div className="modal-body">
//                 <div className="form-grid">
//                   <div className="form-group">
//                     <label>Full Name *</label>
//                     <input
//                       type="text"
//                       name="name"
//                       value={formData.name}
//                       onChange={handleInputChange}
//                       className={`form-input ${formErrors.name ? 'error' : ''}`}
//                       placeholder="John Doe"
//                     />
//                     {formErrors.name && <span className="error-message">{formErrors.name}</span>}
//                   </div>

//                   <div className="form-group">
//                     <label>Email *</label>
//                     <input
//                       type="email"
//                       name="email"
//                       value={formData.email}
//                       onChange={handleInputChange}
//                       className={`form-input ${formErrors.email ? 'error' : ''}`}
//                       placeholder="john@example.com"
//                     />
//                     {formErrors.email && <span className="error-message">{formErrors.email}</span>}
//                   </div>

//                   <div className="form-group">
//                     <label>Primary Phone</label>
//                     <input
//                       type="tel"
//                       name="phone"
//                       value={formData.phone}
//                       onChange={handleInputChange}
//                       className={`form-input ${formErrors.phone ? 'error' : ''}`}
//                       placeholder="+1 234 567 890"
//                     />
//                     {formErrors.phone && <span className="error-message">{formErrors.phone}</span>}
//                   </div>

//                   <div className="form-group">
//                     <label>Alternate Phone</label>
//                     <input
//                       type="tel"
//                       name="alternatePhone"
//                       value={formData.alternatePhone}
//                       onChange={handleInputChange}
//                       className="form-input"
//                       placeholder="+1 234 567 891"
//                     />
//                   </div>

//                   <div className="form-group">
//                     <label>Qualification</label>
//                     <input
//                       type="text"
//                       name="qualification"
//                       value={formData.qualification}
//                       onChange={handleInputChange}
//                       className="form-input"
//                       placeholder="e.g., B.Tech, MCA, MBA"
//                     />
//                   </div>

//                   <div className="form-group">
//                     <label>Branch *</label>
//                     <select
//                       name="branch"
//                       value={formData.branch}
//                       onChange={handleInputChange}
//                       className="form-select"
//                     >
//                       <option value="Ankleshwar">Ankleshwar</option>
//                       <option value="Bharuch">Bharuch</option>
//                     </select>
//                   </div>

//                   <div className="form-group">
//                     <label>Experience *</label>
//                     <select
//                       name="experience"
//                       value={formData.experience}
//                       onChange={handleInputChange}
//                       className={`form-select ${formErrors.experience ? 'error' : ''}`}
//                     >
//                       <option value="">Select Experience</option>
//                       <option value="Fresher">Fresher</option>
//                       <option value="1-2 years">1-2 years</option>
//                       <option value="3-5 years">3-5 years</option>
//                       <option value="5-8 years">5-8 years</option>
//                       <option value="8+ years">8+ years</option>
//                     </select>
//                     {formErrors.experience && <span className="error-message">{formErrors.experience}</span>}
//                   </div>

//                   <div className="form-group">
//                     <label>Current Company</label>
//                     <input
//                       type="text"
//                       name="currentCompany"
//                       value={formData.currentCompany}
//                       onChange={handleInputChange}
//                       className="form-input"
//                       placeholder="Current Company"
//                     />
//                   </div>

//                   <div className="form-group">
//                     <label>Current Salary (LPA)</label>
//                     <input
//                       type="text"
//                       name="currentSalary"
//                       value={formData.currentSalary}
//                       onChange={handleInputChange}
//                       className="form-input"
//                       placeholder="e.g., 12"
//                     />
//                   </div>

//                   <div className="form-group">
//                     <label>Expected Salary (LPA)</label>
//                     <input
//                       type="text"
//                       name="expectedSalary"
//                       value={formData.expectedSalary}
//                       onChange={handleInputChange}
//                       className="form-input"
//                       placeholder="e.g., 15"
//                     />
//                   </div>

//                   <div className="form-group">
//                     <label>Notice Period</label>
//                     <select
//                       name="noticePeriod"
//                       value={formData.noticePeriod}
//                       onChange={handleInputChange}
//                       className="form-select"
//                     >
//                       <option value="">Select Notice Period</option>
//                       <option value="Immediate">Immediate</option>
//                       <option value="15 days">15 days</option>
//                       <option value="30 days">30 days</option>
//                       <option value="45 days">45 days</option>
//                       <option value="60 days">60 days</option>
//                       <option value="90 days">90 days</option>
//                     </select>
//                   </div>

//                   <div className="form-group">
//                     <label>Location</label>
//                     <input
//                       type="text"
//                       name="location"
//                       value={formData.location}
//                       onChange={handleInputChange}
//                       className="form-input"
//                       placeholder="City, Country"
//                     />
//                   </div>

//                   <div className="form-group">
//                     <label>Status</label>
//                     <select
//                       name="status"
//                       value={formData.status}
//                       onChange={handleInputChange}
//                       className="form-select"
//                     >
//                       <option value="Active">Active</option>
//                       <option value="Inactive">Inactive</option>
//                       <option value="Placed">Placed</option>
//                     </select>
//                   </div>

//                   <div className="form-group">
//                     <label>Registration Status</label>
//                     <select
//                       name="registrationStatus"
//                       value={formData.registrationStatus}
//                       onChange={handleInputChange}
//                       className="form-select"
//                     >
//                       <option value="">Select Registration Status</option>
//                       <option value="Registered">Registered</option>
//                       <option value="Unregistered">Unregistered</option>
//                     </select>
//                     <span className="form-hint">
//                       If not selected, "Unregistered" will be saved by default
//                     </span>
//                   </div>

//                   {editingCandidate && (
//                     <div className="form-group">
//                       <label>Created Date</label>
//                       <input
//                         type="datetime-local"
//                         name="createdDate"
//                         value={formData.createdDate}
//                         onChange={handleInputChange}
//                         className="form-input"
//                       />
//                     </div>
//                   )}
//                 </div>

//                 {/* REMOVED: Skills required asterisk and made it optional */}
//                 <div className="form-group">
//                   <label>Skills (Optional)</label>
//                   <textarea
//                     name="skills"
//                     value={formData.skills}
//                     onChange={handleInputChange}
//                     className="form-textarea"
//                     placeholder="React, JavaScript, Node.js (comma separated)"
//                     rows="3"
//                   />
//                   <span className="form-hint">
//                     Enter skills separated by commas (optional)
//                   </span>
//                 </div>

//                 <div className="form-group">
//                   <label>Resume URL</label>
//                   <input
//                     type="url"
//                     name="resumeUrl"
//                     value={formData.resumeUrl}
//                     onChange={handleInputChange}
//                     className="form-input"
//                     placeholder="https://example.com/resume.pdf"
//                   />
//                 </div>
//               </div>

//               <div className="modal-footer">
//                 <button
//                   type="button"
//                   className="btn-secondary"
//                   onClick={() => {
//                     resetForm();
//                     setShowModal(false);
//                   }}
//                 >
//                   Cancel
//                 </button>
//                 <button type="submit" className="btn-primary">
//                   {editingCandidate ? "Update Candidate" : "Save Candidate"}
//                 </button>
//               </div>
//             </form>
//           </div>
//         </div>
//       )}

//       {/* Excel Import Modal */}
//       {showImportModal && (
//         <div className="modal-overlay">
//           <div className="modal-content modal-lg">
//             <div className="modal-header">
//               <h2>Import Candidates from Excel</h2>
//               <button
//                 className="modal-close"
//                 onClick={() => {
//                   resetImport();
//                   setShowImportModal(false);
//                 }}
//               >
//                 ×
//               </button>
//             </div>

//             <div className="modal-body">
//               {importStep === 'upload' && (
//                 <div className="import-upload-section">
//                   <div className="import-instructions">
//                     <h3>Instructions:</h3>
//                     <ul>
//                       <li>Download the template file first</li>
//                       <li>Fill in your candidate data</li>
//                       <li>Required columns: Name, Email, Experience</li>
//                       <li>Skills column is optional</li>
//                       <li>Branch must be either "Ankleshwar" or "Bharuch"</li>
//                       <li>Registration Status: Leave empty to default to "Unregistered"</li>
//                       <li>Upload the filled Excel file (.xlsx, .xls)</li>
//                     </ul>
//                   </div>

//                   <div className="import-actions">
//                     <button
//                       onClick={downloadTemplate}
//                       className="btn-secondary"
//                     >
//                       📥 Download Template
//                     </button>
                    
//                     <div className="file-upload-area">
//                       <input
//                         type="file"
//                         ref={fileInputRef}
//                         accept=".xlsx,.xls,.csv"
//                         onChange={handleFileUpload}
//                         className="file-input"
//                         id="excel-upload"
//                       />
//                       <label htmlFor="excel-upload" className="file-upload-label">
//                         {importLoading ? 'Processing...' : 'Choose Excel File'}
//                       </label>
//                     </div>
//                   </div>

//                   {importLoading && (
//                     <div className="import-loading">
//                       <div className="spinner-small"></div>
//                       <p>Processing file...</p>
//                     </div>
//                   )}
//                 </div>
//               )}

//               {importStep === 'preview' && (
//                 <div className="import-preview-section">
//                   <div className="import-summary">
//                     <h3>Import Summary</h3>
//                     <div className="summary-stats">
//                       <div className="stat-item success">
//                         <span className="stat-value">{importData.length}</span>
//                         <span className="stat-label">Valid Records</span>
//                       </div>
//                       <div className="stat-item error">
//                         <span className="stat-value">{importErrors.length}</span>
//                         <span className="stat-label">Errors</span>
//                       </div>
//                     </div>
//                   </div>

//                   {importErrors.length > 0 && (
//                     <div className="import-errors">
//                       <h4>Errors Found:</h4>
//                       <div className="errors-list">
//                         {importErrors.map((error, idx) => (
//                           <div key={idx} className="error-item">
//                             <strong>Row {error.row}:</strong> {error.name} - {error.errors.join(', ')}
//                           </div>
//                         ))}
//                       </div>
//                     </div>
//                   )}

//                   {importData.length > 0 && (
//                     <div className="import-preview">
//                       <h4>Preview (First 5 Records)</h4>
//                       <div className="preview-table-container">
//                         <table className="preview-table">
//                           <thead>
//                             <tr>
//                               <th>Name</th>
//                               <th>Email</th>
//                               <th>Qualification</th>
//                               <th>Branch</th>
//                               <th>Skills</th>
//                               <th>Experience</th>
//                               <th>Status</th>
//                               <th>Registration Status</th>
//                             </tr>
//                           </thead>
//                           <tbody>
//                             {importData.slice(0, 5).map((candidate, idx) => (
//                               <tr key={idx}>
//                                 <td>{candidate.name}</td>
//                                 <td>{candidate.email}</td>
//                                 <td>{candidate.qualification || '-'}</td>
//                                 <td>
//                                   <span className={`branch-badge ${candidate.branch?.toLowerCase()}`}>
//                                     {candidate.branch}
//                                   </span>
//                                 </td>
//                                 <td>{candidate.skills || '-'}</td>
//                                 <td>{candidate.experience}</td>
//                                 <td>
//                                   <span className={`status-badge ${candidate.status.toLowerCase()}`}>
//                                     {candidate.status}
//                                   </span>
//                                 </td>
//                                 <td>
//                                   <span className={`registration-badge ${(candidate.registrationStatus || 'unregistered').toLowerCase()}`}>
//                                     {candidate.registrationStatus || 'Unregistered'}
//                                   </span>
//                                 </td>
//                               </tr>
//                             ))}
//                           </tbody>
//                         </table>
//                       </div>
//                     </div>
//                   )}
//                 </div>
//               )}

//               {importStep === 'complete' && (
//                 <div className="import-complete">
//                   <div className="success-icon">✅</div>
//                   <h3>Import Successful!</h3>
//                   <p>{importData.length} candidates have been added.</p>
//                 </div>
//               )}
//             </div>

//             {importStep === 'preview' && (
//               <div className="modal-footer">
//                 <button
//                   type="button"
//                   className="btn-secondary"
//                   onClick={resetImport}
//                 >
//                   Back
//                 </button>
//                 <button
//                   type="button"
//                   className="btn-primary"
//                   onClick={handleImportConfirm}
//                   disabled={importData.length === 0 || importLoading}
//                 >
//                   {importLoading ? 'Importing...' : `Import ${importData.length} Candidates`}
//                 </button>
//               </div>
//             )}
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default Candidates;








// import React, { useState, useEffect, useRef } from "react";
// import * as XLSX from "xlsx";

// import { getCandidates, createCandidate, updateCandidate, deleteCandidate } from "../../services/api";

// import { useAuth } from "../../contexts/AuthContext";

// import "./Candidates.css";

// const Candidates = () => {
//   // Get current user from AuthContext
//   const { currentUser } = useAuth();
  
//   const [candidates, setCandidates] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [showModal, setShowModal] = useState(false);
//   const [showViewModal, setShowViewModal] = useState(false);
//   const [viewingCandidate, setViewingCandidate] = useState(null);
//   const [editingCandidate, setEditingCandidate] = useState(null);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [filterSkills, setFilterSkills] = useState("all");
//   const [filterExperience, setFilterExperience] = useState("all");
//   const [filterStatus, setFilterStatus] = useState("all");
//   const [filterRegistration, setFilterRegistration] = useState("all");
//   const [filterQualification, setFilterQualification] = useState("all");
//   const [filterBranch, setFilterBranch] = useState("all");
//   const [sortOrder, setSortOrder] = useState("newest");
//   const [formErrors, setFormErrors] = useState({});
//   const [isHeaderScrolled, setIsHeaderScrolled] = useState(false);
  
//   // Pagination states
//   const [currentPage, setCurrentPage] = useState(1);
//   const [itemsPerPage, setItemsPerPage] = useState(10);
//   const [itemsPerPageOptions] = useState([5, 10, 25, 50, 100]);
  
//   // Excel import states
//   const [showImportModal, setShowImportModal] = useState(false);
//   const [importData, setImportData] = useState([]);
//   const [importErrors, setImportErrors] = useState([]);
//   const [importLoading, setImportLoading] = useState(false);
//   const [importStep, setImportStep] = useState('upload');
//   const fileInputRef = useRef(null);
//   const headerRef = useRef(null);

//   // Check if user is admin
//   const isAdmin = currentUser && currentUser.role === "admin";

//   // Qualification options
//   const qualificationOptions = [
//   // ===== SCHOOL EDUCATION =====
//   "SSC (10th Pass)",
//   "HSC (12th Science)",
//   "HSC (12th Commerce)",
//   "HSC (12th Arts)",

//   // ===== ITI (Industrial Training Institute) =====
//   "ITI AOCP Certification",
//   "ITI - Fitter",
//   "ITI - Electrician",
//   "ITI - Welder",
//   "ITI - Turner",
//   "ITI - Machinist",
//   "ITI - Instrument Mechanic",
//   "ITI - Draughtsman (Mechanical)",
//   "ITI - Draughtsman (Civil)",
//   "ITI - Diesel Mechanic",
//   "ITI - Motor Mechanic",
//   "ITI - Refrigeration & Air Conditioning",
//   "ITI - Plumber",
//   "ITI - COPA (Computer Operator & Programming Assistant)",
//   "ITI - RFM (Refinery & Maintenance Mechanic)",
//   "ITI - Pump Operator",
//   "ITI - Boiler Attendant",
//   "ITI - Fire & Safety",

//   // ===== DIPLOMA =====
//   "Diploma - Mechanical Engineering",
//   "Diploma - Electrical Engineering",
//   "Diploma - Chemical Engineering",
//   "Diploma - Instrumentation",
//   "Diploma - Civil Engineering",
//   "Diploma - Automobile Engineering",
//   "Diploma - Production Engineering",
//   "Diploma - Plastic Technology",
//   "Diploma - Petrochemical Engineering",
//   "Diploma - Industrial Safety",

//   // ===== ENGINEERING (BE / B.Tech) =====
//   "B.E. - Mechanical Engineering",
//   "B.E. - Electrical Engineering",
//   "B.E. - Chemical Engineering",
//   "B.E. - Instrumentation Engineering",
//   "B.E. - Civil Engineering",
//   "B.E. - Automobile Engineering",
//   "B.E. - Production Engineering",
//   "B.E. - Petrochemical Engineering",

//   // ===== SCIENCE GRADUATION =====
//   "B.Sc - Chemistry",
//   "B.Sc - Physics",
//   "B.Sc - Mathematics",
//   "B.Sc - Industrial Chemistry",
//   "B.Sc - Environmental Science",
//   "B.Sc - Microbiology",

//   // ===== COMMERCE & MANAGEMENT =====
//   "B.Com (Bachelor of Commerce)",
//   "BBA (Bachelor of Business Administration)",
//   "MBA - Human Resources",
//   "MBA - Marketing",
//   "MBA - Finance",
//   "MBA - Operations",

//   // ===== COMPUTER / IT =====
//   "BCA (Bachelor of Computer Applications)",
//   "MCA (Master of Computer Applications)",
//   "Diploma - Computer Applications",

//   // ===== POST GRADUATION (TECHNICAL) =====
//   "M.Tech - Mechanical Engineering",
//   "M.Tech - Chemical Engineering",
//   "M.Tech - Electrical Engineering",
//   "M.Tech - Instrumentation Engineering",
//   "M.Sc - Chemistry",
//   "M.Sc - Environmental Science",

//   // ===== SAFETY & PROFESSIONAL =====
//   "PDIS (Professional Diploma in Industrial Safety)",
//   "ADIS (Advanced Diploma in Industrial Safety)",
//   "NEBOSH - IGC",
//   "NEBOSH - Diploma",
//   "IOSH Certification",
//   "Diploma - Fire & Safety",
//   "Industrial Safety Certification",

//   // ===== SPECIALIZED / INDUSTRIAL CERTIFICATIONS =====
//   "LACP Certification",
  
//   "Boiler Operation Certificate",
//   "First Aid Certification",
//   "Quality Control Certification",
//   "NDT Level II",
//   "NDT Level III",

//   // ===== OTHERS =====
//   "PhD (Doctor of Philosophy)",
//   "Other"
// ];

//   // Experience options from Fresher to 15 years
//   const experienceOptions = [
//     "Fresher",
//     "1 year",
//     "2 years",
//     "3 years",
//     "4 years",
//     "5 years",
//     "6 years",
//     "7 years",
//     "8 years",
//     "9 years",
//     "10 years",
//     "11 years",
//     "12 years",
//     "13 years",
//     "14 years",
//     "15 years"
//   ];

//   const [formData, setFormData] = useState({
//     name: "",
//     email: "",
//     phone: "",
//     alternatePhone: "",
//     skills: "",
//     experience: "",
//     qualification: "",
//     branch: "Ankleshwar",
//     currentCompany: "",
//     currentSalary: "",
//     expectedSalary: "",
//     noticePeriod: "",
//     location: "",
//     resumeUrl: "",
//     status: "Active",
//     registrationStatus: "",
//     createdDate: new Date().toISOString().split('T')[0],
//   });

//   useEffect(() => {
//     loadCandidates();
    
//     const handleScroll = () => {
//       if (headerRef.current) {
//         const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
//         setIsHeaderScrolled(scrollTop > 50);
//       }
//     };

//     window.addEventListener('scroll', handleScroll);
//     return () => window.removeEventListener('scroll', handleScroll);
//   }, []);

//   // Reset to first page when filters change
//   useEffect(() => {
//     setCurrentPage(1);
//   }, [searchTerm, filterSkills, filterExperience, filterStatus, 
//       filterRegistration, filterQualification, filterBranch, sortOrder]);

//   const loadCandidates = async () => {
//     setLoading(true);

//     try {
//       const res = await getCandidates();
//       const normalizedCandidates = res.data.map(candidate => ({
//         ...candidate,
//         registrationStatus: candidate.registrationStatus || "Unregistered"
//       }));
//       setCandidates(normalizedCandidates);
//     } catch (error) {
//       console.error(error);
//     }

//     setLoading(false);
//   };

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({ ...prev, [name]: value }));
//     // Clear error for this field when user starts typing
//     if (formErrors[name]) {
//       setFormErrors(prev => ({ ...prev, [name]: "" }));
//     }
//   };

//   // Validation function - only called on submit
//   const validateForm = () => {
//     const errors = {};
    
//     // Name validation
//     if (!formData.name || formData.name.trim() === "") {
//       errors.name = "Name is required";
//     }
    
//     // Email validation
//     if (!formData.email || formData.email.trim() === "") {
//       errors.email = "Email is required";
//     } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
//       errors.email = "Email is invalid";
//     }
    
//     // Experience validation
//     if (!formData.experience || formData.experience === "") {
//       errors.experience = "Experience is required";
//     }
    
//     // Qualification validation
//     if (!formData.qualification || formData.qualification === "") {
//       errors.qualification = "Qualification is required";
//     }
    
//     // Phone validation (optional but validate if provided)
//     if (formData.phone && !/^[\d\s\+\-\(\)]{10,}$/.test(formData.phone)) {
//       errors.phone = "Please enter a valid phone number";
//     }

//     setFormErrors(errors);
//     return Object.keys(errors).length === 0;
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     // Validate form - errors will show only after this
//     if (!validateForm()) {
//       return;
//     }

//     const candidateData = {
//       ...formData,
//       registrationStatus: formData.registrationStatus || "Unregistered",
//       id: editingCandidate ? editingCandidate.id : Date.now().toString(),
//       createdDate: editingCandidate ? formData.createdDate : new Date().toISOString(),
//       skills: formData.skills ? formData.skills.split(',').map(s => s.trim()).filter(Boolean).join(', ') : "",
//     };

//     if (editingCandidate) {
//       await updateCandidate(editingCandidate.id, candidateData);
//     } else {
//       await createCandidate(candidateData);
//     }

//     resetForm();
//     loadCandidates();
//     setShowModal(false);
//   };

//   const handleView = (candidate) => {
//     setViewingCandidate(candidate);
//     setShowViewModal(true);
//   };

//   const handleEdit = (candidate) => {
//     if (!isAdmin) {
//       alert("You don't have permission to edit candidates");
//       return;
//     }
//     setEditingCandidate(candidate);
//     setFormData({
//       ...candidate,
//       skills: candidate.skills || "",
//     });
//     setShowModal(true);
//   };

//   const handleDelete = async (id) => {
//     if (!isAdmin) {
//       alert("You don't have permission to delete candidates");
//       return;
//     }
//     if (window.confirm("Are you sure you want to delete this candidate?")) {
//       await deleteCandidate(id);
//       loadCandidates();
//     }
//   };

//   const resetForm = () => {
//     setFormData({
//       name: "",
//       email: "",
//       phone: "",
//       alternatePhone: "",
//       skills: "",
//       experience: "",
//       qualification: "",
//       branch: "Ankleshwar",
//       currentCompany: "",
//       currentSalary: "",
//       expectedSalary: "",
//       noticePeriod: "",
//       location: "",
//       resumeUrl: "",
//       status: "Active",
//       registrationStatus: "",
//       createdDate: new Date().toISOString().split('T')[0],
//     });
//     setEditingCandidate(null);
//     setFormErrors({}); // Clear all errors on reset
//   };

//   // ===== EXCEL IMPORT FUNCTIONS =====
  
//   const handleFileUpload = (e) => {
//     const file = e.target.files[0];
//     if (!file) return;

//     setImportLoading(true);
//     setImportErrors([]);

//     const reader = new FileReader();
//     reader.onload = (event) => {
//       try {
//         const data = new Uint8Array(event.target.result);
//         const workbook = XLSX.read(data, { type: 'array' });
        
//         const sheetName = workbook.SheetNames[0];
//         const worksheet = workbook.Sheets[sheetName];
        
//         const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
        
//         const parsedData = parseExcelData(jsonData);
//         setImportData(parsedData.validData);
//         setImportErrors(parsedData.errors);
        
//         if (parsedData.validData.length > 0) {
//           setImportStep('preview');
//         }
//       } catch (error) {
//         setImportErrors([{ row: 0, error: 'Failed to parse Excel file: ' + error.message }]);
//       } finally {
//         setImportLoading(false);
//       }
//     };
    
//     reader.readAsArrayBuffer(file);
//   };

//   const parseExcelData = (rows) => {
//     if (rows.length < 2) {
//       return { validData: [], errors: [{ row: 0, error: 'File is empty or has no data rows' }] };
//     }

//     const headers = rows[0].map(h => String(h || '').toLowerCase().trim());
    
//     const fieldMap = {
//       name: findColumnIndex(headers, ['name', 'full name', 'candidate name']),
//       email: findColumnIndex(headers, ['email', 'e-mail', 'email address']),
//       phone: findColumnIndex(headers, ['phone', 'mobile', 'contact', 'phone number']),
//       alternatePhone: findColumnIndex(headers, ['alternate phone', 'alt phone', 'secondary phone']),
//       skills: findColumnIndex(headers, ['skills', 'skill', 'technologies']),
//       experience: findColumnIndex(headers, ['experience', 'exp', 'total experience', 'years']),
//       qualification: findColumnIndex(headers, ['qualification', 'education', 'degree']),
//       branch: findColumnIndex(headers, ['branch', 'location branch', 'office']),
//       currentCompany: findColumnIndex(headers, ['current company', 'company', 'employer']),
//       currentSalary: findColumnIndex(headers, ['current salary', 'current ctc', 'salary']),
//       expectedSalary: findColumnIndex(headers, ['expected salary', 'expected ctc', 'expectation']),
//       noticePeriod: findColumnIndex(headers, ['notice period', 'notice', 'np']),
//       location: findColumnIndex(headers, ['location', 'city', 'place']),
//       status: findColumnIndex(headers, ['status']),
//       registrationStatus: findColumnIndex(headers, ['registration status', 'registration', 'reg status'])
//     };

//     const validData = [];
//     const errors = [];

//     for (let i = 1; i < rows.length; i++) {
//       const row = rows[i];
//       if (!row || row.length === 0 || row.every(cell => !cell)) continue;

//       const branchValue = getCellValue(row, fieldMap.branch);
//       const validBranch = branchValue && ['Ankleshwar', 'Bharuch'].includes(branchValue) 
//         ? branchValue 
//         : 'Ankleshwar';

//       const registrationStatusValue = getCellValue(row, fieldMap.registrationStatus);
      
//       const candidate = {
//         id: Date.now().toString() + i,
//         createdDate: new Date().toISOString(),
//         name: getCellValue(row, fieldMap.name) || '',
//         email: getCellValue(row, fieldMap.email) || '',
//         phone: getCellValue(row, fieldMap.phone) || '',
//         alternatePhone: getCellValue(row, fieldMap.alternatePhone) || '',
//         skills: getCellValue(row, fieldMap.skills) || '',
//         experience: getCellValue(row, fieldMap.experience) || '',
//         qualification: getCellValue(row, fieldMap.qualification) || '',
//         branch: validBranch,
//         currentCompany: getCellValue(row, fieldMap.currentCompany) || '',
//         currentSalary: getCellValue(row, fieldMap.currentSalary) || '',
//         expectedSalary: getCellValue(row, fieldMap.expectedSalary) || '',
//         noticePeriod: getCellValue(row, fieldMap.noticePeriod) || '',
//         location: getCellValue(row, fieldMap.location) || '',
//         status: mapStatus(getCellValue(row, fieldMap.status)) || 'Active',
//         registrationStatus: mapRegistrationStatus(registrationStatusValue) || "Unregistered"
//       };

//       const rowErrors = [];
//       if (!candidate.name) rowErrors.push('Name is required');
//       if (!candidate.email) rowErrors.push('Email is required');
//       else if (!/\S+@\S+\.\S+/.test(candidate.email)) rowErrors.push('Invalid email format');
//       if (!candidate.experience) rowErrors.push('Experience is required');
//       if (!candidate.qualification) rowErrors.push('Qualification is required');

//       if (rowErrors.length > 0) {
//         errors.push({
//           row: i + 1,
//           name: candidate.name || 'Unknown',
//           errors: rowErrors
//         });
//       } else {
//         validData.push(candidate);
//       }
//     }

//     return { validData, errors };
//   };

//   const findColumnIndex = (headers, possibleNames) => {
//     for (let i = 0; i < headers.length; i++) {
//       if (possibleNames.some(name => headers[i].includes(name))) {
//         return i;
//       }
//     }
//     return -1;
//   };

//   const getCellValue = (row, index) => {
//     if (index === -1 || index >= row.length) return '';
//     const value = row[index];
//     return value !== undefined && value !== null ? String(value).trim() : '';
//   };

//   const mapStatus = (value) => {
//     if (!value) return 'Active';
//     const status = value.toLowerCase();
//     if (status.includes('inactive')) return 'Inactive';
//     if (status.includes('placed')) return 'Placed';
//     return 'Active';
//   };

//   const mapRegistrationStatus = (value) => {
//     if (!value) return '';
//     const reg = value.toLowerCase();
//     if (reg.includes('unreg')) return 'Unregistered';
//     if (reg.includes('reg')) return 'Registered';
//     return '';
//   };

//   const handleImportConfirm = async () => {
//     setImportLoading(true);

//     try {
//       for (const candidate of importData) {
//         const candidateToSave = {
//           ...candidate,
//           registrationStatus: candidate.registrationStatus || "Unregistered"
//         };
//         await createCandidate(candidateToSave);
//       }

//       loadCandidates();
//       setImportStep('complete');

//       setTimeout(() => {
//         resetImport();
//         setShowImportModal(false);
//       }, 2000);

//     } catch (error) {
//       setImportErrors([{ row: 0, error: 'Failed to save candidates: ' + error.message }]);
//     }

//     setImportLoading(false);
//   };

//   const resetImport = () => {
//     setImportData([]);
//     setImportErrors([]);
//     setImportStep('upload');
//     if (fileInputRef.current) {
//       fileInputRef.current.value = '';
//     }
//   };

//   const downloadTemplate = () => {
//     const template = [
//       ['Name', 'Email', 'Phone', 'Alternate Phone', 'Skills', 'Experience', 'Qualification', 'Branch', 'Current Company', 'Current Salary', 'Expected Salary', 'Notice Period', 'Location', 'Status', 'Registration Status'],
//       ['John Doe', 'john@example.com', '+1234567890', '+1234567891', 'React, JavaScript, Node.js', '3 years', 'B.Tech/B.E', 'Ankleshwar', 'Tech Corp', '12', '15', '30 days', 'New York', 'Active', 'Registered'],
//       ['Jane Smith', 'jane@example.com', '+1234567892', '', '', '5 years', 'MCA', 'Bharuch', 'Data Inc', '18', '22', '45 days', 'San Francisco', 'Active', '']
//     ];

//     const wb = XLSX.utils.book_new();
//     const ws = XLSX.utils.aoa_to_sheet(template);
//     XLSX.utils.book_append_sheet(wb, ws, 'Template');
//     XLSX.writeFile(wb, 'candidates_template.xlsx');
//   };

//   // Filter and sort candidates
//   const filteredCandidates = candidates
//     .filter((candidate) => {
//       const search = searchTerm.toLowerCase();
//       const name = candidate.name?.toLowerCase() || "";
//       const email = candidate.email?.toLowerCase() || "";
//       const skills = candidate.skills?.toLowerCase() || "";
//       const company = candidate.currentCompany?.toLowerCase() || "";
//       const qualification = candidate.qualification?.toLowerCase() || "";

//       const matchesSearch = !searchTerm || 
//         name.includes(search) ||
//         email.includes(search) ||
//         skills.includes(search) ||
//         company.includes(search) ||
//         qualification.includes(search);

//       const matchesSkills = filterSkills === "all" || 
//         (candidate.skills?.toLowerCase() || "").includes(filterSkills.toLowerCase());

//       const matchesExperience = filterExperience === "all" || 
//         candidate.experience === filterExperience;

//       const normalize = (val) => (val || "").toLowerCase().trim();

//       const matchesStatus =
//         filterStatus === "all" ||
//         normalize(candidate.status) === normalize(filterStatus);

//       let matchesRegistration = true;
//       if (filterRegistration !== "all") {
//         const candidateRegStatus = candidate.registrationStatus || "Unregistered";
//         matchesRegistration = normalize(candidateRegStatus) === normalize(filterRegistration);
//       }

//       const matchesQualification = filterQualification === "all" || 
//         candidate.qualification === filterQualification;

//       const matchesBranch = filterBranch === "all" || 
//         candidate.branch === filterBranch;

//       return matchesSearch && matchesSkills && matchesExperience && 
//              matchesStatus && matchesRegistration && 
//              matchesQualification && matchesBranch;
//     })
//     .sort((a, b) => {
//       const dateA = new Date(a.createdDate);
//       const dateB = new Date(b.createdDate);
//       const timeA = isNaN(dateA.getTime()) ? 0 : dateA.getTime();
//       const timeB = isNaN(dateB.getTime()) ? 0 : dateB.getTime();
//       return sortOrder === "newest" ? timeB - timeA : timeA - timeB;
//     });

//   // Pagination logic
//   const indexOfLastItem = currentPage * itemsPerPage;
//   const indexOfFirstItem = indexOfLastItem - itemsPerPage;
//   const currentItems = filteredCandidates.slice(indexOfFirstItem, indexOfLastItem);
//   const totalPages = Math.ceil(filteredCandidates.length / itemsPerPage);

//   const paginate = (pageNumber) => setCurrentPage(pageNumber);
  
//   const goToPreviousPage = () => {
//     if (currentPage > 1) {
//       setCurrentPage(currentPage - 1);
//     }
//   };
  
//   const goToNextPage = () => {
//     if (currentPage < totalPages) {
//       setCurrentPage(currentPage + 1);
//     }
//   };
  
//   const handleItemsPerPageChange = (e) => {
//     setItemsPerPage(Number(e.target.value));
//     setCurrentPage(1);
//   };

//   const allSkills = [
//     ...new Set(
//       candidates.flatMap((c) =>
//         (c.skills || "")
//           .split(",")
//           .map((s) => s.trim())
//           .filter(Boolean)
//       )
//     ),
//   ];

//   const allQualifications = [
//     ...new Set(candidates.map((c) => c.qualification).filter(Boolean)),
//   ];

//   const experienceLevels = [
//     ...new Set(candidates.map((c) => c.experience).filter(Boolean)),
//   ];

//   const activeCandidates = candidates.filter(
//     (c) => c.status === "Active"
//   ).length;
  
//   const registeredCandidates = candidates.filter(
//     (c) => (c.registrationStatus || "Unregistered") === "Registered"
//   ).length;

//   const ankleshwarCandidates = candidates.filter(
//     (c) => c.branch === "Ankleshwar"
//   ).length;

//   const bharuchCandidates = candidates.filter(
//     (c) => c.branch === "Bharuch"
//   ).length;

//   const getInitials = (name) => {
//     if (!name) return "?";
//     return name
//       .split(" ")
//       .map((n) => n[0])
//       .join("")
//       .toUpperCase()
//       .slice(0, 2);
//   };

//   const formatDate = (dateString) => {
//     if (!dateString) return "-";
//     try {
//       const date = new Date(dateString);
//       const options = { year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' };
//       return date.toLocaleDateString(undefined, options);
//     } catch (e) {
//       return dateString;
//     }
//   };

//   const formatCurrency = (value) => {
//     if (!value) return "-";
//     return `₹${value}`;
//   };

//   if (loading) {
//     return (
//       <div className="loading-container">
//         <div className="spinner"></div>
//         <p>Loading candidates...</p>
//       </div>
//     );
//   }

//   return (
//     <div className="candidates-page">
//       <div id="candidates-top"></div>

//       <div 
//         ref={headerRef}
//         className={`page-header ${isHeaderScrolled ? 'scrolled' : ''}`}
//       >
//         <div>
//           <h1>Candidates</h1>
//           <p>Manage candidate profiles and information</p>
//           {!isAdmin && (
//             <small style={{ color: '#666', fontSize: '12px' }}>View Only Mode</small>
//           )}
//         </div>
//         <div className="header-actions">
//           <button
//             onClick={() => setShowImportModal(true)}
//             className="btn-secondary"
//             title="Import from Excel"
//           >
//             📥 Import Excel
//           </button>
//           <button
//             onClick={() => setShowModal(true)}
//             className="btn-primary"
//           >
//             + Add Candidate
//           </button>
//         </div>
//       </div>

//       {/* Stats Cards */}
//       <div className="stats-cards">
//         <div className="stat-card">
//           <div className="stat-icon">👥</div>
//           <div className="stat-content">
//             <h3>{candidates.length}</h3>
//             <p>Total Candidates</p>
//           </div>
//         </div>
//         <div className="stat-card">
//           <div className="stat-icon">✅</div>
//           <div className="stat-content">
//             <h3>{activeCandidates}</h3>
//             <p>Active Candidates</p>
//           </div>
//         </div>
//         <div className="stat-card">
//           <div className="stat-icon">📝</div>
//           <div className="stat-content">
//             <h3>{registeredCandidates}</h3>
//             <p>Registered</p>
//           </div>
//         </div>
//         <div className="stat-card">
//           <div className="stat-icon">🏢</div>
//           <div className="stat-content">
//             <h3>{ankleshwarCandidates} | {bharuchCandidates}</h3>
//             <p>Ankleshwar | Bharuch</p>
//           </div>
//         </div>
//       </div>

//       {/* Filters */}
//       <div className="filters-section">
//         <div className="search-box">
//           <span className="search-icon">🔍</span>
//           <input
//             type="text"
//             placeholder="Search candidates..."
//             value={searchTerm}
//             onChange={(e) => setSearchTerm(e.target.value)}
//             className="search-input"
//           />
//         </div>

//         <div className="filter-controls">
//           <select
//             value={filterQualification}
//             onChange={(e) => setFilterQualification(e.target.value)}
//             className="filter-select"
//           >
//             <option value="all">All Qualifications</option>
//             {allQualifications.map((qual) => (
//               <option key={qual} value={qual}>
//                 {qual}
//               </option>
//             ))}
//           </select>

//           <select
//             value={filterBranch}
//             onChange={(e) => setFilterBranch(e.target.value)}
//             className="filter-select"
//           >
//             <option value="all">All Branches</option>
//             <option value="Ankleshwar">Ankleshwar</option>
//             <option value="Bharuch">Bharuch</option>
//           </select>

//           <select
//             value={filterSkills}
//             onChange={(e) => setFilterSkills(e.target.value)}
//             className="filter-select"
//           >
//             <option value="all">All Skills</option>
//             {allSkills.map((skill) => (
//               <option key={skill} value={skill}>
//                 {skill}
//               </option>
//             ))}
//           </select>

//           <select
//             value={filterExperience}
//             onChange={(e) => setFilterExperience(e.target.value)}
//             className="filter-select"
//           >
//             <option value="all">All Experience</option>
//             {experienceLevels.map((exp) => (
//               <option key={exp} value={exp}>
//                 {exp}
//               </option>
//             ))}
//           </select>

//           <select
//             value={filterStatus}
//             onChange={(e) => setFilterStatus(e.target.value)}
//             className="filter-select"
//           >
//             <option value="all">All Status</option>
//             <option value="Active">Active</option>
//             <option value="Inactive">Inactive</option>
//             <option value="Placed">Placed</option>
//           </select>

//           <select
//             value={filterRegistration}
//             onChange={(e) => setFilterRegistration(e.target.value)}
//             className="filter-select"
//           >
//             <option value="all">All Registration</option>
//             <option value="Registered">Registered</option>
//             <option value="Unregistered">Unregistered</option>
//           </select>

//           <select
//             value={sortOrder}
//             onChange={(e) => setSortOrder(e.target.value)}
//             className="filter-select"
//           >
//             <option value="newest">Newest First</option>
//             <option value="oldest">Oldest First</option>
//           </select>
//         </div>
//       </div>

//       {/* Table */}
//       <div className="table-container">
//         {filteredCandidates.length > 0 ? (
//           <>
//             <div className="table-responsive">
//               <table className="data-table">
//                 <thead>
//                   <tr>
//                     <th>Candidate</th>
//                     <th>Qualification</th>
//                     <th>Branch</th>
//                     <th>Skills & Experience</th>
//                     <th>Contact</th>
//                     <th>Salary</th>
//                     <th>Status</th>
//                     <th>Actions</th>
//                   </tr>
//                 </thead>

//                 <tbody>
//                   {currentItems.map((candidate) => (
//                     <tr key={candidate.id}>
//                       <td>
//                         <div className="candidate-cell">
//                           <div className="candidate-avatar">
//                             {getInitials(candidate.name)}
//                           </div>
//                           <div>
//                             <div className="candidate-name">
//                               {candidate.name || "N/A"}
//                             </div>
//                             <div className="candidate-company">
//                               {candidate.currentCompany || "Not Specified"}
//                             </div>
//                             <div className="candidate-meta">
//                               📅 {formatDate(candidate.createdDate)}
//                             </div>
//                           </div>
//                         </div>
//                       </td>
                      
//                       <td>
//                         <div className="qualification-cell">
//                           <span className="qualification-badge">
//                             {candidate.qualification || "-"}
//                           </span>
//                         </div>
//                       </td>
                      
//                       <td>
//                         <div className="branch-cell">
//                           <span className={`branch-badge ${candidate.branch?.toLowerCase() || ''}`}>
//                             {candidate.branch || "-"}
//                           </span>
//                         </div>
//                       </td>
                      
//                       <td>
//                         <div className="skills-experience-cell">
//                           <span className="experience-badge">
//                             {candidate.experience || "Exp N/A"}
//                           </span>
//                           <div className="skills-cell">
//                             {(candidate.skills || "")
//                               .split(",")
//                               .map(s => s.trim())
//                               .filter(Boolean)
//                               .slice(0, 2)
//                               .map((skill, i) => (
//                                 <span key={i} className="skill-tag">
//                                   {skill}
//                                 </span>
//                               ))}
//                             {(candidate.skills || "").split(",").filter(Boolean).length > 2 && (
//                               <span className="more-tag">
//                                 +{(candidate.skills || "").split(",").filter(Boolean).length - 2}
//                               </span>
//                             )}
//                             {!candidate.skills && <span className="no-skills">No skills</span>}
//                           </div>
//                         </div>
//                       </td>
                      
//                       <td>
//                         <div className="compact-contact">
//                           <a href={`mailto:${candidate.email}`} className="email-link" title={candidate.email}>
//                             {candidate.email?.length > 20 
//                               ? candidate.email.substring(0, 18) + "..." 
//                               : candidate.email || "-"}
//                           </a>
//                           {candidate.phone && (
//                             <div className="contact-phone" title={`Primary: ${candidate.phone}${candidate.alternatePhone ? `\nAlternate: ${candidate.alternatePhone}` : ''}`}>
//                               📞 {candidate.phone}
//                             </div>
//                           )}
//                         </div>
//                       </td>
                      
//                       <td>
//                         <div className="salary-info">
//                           {candidate.currentSalary ? (
//                             <>
//                               <span className="current-salary">
//                                 💰 {formatCurrency(candidate.currentSalary)}
//                               </span>
//                               {candidate.expectedSalary && (
//                                 <span className="expected-salary" title="Expected Salary">
//                                   → {formatCurrency(candidate.expectedSalary)}
//                                 </span>
//                               )}
//                             </>
//                           ) : (
//                             <span className="salary-na">Not specified</span>
//                           )}
//                         </div>
//                       </td>
                      
//                       <td>
//                         <div className="status-group">
//                           <span className={`status-badge ${(candidate.status || "inactive").toLowerCase()}`}>
//                             {candidate.status || "Inactive"}
//                           </span>
//                           <span className={`registration-badge ${(candidate.registrationStatus || "unregistered").toLowerCase()}`}>
//                             {candidate.registrationStatus === "Registered" ? "✓" : "✗"} 
//                             {candidate.registrationStatus === "Registered" ? " Reg" : " Unreg"}
//                           </span>
//                         </div>
//                       </td>
                      
//                       <td>
//                         <div className="action-buttons">
//                           <button
//                             onClick={() => handleView(candidate)}
//                             className="action-btn view"
//                             title="View Details"
//                           >
//                             👁️
//                           </button>
                          
//                           {isAdmin && (
//                             <button
//                               onClick={() => handleEdit(candidate)}
//                               className="action-btn edit"
//                               title="Edit"
//                             >
//                               ✏️
//                             </button>
//                           )}
                          
//                           {isAdmin && (
//                             <button
//                               onClick={() => handleDelete(candidate.id)}
//                               className="action-btn delete"
//                               title="Delete"
//                             >
//                               🗑️
//                             </button>
//                           )}
//                         </div>
//                       </td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//             </div>

//             {/* Pagination Controls */}
//             <div className="pagination-container">
//               <div className="pagination-info">
//                 Showing {indexOfFirstItem + 1} to {Math.min(indexOfLastItem, filteredCandidates.length)} of {filteredCandidates.length} entries
//               </div>
              
//               <div className="pagination-controls">
//                 <div className="items-per-page">
//                   <label>Show:</label>
//                   <select 
//                     value={itemsPerPage} 
//                     onChange={handleItemsPerPageChange}
//                     className="items-per-page-select"
//                   >
//                     {itemsPerPageOptions.map(option => (
//                       <option key={option} value={option}>{option}</option>
//                     ))}
//                   </select>
//                 </div>
                
//                 <div className="pagination-buttons">
//                   <button 
//                     onClick={goToPreviousPage} 
//                     disabled={currentPage === 1}
//                     className="pagination-btn prev"
//                   >
//                     &laquo; Previous
//                   </button>
                  
//                   <div className="page-numbers">
//                     {[...Array(totalPages)].map((_, index) => {
//                       const pageNumber = index + 1;
//                       if (
//                         pageNumber === 1 ||
//                         pageNumber === totalPages ||
//                         (pageNumber >= currentPage - 2 && pageNumber <= currentPage + 2)
//                       ) {
//                         return (
//                           <button
//                             key={pageNumber}
//                             onClick={() => paginate(pageNumber)}
//                             className={`page-number ${currentPage === pageNumber ? 'active' : ''}`}
//                           >
//                             {pageNumber}
//                           </button>
//                         );
//                       } else if (
//                         pageNumber === currentPage - 3 ||
//                         pageNumber === currentPage + 3
//                       ) {
//                         return <span key={pageNumber} className="page-ellipsis">...</span>;
//                       }
//                       return null;
//                     })}
//                   </div>
                  
//                   <button 
//                     onClick={goToNextPage} 
//                     disabled={currentPage === totalPages}
//                     className="pagination-btn next"
//                   >
//                     Next &raquo;
//                   </button>
//                 </div>
//               </div>
//             </div>
//           </>
//         ) : (
//           <div className="empty-state">
//             <div className="empty-icon">👥</div>
//             <h3>No candidates found</h3>
//             <p>Try adjusting your search or add a new candidate</p>
//             <button
//               onClick={() => setShowModal(true)}
//               className="btn-primary"
//             >
//               + Add Candidate
//             </button>
//           </div>
//         )}
//       </div>

//       {/* View Candidate Modal */}
//       {showViewModal && viewingCandidate && (
//         <div className="modal-overlay">
//           <div className="modal-content modal-lg">
//             <div className="modal-header">
//               <h2>Candidate Details</h2>
//               <button
//                 className="modal-close"
//                 onClick={() => {
//                   setViewingCandidate(null);
//                   setShowViewModal(false);
//                 }}
//               >
//                 ×
//               </button>
//             </div>

//             <div className="modal-body">
//               <div className="view-candidate-header">
//                 <div className="view-candidate-avatar">
//                   {getInitials(viewingCandidate.name)}
//                 </div>
//                 <div className="view-candidate-title">
//                   <h3>{viewingCandidate.name || "N/A"}</h3>
//                   <p>{viewingCandidate.currentCompany || "No current company"}</p>
//                 </div>
//                 <div className="view-candidate-badges">
//                   <span className={`status-badge ${(viewingCandidate.status || "inactive").toLowerCase()}`}>
//                     {viewingCandidate.status || "Inactive"}
//                   </span>
//                   <span className={`registration-badge ${(viewingCandidate.registrationStatus || "unregistered").toLowerCase()}`}>
//                     {viewingCandidate.registrationStatus || "Unregistered"}
//                   </span>
//                 </div>
//               </div>

//               <div className="view-details-grid">
//                 <div className="view-details-section">
//                   <h4>Contact Information</h4>
//                   <div className="view-details-row">
//                     <span className="detail-label">Email:</span>
//                     <span className="detail-value">
//                       <a href={`mailto:${viewingCandidate.email}`}>{viewingCandidate.email || "-"}</a>
//                     </span>
//                   </div>
//                   <div className="view-details-row">
//                     <span className="detail-label">Primary Phone:</span>
//                     <span className="detail-value">{viewingCandidate.phone || "-"}</span>
//                   </div>
//                   <div className="view-details-row">
//                     <span className="detail-label">Alternate Phone:</span>
//                     <span className="detail-value">{viewingCandidate.alternatePhone || "-"}</span>
//                   </div>
//                   <div className="view-details-row">
//                     <span className="detail-label">Location:</span>
//                     <span className="detail-value">{viewingCandidate.location || "-"}</span>
//                   </div>
//                 </div>

//                 <div className="view-details-section">
//                   <h4>Professional Details</h4>
//                   <div className="view-details-row">
//                     <span className="detail-label">Qualification:</span>
//                     <span className="detail-value">{viewingCandidate.qualification || "-"}</span>
//                   </div>
//                   <div className="view-details-row">
//                     <span className="detail-label">Branch:</span>
//                     <span className="detail-value">
//                       <span className={`branch-badge ${viewingCandidate.branch?.toLowerCase() || ''}`}>
//                         {viewingCandidate.branch || "-"}
//                       </span>
//                     </span>
//                   </div>
//                   <div className="view-details-row">
//                     <span className="detail-label">Experience:</span>
//                     <span className="detail-value">{viewingCandidate.experience || "-"}</span>
//                   </div>
//                   <div className="view-details-row">
//                     <span className="detail-label">Current Company:</span>
//                     <span className="detail-value">{viewingCandidate.currentCompany || "-"}</span>
//                   </div>
//                   <div className="view-details-row">
//                     <span className="detail-label">Notice Period:</span>
//                     <span className="detail-value">{viewingCandidate.noticePeriod || "-"}</span>
//                   </div>
//                 </div>

//                 <div className="view-details-section">
//                   <h4>Salary Information</h4>
//                   <div className="view-details-row">
//                     <span className="detail-label">Current Salary:</span>
//                     <span className="detail-value">{formatCurrency(viewingCandidate.currentSalary)}</span>
//                   </div>
//                   <div className="view-details-row">
//                     <span className="detail-label">Expected Salary:</span>
//                     <span className="detail-value">{formatCurrency(viewingCandidate.expectedSalary)}</span>
//                   </div>
//                 </div>

//                 <div className="view-details-section full-width">
//                   <h4>Skills</h4>
//                   <div className="skills-container">
//                     {(viewingCandidate.skills || "")
//                       .split(",")
//                       .map(s => s.trim())
//                       .filter(Boolean)
//                       .map((skill, index) => (
//                         <span key={index} className="skill-tag large">
//                           {skill}
//                         </span>
//                       ))}
//                     {!viewingCandidate.skills && <span className="detail-value">No skills added</span>}
//                   </div>
//                 </div>

//                 <div className="view-details-section full-width">
//                   <h4>Additional Information</h4>
//                   <div className="view-details-row">
//                     <span className="detail-label">Resume URL:</span>
//                     <span className="detail-value">
//                       {viewingCandidate.resumeUrl ? (
//                         <a href={viewingCandidate.resumeUrl} target="_blank" rel="noopener noreferrer">
//                           View Resume ↗
//                         </a>
//                       ) : "-"}
//                     </span>
//                   </div>
//                   <div className="view-details-row">
//                     <span className="detail-label">Created Date:</span>
//                     <span className="detail-value">{formatDate(viewingCandidate.createdDate)}</span>
//                   </div>
//                 </div>
//               </div>
//             </div>

//             <div className="modal-footer">
//               <button
//                 type="button"
//                 className="btn-secondary"
//                 onClick={() => {
//                   setViewingCandidate(null);
//                   setShowViewModal(false);
//                 }}
//               >
//                 Close
//               </button>
              
//               {isAdmin && (
//                 <button
//                   type="button"
//                   className="btn-primary"
//                   onClick={() => {
//                     setViewingCandidate(null);
//                     setShowViewModal(false);
//                     handleEdit(viewingCandidate);
//                   }}
//                 >
//                   Edit Candidate
//                 </button>
//               )}
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Add/Edit Modal - Updated with Qualification Dropdown and Experience Dropdown */}
//       {showModal && (
//         <div className="modal-overlay">
//           <div className="modal-content modal-lg">
//             <div className="modal-header">
//               <h2>
//                 {editingCandidate ? "Edit Candidate" : "Add New Candidate"}
//               </h2>
//               <button
//                 className="modal-close"
//                 onClick={() => {
//                   resetForm();
//                   setShowModal(false);
//                 }}
//               >
//                 ×
//               </button>
//             </div>

//             <form onSubmit={handleSubmit}>
//               <div className="modal-body">
//                 <div className="form-grid">
//                   <div className="form-group">
//                     <label>Full Name *</label>
//                     <input
//                       type="text"
//                       name="name"
//                       value={formData.name}
//                       onChange={handleInputChange}
//                       className={`form-input ${formErrors.name ? 'error' : ''}`}
//                       placeholder="John Doe"
//                     />
//                     {formErrors.name && <span className="error-message">{formErrors.name}</span>}
//                   </div>

//                   <div className="form-group">
//                     <label>Email *</label>
//                     <input
//                       type="email"
//                       name="email"
//                       value={formData.email}
//                       onChange={handleInputChange}
//                       className={`form-input ${formErrors.email ? 'error' : ''}`}
//                       placeholder="john@example.com"
//                     />
//                     {formErrors.email && <span className="error-message">{formErrors.email}</span>}
//                   </div>

//                   <div className="form-group">
//                     <label>Primary Phone</label>
//                     <input
//                       type="tel"
//                       name="phone"
//                       value={formData.phone}
//                       onChange={handleInputChange}
//                       className={`form-input ${formErrors.phone ? 'error' : ''}`}
//                       placeholder="+1 234 567 890"
//                     />
//                     {formErrors.phone && <span className="error-message">{formErrors.phone}</span>}
//                   </div>

//                   <div className="form-group">
//                     <label>Alternate Phone</label>
//                     <input
//                       type="tel"
//                       name="alternatePhone"
//                       value={formData.alternatePhone}
//                       onChange={handleInputChange}
//                       className="form-input"
//                       placeholder="+1 234 567 891"
//                     />
//                   </div>

//                   {/* Qualification - DROPDOWN */}
//                   <div className="form-group">
//                     <label>Qualification *</label>
//                     <select
//                       name="qualification"
//                       value={formData.qualification}
//                       onChange={handleInputChange}
//                       className={`form-select ${formErrors.qualification ? 'error' : ''}`}
//                     >
//                       <option value="">Select Qualification</option>
//                       {qualificationOptions.map((qual, index) => (
//                         <option key={index} value={qual}>
//                           {qual}
//                         </option>

  
//                       ))}
//                     </select>
//                     {formErrors.qualification && <span className="error-message">{formErrors.qualification}</span>}
//                     <span className="form-hint">
//                       Select candidate's highest qualification
//                     </span>
//                   </div>

//                   <div className="form-group">
//                     <label>Branch *</label>
//                     <select
//                       name="branch"
//                       value={formData.branch}
//                       onChange={handleInputChange}
//                       className="form-select"
//                     >
//                       <option value="Ankleshwar">Ankleshwar</option>
//                       <option value="Bharuch">Bharuch</option>
//                     </select>
//                   </div>

//                   {/* Experience - DROPDOWN with Fresher to 15 years */}
//                   <div className="form-group">
//                     <label>Experience *</label>
//                     <select
//                       name="experience"
//                       value={formData.experience}
//                       onChange={handleInputChange}
//                       className={`form-select ${formErrors.experience ? 'error' : ''}`}
//                     >
//                       <option value="">Select Experience</option>
//                       {experienceOptions.map((exp, index) => (
//                         <option key={index} value={exp}>
//                           {exp}
//                         </option>
//                       ))}
//                     </select>
//                     {formErrors.experience && <span className="error-message">{formErrors.experience}</span>}
//                   </div>

//                   <div className="form-group">
//                     <label>Current Company</label>
//                     <input
//                       type="text"
//                       name="currentCompany"
//                       value={formData.currentCompany}
//                       onChange={handleInputChange}
//                       className="form-input"
//                       placeholder="Current Company"
//                     />
//                   </div>

//                   <div className="form-group">
//                     <label>Current Salary (LPA)</label>
//                     <input
//                       type="text"
//                       name="currentSalary"
//                       value={formData.currentSalary}
//                       onChange={handleInputChange}
//                       className="form-input"
//                       placeholder="e.g., 12"
//                     />
//                   </div>

//                   <div className="form-group">
//                     <label>Expected Salary (LPA)</label>
//                     <input
//                       type="text"
//                       name="expectedSalary"
//                       value={formData.expectedSalary}
//                       onChange={handleInputChange}
//                       className="form-input"
//                       placeholder="e.g., 15"
//                     />
//                   </div>

//                   <div className="form-group">
//                     <label>Notice Period</label>
//                     <select
//                       name="noticePeriod"
//                       value={formData.noticePeriod}
//                       onChange={handleInputChange}
//                       className="form-select"
//                     >
//                       <option value="">Select Notice Period</option>
//                       <option value="Immediate">Immediate</option>
//                       <option value="15 days">15 days</option>
//                       <option value="30 days">30 days</option>
//                       <option value="45 days">45 days</option>
//                       <option value="60 days">60 days</option>
//                       <option value="90 days">90 days</option>
//                     </select>
//                   </div>

//                   <div className="form-group">
//                     <label>Location</label>
//                     <input
//                       type="text"
//                       name="location"
//                       value={formData.location}
//                       onChange={handleInputChange}
//                       className="form-input"
//                       placeholder="City, Country"
//                     />
//                   </div>

//                   <div className="form-group">
//                     <label>Status</label>
//                     <select
//                       name="status"
//                       value={formData.status}
//                       onChange={handleInputChange}
//                       className="form-select"
//                     >
//                       <option value="Active">Active</option>
//                       <option value="Inactive">Inactive</option>
//                       <option value="Placed">Placed</option>
//                     </select>
//                   </div>

//                   <div className="form-group">
//                     <label>Registration Status</label>
//                     <select
//                       name="registrationStatus"
//                       value={formData.registrationStatus}
//                       onChange={handleInputChange}
//                       className="form-select"
//                     >
//                       <option value="">Select Registration Status</option>
//                       <option value="Registered">Registered</option>
//                       <option value="Unregistered">Unregistered</option>
//                     </select>
//                     <span className="form-hint">
//                       If not selected, "Unregistered" will be saved by default
//                     </span>
//                   </div>

//                   {editingCandidate && (
//                     <div className="form-group">
//                       <label>Created Date</label>
//                       <input
//                         type="datetime-local"
//                         name="createdDate"
//                         value={formData.createdDate}
//                         onChange={handleInputChange}
//                         className="form-input"
//                       />
//                     </div>
//                   )}
//                 </div>

//                 {/* Skills - Optional */}
//                 <div className="form-group">
//                   <label>Skills (Optional)</label>
//                   <textarea
//                     name="skills"
//                     value={formData.skills}
//                     onChange={handleInputChange}
//                     className="form-textarea"
//                     placeholder="React, JavaScript, Node.js (comma separated)"
//                     rows="3"
//                   />
//                   <span className="form-hint">
//                     Enter skills separated by commas (optional)
//                   </span>
//                 </div>

//                 <div className="form-group">
//                   <label>Resume URL</label>
//                   <input
//                     type="url"
//                     name="resumeUrl"
//                     value={formData.resumeUrl}
//                     onChange={handleInputChange}
//                     className="form-input"
//                     placeholder="https://example.com/resume.pdf"
//                   />
//                 </div>
//               </div>

//               <div className="modal-footer">
//                 <button
//                   type="button"
//                   className="btn-secondary"
//                   onClick={() => {
//                     resetForm();
//                     setShowModal(false);
//                   }}
//                 >
//                   Cancel
//                 </button>
//                 <button type="submit" className="btn-primary">
//                   {editingCandidate ? "Update Candidate" : "Save Candidate"}
//                 </button>
//               </div>
//             </form>
//           </div>
//         </div>
//       )}

//       {/* Excel Import Modal */}
//       {showImportModal && (
//         <div className="modal-overlay">
//           <div className="modal-content modal-lg">
//             <div className="modal-header">
//               <h2>Import Candidates from Excel</h2>
//               <button
//                 className="modal-close"
//                 onClick={() => {
//                   resetImport();
//                   setShowImportModal(false);
//                 }}
//               >
//                 ×
//               </button>
//             </div>

//             <div className="modal-body">
//               {importStep === 'upload' && (
//                 <div className="import-upload-section">
//                   <div className="import-instructions">
//                     <h3>Instructions:</h3>
//                     <ul>
//                       <li>Download the template file first</li>
//                       <li>Fill in your candidate data</li>
//                       <li>Required columns: Name, Email, Experience, Qualification</li>
//                       <li>Skills column is optional</li>
//                       <li>Branch must be either "Ankleshwar" or "Bharuch"</li>
//                       <li>Registration Status: Leave empty to default to "Unregistered"</li>
//                       <li>Upload the filled Excel file (.xlsx, .xls)</li>
//                     </ul>
//                   </div>

//                   <div className="import-actions">
//                     <button
//                       onClick={downloadTemplate}
//                       className="btn-secondary"
//                     >
//                       📥 Download Template
//                     </button>
                    
//                     <div className="file-upload-area">
//                       <input
//                         type="file"
//                         ref={fileInputRef}
//                         accept=".xlsx,.xls,.csv"
//                         onChange={handleFileUpload}
//                         className="file-input"
//                         id="excel-upload"
//                       />
//                       <label htmlFor="excel-upload" className="file-upload-label">
//                         {importLoading ? 'Processing...' : 'Choose Excel File'}
//                       </label>
//                     </div>
//                   </div>

//                   {importLoading && (
//                     <div className="import-loading">
//                       <div className="spinner-small"></div>
//                       <p>Processing file...</p>
//                     </div>
//                   )}
//                 </div>
//               )}

//               {importStep === 'preview' && (
//                 <div className="import-preview-section">
//                   <div className="import-summary">
//                     <h3>Import Summary</h3>
//                     <div className="summary-stats">
//                       <div className="stat-item success">
//                         <span className="stat-value">{importData.length}</span>
//                         <span className="stat-label">Valid Records</span>
//                       </div>
//                       <div className="stat-item error">
//                         <span className="stat-value">{importErrors.length}</span>
//                         <span className="stat-label">Errors</span>
//                       </div>
//                     </div>
//                   </div>

//                   {importErrors.length > 0 && (
//                     <div className="import-errors">
//                       <h4>Errors Found:</h4>
//                       <div className="errors-list">
//                         {importErrors.map((error, idx) => (
//                           <div key={idx} className="error-item">
//                             <strong>Row {error.row}:</strong> {error.name} - {error.errors.join(', ')}
//                           </div>
//                         ))}
//                       </div>
//                     </div>
//                   )}

//                   {importData.length > 0 && (
//                     <div className="import-preview">
//                       <h4>Preview (First 5 Records)</h4>
//                       <div className="preview-table-container">
//                         <table className="preview-table">
//                           <thead>
//                             <tr>
//                               <th>Name</th>
//                               <th>Email</th>
//                               <th>Qualification</th>
//                               <th>Branch</th>
//                               <th>Skills</th>
//                               <th>Experience</th>
//                               <th>Status</th>
//                               <th>Registration Status</th>
//                             </tr>
//                           </thead>
//                           <tbody>
//                             {importData.slice(0, 5).map((candidate, idx) => (
//                               <tr key={idx}>
//                                 <td>{candidate.name}</td>
//                                 <td>{candidate.email}</td>
//                                 <td>{candidate.qualification || '-'}</td>
//                                 <td>
//                                   <span className={`branch-badge ${candidate.branch?.toLowerCase()}`}>
//                                     {candidate.branch}
//                                   </span>
//                                 </td>
//                                 <td>{candidate.skills || '-'}</td>
//                                 <td>{candidate.experience}</td>
//                                 <td>
//                                   <span className={`status-badge ${candidate.status.toLowerCase()}`}>
//                                     {candidate.status}
//                                   </span>
//                                 </td>
//                                 <td>
//                                   <span className={`registration-badge ${(candidate.registrationStatus || 'unregistered').toLowerCase()}`}>
//                                     {candidate.registrationStatus || 'Unregistered'}
//                                   </span>
//                                 </td>
//                               </tr>
//                             ))}
//                           </tbody>
//                         </table>
//                       </div>
//                     </div>
//                   )}
//                 </div>
//               )}

//               {importStep === 'complete' && (
//                 <div className="import-complete">
//                   <div className="success-icon">✅</div>
//                   <h3>Import Successful!</h3>
//                   <p>{importData.length} candidates have been added.</p>
//                 </div>
//               )}
//             </div>

//             {importStep === 'preview' && (
//               <div className="modal-footer">
//                 <button
//                   type="button"
//                   className="btn-secondary"
//                   onClick={resetImport}
//                 >
//                   Back
//                 </button>
//                 <button
//                   type="button"
//                   className="btn-primary"
//                   onClick={handleImportConfirm}
//                   disabled={importData.length === 0 || importLoading}
//                 >
//                   {importLoading ? 'Importing...' : `Import ${importData.length} Candidates`}
//                 </button>
//               </div>
//             )}
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default Candidates;



// 13/04/2026




// import React, { useState, useEffect, useRef } from "react";
// import * as XLSX from "xlsx";

// import { getCandidates, createCandidate, updateCandidate, deleteCandidate } from "../../services/api";

// import { useAuth } from "../../contexts/AuthContext";

// import "./Candidates.css";

// const Candidates = () => {
//   // Get current user from AuthContext
//   const { currentUser } = useAuth();
  
//   const [candidates, setCandidates] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [showModal, setShowModal] = useState(false);
//   const [showViewModal, setShowViewModal] = useState(false);
//   const [viewingCandidate, setViewingCandidate] = useState(null);
//   const [editingCandidate, setEditingCandidate] = useState(null);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [filterSkills, setFilterSkills] = useState("all");
//   const [filterExperience, setFilterExperience] = useState("all");
//   const [filterStatus, setFilterStatus] = useState("all");
//   const [filterRegistration, setFilterRegistration] = useState("all");
//   const [filterQualification, setFilterQualification] = useState("all");
//   const [filterBranch, setFilterBranch] = useState("all");
//   const [sortOrder, setSortOrder] = useState("newest");
//   const [formErrors, setFormErrors] = useState({});
//   const [isHeaderScrolled, setIsHeaderScrolled] = useState(false);
  
//   // Pagination states
//   const [currentPage, setCurrentPage] = useState(1);
//   const [itemsPerPage, setItemsPerPage] = useState(10);
//   const [itemsPerPageOptions] = useState([5, 10, 25, 50, 100]);
  
//   // Excel import states
//   const [showImportModal, setShowImportModal] = useState(false);
//   const [importData, setImportData] = useState([]);
//   const [importErrors, setImportErrors] = useState([]);
//   const [importLoading, setImportLoading] = useState(false);
//   const [importStep, setImportStep] = useState('upload');
//   const fileInputRef = useRef(null);
//   const headerRef = useRef(null);

//   // Check user roles
//   const isAdmin = currentUser && currentUser.role === "admin";
//   const isRecruiter = currentUser && currentUser.role === "recruiter";
//   const canEdit = isAdmin || isRecruiter; // Both admin and recruiter can edit
//   const canDelete = isAdmin; // Only admin can delete

//   // Qualification options
//   const qualificationOptions = [
//   // ===== SCHOOL EDUCATION =====
//   "SSC (10th Pass)",
//   "HSC (12th Science)",
//   "HSC (12th Commerce)",
//   "HSC (12th Arts)",

//   // ===== ITI (Industrial Training Institute) =====
//   "ITI AOCP Certification",
//   "ITI - Fitter",
//   "ITI - Electrician",
//   "ITI - Welder",
//   "ITI - Turner",
//   "ITI - Machinist",
//   "ITI - Instrument Mechanic",
//   "ITI - Draughtsman (Mechanical)",
//   "ITI - Draughtsman (Civil)",
//   "ITI - Diesel Mechanic",
//   "ITI - Motor Mechanic",
//   "ITI - Refrigeration & Air Conditioning",
//   "ITI - Plumber",
//   "ITI - COPA (Computer Operator & Programming Assistant)",
//   "ITI - RFM (Refinery & Maintenance Mechanic)",
//   "ITI - Pump Operator",
//   "ITI - Boiler Attendant",
//   "ITI - Fire & Safety",

//   // ===== DIPLOMA =====
//   "Diploma - Mechanical Engineering",
//   "Diploma - Electrical Engineering",
//   "Diploma - Chemical Engineering",
//   "Diploma - Instrumentation",
//   "Diploma - Civil Engineering",
//   "Diploma - Automobile Engineering",
//   "Diploma - Production Engineering",
//   "Diploma - Plastic Technology",
//   "Diploma - Petrochemical Engineering",
//   "Diploma - Industrial Safety",

//   // ===== ENGINEERING (BE / B.Tech) =====
//   "B.E. - Mechanical Engineering",
//   "B.E. - Electrical Engineering",
//   "B.E. - Chemical Engineering",
//   "B.E. - Instrumentation Engineering",
//   "B.E. - Civil Engineering",
//   "B.E. - Automobile Engineering",
//   "B.E. - Production Engineering",
//   "B.E. - Petrochemical Engineering",

//   // ===== SCIENCE GRADUATION =====
//   "B.Sc - Chemistry",
//   "B.Sc - Physics",
//   "B.Sc - Mathematics",
//   "B.Sc - Industrial Chemistry",
//   "B.Sc - Environmental Science",
//   "B.Sc - Microbiology",

//   // ===== COMMERCE & MANAGEMENT =====
//   "B.Com (Bachelor of Commerce)",
//   "BBA (Bachelor of Business Administration)",
//   "MBA - Human Resources",
//   "MBA - Marketing",
//   "MBA - Finance",
//   "MBA - Operations",

//   // ===== COMPUTER / IT =====
//   "BCA (Bachelor of Computer Applications)",
//   "MCA (Master of Computer Applications)",
//   "Diploma - Computer Applications",

//   // ===== POST GRADUATION (TECHNICAL) =====
//   "M.Tech - Mechanical Engineering",
//   "M.Tech - Chemical Engineering",
//   "M.Tech - Electrical Engineering",
//   "M.Tech - Instrumentation Engineering",
//   "M.Sc - Chemistry",
//   "M.Sc - Environmental Science",

//   // ===== SAFETY & PROFESSIONAL =====
//   "PDIS (Professional Diploma in Industrial Safety)",
//   "ADIS (Advanced Diploma in Industrial Safety)",
//   "NEBOSH - IGC",
//   "NEBOSH - Diploma",
//   "IOSH Certification",
//   "Diploma - Fire & Safety",
//   "Industrial Safety Certification",

//   // ===== SPECIALIZED / INDUSTRIAL CERTIFICATIONS =====
//   "LACP Certification",
  
//   "Boiler Operation Certificate",
//   "First Aid Certification",
//   "Quality Control Certification",
//   "NDT Level II",
//   "NDT Level III",

//   // ===== OTHERS =====
//   "PhD (Doctor of Philosophy)",
//   "Other"
// ];

//   // Experience options from Fresher to 15 years
//   const experienceOptions = [
//     "Fresher",
//     "1 year",
//     "2 years",
//     "3 years",
//     "4 years",
//     "5 years",
//     "6 years",
//     "7 years",
//     "8 years",
//     "9 years",
//     "10 years",
//     "11 years",
//     "12 years",
//     "13 years",
//     "14 years",
//     "15 years"
//   ];

//   const [formData, setFormData] = useState({
//     name: "",
//     email: "",
//     phone: "",
//     alternatePhone: "",
//     skills: "",
//     experience: "",
//     qualification: "",
//     branch: "Ankleshwar",
//     currentCompany: "",
//     currentSalary: "",
//     expectedSalary: "",
//     noticePeriod: "",
//     location: "",
//     resumeUrl: "",
//     status: "Active",
//     registrationStatus: "",
//     createdDate: new Date().toISOString().slice(0, 16),
//   });

//   useEffect(() => {
//     loadCandidates();
    
//     const handleScroll = () => {
//       if (headerRef.current) {
//         const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
//         setIsHeaderScrolled(scrollTop > 50);
//       }
//     };

//     window.addEventListener('scroll', handleScroll);
//     return () => window.removeEventListener('scroll', handleScroll);
//   }, []);

//   // Reset to first page when filters change
//   useEffect(() => {
//     setCurrentPage(1);
//   }, [searchTerm, filterSkills, filterExperience, filterStatus, 
//       filterRegistration, filterQualification, filterBranch, sortOrder]);

//   const loadCandidates = async () => {
//     setLoading(true);

//     try {
//       const res = await getCandidates();
//       const normalizedCandidates = res.data.map(candidate => ({
//         ...candidate,
//         registrationStatus: candidate.registrationStatus || "Unregistered"
//       }));
//       setCandidates(normalizedCandidates);
//     } catch (error) {
//       console.error(error);
//     }

//     setLoading(false);
//   };

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({ ...prev, [name]: value }));
//     if (formErrors[name]) {
//       setFormErrors(prev => ({ ...prev, [name]: "" }));
//     }
//   };

//   // Function to check if date is not in future
//   const isDateNotInFuture = (dateString) => {
//     if (!dateString) return true;
//     const selectedDate = new Date(dateString);
//     const currentDate = new Date();
    
//     selectedDate.setHours(0, 0, 0, 0);
//     currentDate.setHours(0, 0, 0, 0);
    
//     return selectedDate <= currentDate;
//   };

//   // Validation function
//   const validateForm = () => {
//     const errors = {};
    
//     if (!formData.name || formData.name.trim() === "") {
//       errors.name = "Name is required";
//     }
    
//     if (!formData.email || formData.email.trim() === "") {
//       errors.email = "Email is required";
//     } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
//       errors.email = "Email is invalid";
//     }
    
//     if (!formData.experience || formData.experience === "") {
//       errors.experience = "Experience is required";
//     }
    
//     if (!formData.qualification || formData.qualification === "") {
//       errors.qualification = "Qualification is required";
//     }
    
//     if (formData.phone && !/^[\d\s\+\-\(\)]{10,}$/.test(formData.phone)) {
//       errors.phone = "Please enter a valid phone number";
//     }

//     // Created date validation - Only for editing candidates
//     if (editingCandidate && formData.createdDate) {
//       if (!isDateNotInFuture(formData.createdDate)) {
//         errors.createdDate = "Created date cannot be in the future";
//       }
//     }

//     setFormErrors(errors);
//     return Object.keys(errors).length === 0;
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (!validateForm()) {
//       return;
//     }

//     const candidateData = {
//       ...formData,
//       registrationStatus: formData.registrationStatus || "Unregistered",
//       id: editingCandidate ? editingCandidate.id : Date.now().toString(),
//       createdDate: editingCandidate ? formData.createdDate : new Date().toISOString(),
//       skills: formData.skills ? formData.skills.split(',').map(s => s.trim()).filter(Boolean).join(', ') : "",
//     };

//     if (editingCandidate) {
//       await updateCandidate(editingCandidate.id, candidateData);
//     } else {
//       await createCandidate(candidateData);
//     }

//     resetForm();
//     loadCandidates();
//     setShowModal(false);
//   };

//   const handleView = (candidate) => {
//     setViewingCandidate(candidate);
//     setShowViewModal(true);
//   };

//   const handleEdit = (candidate) => {
//     // Both admin and recruiter can edit
//     if (!canEdit) {
//       alert("You don't have permission to edit candidates");
//       return;
//     }
    
//     // Format the created date for datetime-local input
//     let formattedDate = candidate.createdDate;
//     if (candidate.createdDate) {
//       const date = new Date(candidate.createdDate);
//       if (!isNaN(date.getTime())) {
//         formattedDate = date.toISOString().slice(0, 16);
//       }
//     }
    
//     setEditingCandidate(candidate);
//     setFormData({
//       ...candidate,
//       skills: candidate.skills || "",
//       createdDate: formattedDate,
//     });
//     setShowModal(true);
//   };

//   const handleDelete = async (id) => {
//     // Only admin can delete
//     if (!isAdmin) {
//       alert("You don't have permission to delete candidates");
//       return;
//     }
//     if (window.confirm("Are you sure you want to delete this candidate?")) {
//       await deleteCandidate(id);
//       loadCandidates();
//     }
//   };

//   const resetForm = () => {
//     setFormData({
//       name: "",
//       email: "",
//       phone: "",
//       alternatePhone: "",
//       skills: "",
//       experience: "",
//       qualification: "",
//       branch: "Ankleshwar",
//       currentCompany: "",
//       currentSalary: "",
//       expectedSalary: "",
//       noticePeriod: "",
//       location: "",
//       resumeUrl: "",
//       status: "Active",
//       registrationStatus: "",
//       createdDate: new Date().toISOString().slice(0, 16),
//     });
//     setEditingCandidate(null);
//     setFormErrors({});
//   };

//   // ===== EXCEL IMPORT FUNCTIONS =====
  
//   const handleFileUpload = (e) => {
//     const file = e.target.files[0];
//     if (!file) return;

//     setImportLoading(true);
//     setImportErrors([]);

//     const reader = new FileReader();
//     reader.onload = (event) => {
//       try {
//         const data = new Uint8Array(event.target.result);
//         const workbook = XLSX.read(data, { type: 'array' });
        
//         const sheetName = workbook.SheetNames[0];
//         const worksheet = workbook.Sheets[sheetName];
        
//         const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
        
//         const parsedData = parseExcelData(jsonData);
//         setImportData(parsedData.validData);
//         setImportErrors(parsedData.errors);
        
//         if (parsedData.validData.length > 0) {
//           setImportStep('preview');
//         }
//       } catch (error) {
//         setImportErrors([{ row: 0, error: 'Failed to parse Excel file: ' + error.message }]);
//       } finally {
//         setImportLoading(false);
//       }
//     };
    
//     reader.readAsArrayBuffer(file);
//   };

//   const parseExcelData = (rows) => {
//     if (rows.length < 2) {
//       return { validData: [], errors: [{ row: 0, error: 'File is empty or has no data rows' }] };
//     }

//     const headers = rows[0].map(h => String(h || '').toLowerCase().trim());
    
//     const fieldMap = {
//       name: findColumnIndex(headers, ['name', 'full name', 'candidate name']),
//       email: findColumnIndex(headers, ['email', 'e-mail', 'email address']),
//       phone: findColumnIndex(headers, ['phone', 'mobile', 'contact', 'phone number']),
//       alternatePhone: findColumnIndex(headers, ['alternate phone', 'alt phone', 'secondary phone']),
//       skills: findColumnIndex(headers, ['skills', 'skill', 'technologies']),
//       experience: findColumnIndex(headers, ['experience', 'exp', 'total experience', 'years']),
//       qualification: findColumnIndex(headers, ['qualification', 'education', 'degree']),
//       branch: findColumnIndex(headers, ['branch', 'location branch', 'office']),
//       currentCompany: findColumnIndex(headers, ['current company', 'company', 'employer']),
//       currentSalary: findColumnIndex(headers, ['current salary', 'current ctc', 'salary']),
//       expectedSalary: findColumnIndex(headers, ['expected salary', 'expected ctc', 'expectation']),
//       noticePeriod: findColumnIndex(headers, ['notice period', 'notice', 'np']),
//       location: findColumnIndex(headers, ['location', 'city', 'place']),
//       status: findColumnIndex(headers, ['status']),
//       registrationStatus: findColumnIndex(headers, ['registration status', 'registration', 'reg status'])
//     };

//     const validData = [];
//     const errors = [];

//     for (let i = 1; i < rows.length; i++) {
//       const row = rows[i];
//       if (!row || row.length === 0 || row.every(cell => !cell)) continue;

//       const branchValue = getCellValue(row, fieldMap.branch);
//       const validBranch = branchValue && ['Ankleshwar', 'Bharuch'].includes(branchValue) 
//         ? branchValue 
//         : 'Ankleshwar';

//       const registrationStatusValue = getCellValue(row, fieldMap.registrationStatus);
      
//       const candidate = {
//         id: Date.now().toString() + i,
//         createdDate: new Date().toISOString(),
//         name: getCellValue(row, fieldMap.name) || '',
//         email: getCellValue(row, fieldMap.email) || '',
//         phone: getCellValue(row, fieldMap.phone) || '',
//         alternatePhone: getCellValue(row, fieldMap.alternatePhone) || '',
//         skills: getCellValue(row, fieldMap.skills) || '',
//         experience: getCellValue(row, fieldMap.experience) || '',
//         qualification: getCellValue(row, fieldMap.qualification) || '',
//         branch: validBranch,
//         currentCompany: getCellValue(row, fieldMap.currentCompany) || '',
//         currentSalary: getCellValue(row, fieldMap.currentSalary) || '',
//         expectedSalary: getCellValue(row, fieldMap.expectedSalary) || '',
//         noticePeriod: getCellValue(row, fieldMap.noticePeriod) || '',
//         location: getCellValue(row, fieldMap.location) || '',
//         status: mapStatus(getCellValue(row, fieldMap.status)) || 'Active',
//         registrationStatus: mapRegistrationStatus(registrationStatusValue) || "Unregistered"
//       };

//       const rowErrors = [];
//       if (!candidate.name) rowErrors.push('Name is required');
//       if (!candidate.email) rowErrors.push('Email is required');
//       else if (!/\S+@\S+\.\S+/.test(candidate.email)) rowErrors.push('Invalid email format');
//       if (!candidate.experience) rowErrors.push('Experience is required');
//       if (!candidate.qualification) rowErrors.push('Qualification is required');

//       if (rowErrors.length > 0) {
//         errors.push({
//           row: i + 1,
//           name: candidate.name || 'Unknown',
//           errors: rowErrors
//         });
//       } else {
//         validData.push(candidate);
//       }
//     }

//     return { validData, errors };
//   };

//   const findColumnIndex = (headers, possibleNames) => {
//     for (let i = 0; i < headers.length; i++) {
//       if (possibleNames.some(name => headers[i].includes(name))) {
//         return i;
//       }
//     }
//     return -1;
//   };

//   const getCellValue = (row, index) => {
//     if (index === -1 || index >= row.length) return '';
//     const value = row[index];
//     return value !== undefined && value !== null ? String(value).trim() : '';
//   };

//   const mapStatus = (value) => {
//     if (!value) return 'Active';
//     const status = value.toLowerCase();
//     if (status.includes('inactive')) return 'Inactive';
//     if (status.includes('placed')) return 'Placed';
//     return 'Active';
//   };

//   const mapRegistrationStatus = (value) => {
//     if (!value) return '';
//     const reg = value.toLowerCase();
//     if (reg.includes('unreg')) return 'Unregistered';
//     if (reg.includes('reg')) return 'Registered';
//     return '';
//   };

//   const handleImportConfirm = async () => {
//     setImportLoading(true);

//     try {
//       for (const candidate of importData) {
//         const candidateToSave = {
//           ...candidate,
//           registrationStatus: candidate.registrationStatus || "Unregistered"
//         };
//         await createCandidate(candidateToSave);
//       }

//       loadCandidates();
//       setImportStep('complete');

//       setTimeout(() => {
//         resetImport();
//         setShowImportModal(false);
//       }, 2000);

//     } catch (error) {
//       setImportErrors([{ row: 0, error: 'Failed to save candidates: ' + error.message }]);
//     }

//     setImportLoading(false);
//   };

//   const resetImport = () => {
//     setImportData([]);
//     setImportErrors([]);
//     setImportStep('upload');
//     if (fileInputRef.current) {
//       fileInputRef.current.value = '';
//     }
//   };

//   const downloadTemplate = () => {
//     const template = [
//       ['Name', 'Email', 'Phone', 'Alternate Phone', 'Skills', 'Experience', 'Qualification', 'Branch', 'Current Company', 'Current Salary', 'Expected Salary', 'Notice Period', 'Location', 'Status', 'Registration Status'],
//       ['John Doe', 'john@example.com', '+1234567890', '+1234567891', 'React, JavaScript, Node.js', '3 years', 'B.E. - Mechanical Engineering', 'Ankleshwar', 'Tech Corp', '12', '15', '30 days', 'New York', 'Active', 'Registered'],
//       ['Jane Smith', 'jane@example.com', '+1234567892', '', '', '5 years', 'MCA', 'Bharuch', 'Data Inc', '18', '22', '45 days', 'San Francisco', 'Active', '']
//     ];

//     const wb = XLSX.utils.book_new();
//     const ws = XLSX.utils.aoa_to_sheet(template);
//     XLSX.utils.book_append_sheet(wb, ws, 'Template');
//     XLSX.writeFile(wb, 'candidates_template.xlsx');
//   };

//   // Filter and sort candidates
//   const filteredCandidates = candidates
//     .filter((candidate) => {
//       const search = searchTerm.toLowerCase();
//       const name = candidate.name?.toLowerCase() || "";
//       const email = candidate.email?.toLowerCase() || "";
//       const skills = candidate.skills?.toLowerCase() || "";
//       const company = candidate.currentCompany?.toLowerCase() || "";
//       const qualification = candidate.qualification?.toLowerCase() || "";

//       const matchesSearch = !searchTerm || 
//         name.includes(search) ||
//         email.includes(search) ||
//         skills.includes(search) ||
//         company.includes(search) ||
//         qualification.includes(search);

//       const matchesSkills = filterSkills === "all" || 
//         (candidate.skills?.toLowerCase() || "").includes(filterSkills.toLowerCase());

//       const matchesExperience = filterExperience === "all" || 
//         candidate.experience === filterExperience;

//       const normalize = (val) => (val || "").toLowerCase().trim();

//       const matchesStatus =
//         filterStatus === "all" ||
//         normalize(candidate.status) === normalize(filterStatus);

//       let matchesRegistration = true;
//       if (filterRegistration !== "all") {
//         const candidateRegStatus = candidate.registrationStatus || "Unregistered";
//         matchesRegistration = normalize(candidateRegStatus) === normalize(filterRegistration);
//       }

//       const matchesQualification = filterQualification === "all" || 
//         candidate.qualification === filterQualification;

//       const matchesBranch = filterBranch === "all" || 
//         candidate.branch === filterBranch;

//       return matchesSearch && matchesSkills && matchesExperience && 
//              matchesStatus && matchesRegistration && 
//              matchesQualification && matchesBranch;
//     })
//     .sort((a, b) => {
//       const dateA = new Date(a.createdDate);
//       const dateB = new Date(b.createdDate);
//       const timeA = isNaN(dateA.getTime()) ? 0 : dateA.getTime();
//       const timeB = isNaN(dateB.getTime()) ? 0 : dateB.getTime();
//       return sortOrder === "newest" ? timeB - timeA : timeA - timeB;
//     });

//   // Pagination logic
//   const indexOfLastItem = currentPage * itemsPerPage;
//   const indexOfFirstItem = indexOfLastItem - itemsPerPage;
//   const currentItems = filteredCandidates.slice(indexOfFirstItem, indexOfLastItem);
//   const totalPages = Math.ceil(filteredCandidates.length / itemsPerPage);

//   const paginate = (pageNumber) => setCurrentPage(pageNumber);
  
//   const goToPreviousPage = () => {
//     if (currentPage > 1) {
//       setCurrentPage(currentPage - 1);
//     }
//   };
  
//   const goToNextPage = () => {
//     if (currentPage < totalPages) {
//       setCurrentPage(currentPage + 1);
//     }
//   };
  
//   const handleItemsPerPageChange = (e) => {
//     setItemsPerPage(Number(e.target.value));
//     setCurrentPage(1);
//   };

//   const allSkills = [
//     ...new Set(
//       candidates.flatMap((c) =>
//         (c.skills || "")
//           .split(",")
//           .map((s) => s.trim())
//           .filter(Boolean)
//       )
//     ),
//   ];

//   const allQualifications = [
//     ...new Set(candidates.map((c) => c.qualification).filter(Boolean)),
//   ];

//   const experienceLevels = [
//     ...new Set(candidates.map((c) => c.experience).filter(Boolean)),
//   ];

//   const activeCandidates = candidates.filter(
//     (c) => c.status === "Active"
//   ).length;
  
//   const registeredCandidates = candidates.filter(
//     (c) => (c.registrationStatus || "Unregistered") === "Registered"
//   ).length;

//   const ankleshwarCandidates = candidates.filter(
//     (c) => c.branch === "Ankleshwar"
//   ).length;

//   const bharuchCandidates = candidates.filter(
//     (c) => c.branch === "Bharuch"
//   ).length;

//   const getInitials = (name) => {
//     if (!name) return "?";
//     return name
//       .split(" ")
//       .map((n) => n[0])
//       .join("")
//       .toUpperCase()
//       .slice(0, 2);
//   };

//   const formatDate = (dateString) => {
//     if (!dateString) return "-";
//     try {
//       const date = new Date(dateString);
//       const options = { year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' };
//       return date.toLocaleDateString(undefined, options);
//     } catch (e) {
//       return dateString;
//     }
//   };

//   const formatCurrency = (value) => {
//     if (!value) return "-";
//     return `₹${value}`;
//   };

//   if (loading) {
//     return (
//       <div className="loading-container">
//         <div className="spinner"></div>
//         <p>Loading candidates...</p>
//       </div>
//     );
//   }

//   return (
//     <div className="candidates-page">
//       <div id="candidates-top"></div>

//       <div 
//         ref={headerRef}
//         className={`page-header ${isHeaderScrolled ? 'scrolled' : ''}`}
//       >
//         <div>
//           <h1>Candidates</h1>
//           <p>Manage candidate profiles and information</p>
//           {!canEdit && (
//             <small style={{ color: '#666', fontSize: '12px' }}>View Only Mode</small>
//           )}
//           {isRecruiter && (
//             <small style={{ color: '#4CAF50', fontSize: '12px' }}>Recruiter Mode - Can Edit</small>
//           )}
//           {isAdmin && (
//             <small style={{ color: '#2196F3', fontSize: '12px' }}>Admin Mode - Full Access</small>
//           )}
//         </div>
//         <div className="header-actions">
//           {/* Only show Import button for Admin */}
//           {isAdmin && (
//             <button
//               onClick={() => setShowImportModal(true)}
//               className="btn-secondary"
//               title="Import from Excel"
//             >
//               📥 Import Excel
//             </button>
//           )}
//           {/* Show Add button for both Admin and Recruiter */}
//           {canEdit && (
//             <button
//               onClick={() => setShowModal(true)}
//               className="btn-primary"
//             >
//               + Add Candidate
//             </button>
//           )}
//         </div>
//       </div>

//       {/* Stats Cards */}
//       <div className="stats-cards">
//         <div className="stat-card">
//           <div className="stat-icon">👥</div>
//           <div className="stat-content">
//             <h3>{candidates.length}</h3>
//             <p>Total Candidates</p>
//           </div>
//         </div>
//         <div className="stat-card">
//           <div className="stat-icon">✅</div>
//           <div className="stat-content">
//             <h3>{activeCandidates}</h3>
//             <p>Active Candidates</p>
//           </div>
//         </div>
//         <div className="stat-card">
//           <div className="stat-icon">📝</div>
//           <div className="stat-content">
//             <h3>{registeredCandidates}</h3>
//             <p>Registered</p>
//           </div>
//         </div>
//         <div className="stat-card">
//           <div className="stat-icon">🏢</div>
//           <div className="stat-content">
//             <h3>{ankleshwarCandidates} | {bharuchCandidates}</h3>
//             <p>Ankleshwar | Bharuch</p>
//           </div>
//         </div>
//       </div>

//       {/* Filters */}
//       <div className="filters-section">
//         <div className="search-box">
//           <span className="search-icon">🔍</span>
//           <input
//             type="text"
//             placeholder="Search candidates..."
//             value={searchTerm}
//             onChange={(e) => setSearchTerm(e.target.value)}
//             className="search-input"
//           />
//         </div>

//         <div className="filter-controls">
//           <select
//             value={filterQualification}
//             onChange={(e) => setFilterQualification(e.target.value)}
//             className="filter-select"
//           >
//             <option value="all">All Qualifications</option>
//             {allQualifications.map((qual) => (
//               <option key={qual} value={qual}>
//                 {qual}
//               </option>
//             ))}
//           </select>

//           <select
//             value={filterBranch}
//             onChange={(e) => setFilterBranch(e.target.value)}
//             className="filter-select"
//           >
//             <option value="all">All Branches</option>
//             <option value="Ankleshwar">Ankleshwar</option>
//             <option value="Bharuch">Bharuch</option>
//           </select>

//           <select
//             value={filterSkills}
//             onChange={(e) => setFilterSkills(e.target.value)}
//             className="filter-select"
//           >
//             <option value="all">All Skills</option>
//             {allSkills.map((skill) => (
//               <option key={skill} value={skill}>
//                 {skill}
//               </option>
//             ))}
//           </select>

//           <select
//             value={filterExperience}
//             onChange={(e) => setFilterExperience(e.target.value)}
//             className="filter-select"
//           >
//             <option value="all">All Experience</option>
//             {experienceLevels.map((exp) => (
//               <option key={exp} value={exp}>
//                 {exp}
//               </option>
//             ))}
//           </select>

//           <select
//             value={filterStatus}
//             onChange={(e) => setFilterStatus(e.target.value)}
//             className="filter-select"
//           >
//             <option value="all">All Status</option>
//             <option value="Active">Active</option>
//             <option value="Inactive">Inactive</option>
//             <option value="Placed">Placed</option>
//           </select>

//           <select
//             value={filterRegistration}
//             onChange={(e) => setFilterRegistration(e.target.value)}
//             className="filter-select"
//           >
//             <option value="all">All Registration</option>
//             <option value="Registered">Registered</option>
//             <option value="Unregistered">Unregistered</option>
//           </select>

//           <select
//             value={sortOrder}
//             onChange={(e) => setSortOrder(e.target.value)}
//             className="filter-select"
//           >
//             <option value="newest">Newest First</option>
//             <option value="oldest">Oldest First</option>
//           </select>
//         </div>
//       </div>

//       {/* Table */}
//       <div className="table-container">
//         {filteredCandidates.length > 0 ? (
//           <>
//             <div className="table-responsive">
//               <table className="data-table">
//                 <thead>
//                   <tr>
//                     <th>Candidate</th>
//                     <th>Qualification</th>
//                     <th>Branch</th>
//                     <th>Skills & Experience</th>
//                     <th>Contact</th>
//                     <th>Salary</th>
//                     <th>Status</th>
//                     <th>Actions</th>
//                    </tr>
//                 </thead>

//                 <tbody>
//                   {currentItems.map((candidate) => (
//                     <tr key={candidate.id}>
//                       <td>
//                         <div className="candidate-cell">
//                           <div className="candidate-avatar">
//                             {getInitials(candidate.name)}
//                           </div>
//                           <div>
//                             <div className="candidate-name">
//                               {candidate.name || "N/A"}
//                             </div>
//                             <div className="candidate-company">
//                               {candidate.currentCompany || "Not Specified"}
//                             </div>
//                             <div className="candidate-meta">
//                               📅 {formatDate(candidate.createdDate)}
//                             </div>
//                           </div>
//                         </div>
//                       </td>
                      
//                       <td>
//                         <div className="qualification-cell">
//                           <span className="qualification-badge">
//                             {candidate.qualification || "-"}
//                           </span>
//                         </div>
//                       </td>
                      
//                       <td>
//                         <div className="branch-cell">
//                           <span className={`branch-badge ${candidate.branch?.toLowerCase() || ''}`}>
//                             {candidate.branch || "-"}
//                           </span>
//                         </div>
//                       </td>
                      
//                       <td>
//                         <div className="skills-experience-cell">
//                           <span className="experience-badge">
//                             {candidate.experience || "Exp N/A"}
//                           </span>
//                           <div className="skills-cell">
//                             {(candidate.skills || "")
//                               .split(",")
//                               .map(s => s.trim())
//                               .filter(Boolean)
//                               .slice(0, 2)
//                               .map((skill, i) => (
//                                 <span key={i} className="skill-tag">
//                                   {skill}
//                                 </span>
//                               ))}
//                             {(candidate.skills || "").split(",").filter(Boolean).length > 2 && (
//                               <span className="more-tag">
//                                 +{(candidate.skills || "").split(",").filter(Boolean).length - 2}
//                               </span>
//                             )}
//                             {!candidate.skills && <span className="no-skills">No skills</span>}
//                           </div>
//                         </div>
//                       </td>
                      
//                       <td>
//                         <div className="compact-contact">
//                           <a href={`mailto:${candidate.email}`} className="email-link" title={candidate.email}>
//                             {candidate.email?.length > 20 
//                               ? candidate.email.substring(0, 18) + "..." 
//                               : candidate.email || "-"}
//                           </a>
//                           {candidate.phone && (
//                             <div className="contact-phone" title={`Primary: ${candidate.phone}${candidate.alternatePhone ? `\nAlternate: ${candidate.alternatePhone}` : ''}`}>
//                               📞 {candidate.phone}
//                             </div>
//                           )}
//                         </div>
//                       </td>
                      
//                       <td>
//                         <div className="salary-info">
//                           {candidate.currentSalary ? (
//                             <>
//                               <span className="current-salary">
//                                 💰 {formatCurrency(candidate.currentSalary)}
//                               </span>
//                               {candidate.expectedSalary && (
//                                 <span className="expected-salary" title="Expected Salary">
//                                   → {formatCurrency(candidate.expectedSalary)}
//                                 </span>
//                               )}
//                             </>
//                           ) : (
//                             <span className="salary-na">Not specified</span>
//                           )}
//                         </div>
//                       </td>
                      
//                       <td>
//                         <div className="status-group">
//                           <span className={`status-badge ${(candidate.status || "inactive").toLowerCase()}`}>
//                             {candidate.status || "Inactive"}
//                           </span>
//                           <span className={`registration-badge ${(candidate.registrationStatus || "unregistered").toLowerCase()}`}>
//                             {candidate.registrationStatus === "Registered" ? "✓" : "✗"} 
//                             {candidate.registrationStatus === "Registered" ? " Reg" : " Unreg"}
//                           </span>
//                         </div>
//                       </td>
                      
//                       <td>
//                         <div className="action-buttons">
//                           <button
//                             onClick={() => handleView(candidate)}
//                             className="action-btn view"
//                             title="View Details"
//                           >
//                             👁️
//                           </button>
                          
//                           {/* Edit Button - Visible to both Admin and Recruiter */}
//                           {canEdit && (
//                             <button
//                               onClick={() => handleEdit(candidate)}
//                               className="action-btn edit"
//                               title="Edit"
//                             >
//                               ✏️
//                             </button>
//                           )}
                          
//                           {/* Delete Button - Only visible to Admin */}
//                           {canDelete && (
//                             <button
//                               onClick={() => handleDelete(candidate.id)}
//                               className="action-btn delete"
//                               title="Delete"
//                             >
//                               🗑️
//                             </button>
//                           )}
//                         </div>
//                        </td>
//                        </tr>
                      
//                   ))}
//                 </tbody>
//               </table>
//             </div>

//             {/* Pagination Controls */}
//             <div className="pagination-container">
//               <div className="pagination-info">
//                 Showing {indexOfFirstItem + 1} to {Math.min(indexOfLastItem, filteredCandidates.length)} of {filteredCandidates.length} entries
//               </div>
              
//               <div className="pagination-controls">
//                 <div className="items-per-page">
//                   <label>Show:</label>
//                   <select 
//                     value={itemsPerPage} 
//                     onChange={handleItemsPerPageChange}
//                     className="items-per-page-select"
//                   >
//                     {itemsPerPageOptions.map(option => (
//                       <option key={option} value={option}>{option}</option>
//                     ))}
//                   </select>
//                 </div>
                
//                 <div className="pagination-buttons">
//                   <button 
//                     onClick={goToPreviousPage} 
//                     disabled={currentPage === 1}
//                     className="pagination-btn prev"
//                   >
//                     &laquo; Previous
//                   </button>
                  
//                   <div className="page-numbers">
//                     {[...Array(totalPages)].map((_, index) => {
//                       const pageNumber = index + 1;
//                       if (
//                         pageNumber === 1 ||
//                         pageNumber === totalPages ||
//                         (pageNumber >= currentPage - 2 && pageNumber <= currentPage + 2)
//                       ) {
//                         return (
//                           <button
//                             key={pageNumber}
//                             onClick={() => paginate(pageNumber)}
//                             className={`page-number ${currentPage === pageNumber ? 'active' : ''}`}
//                           >
//                             {pageNumber}
//                           </button>
//                         );
//                       } else if (
//                         pageNumber === currentPage - 3 ||
//                         pageNumber === currentPage + 3
//                       ) {
//                         return <span key={pageNumber} className="page-ellipsis">...</span>;
//                       }
//                       return null;
//                     })}
//                   </div>
                  
//                   <button 
//                     onClick={goToNextPage} 
//                     disabled={currentPage === totalPages}
//                     className="pagination-btn next"
//                   >
//                     Next &raquo;
//                   </button>
//                 </div>
//               </div>
//             </div>
//           </>
//         ) : (
//           <div className="empty-state">
//             <div className="empty-icon">👥</div>
//             <h3>No candidates found</h3>
//             <p>Try adjusting your search or add a new candidate</p>
//             {canEdit && (
//               <button
//                 onClick={() => setShowModal(true)}
//                 className="btn-primary"
//               >
//                 + Add Candidate
//               </button>
//             )}
//           </div>
//         )}
//       </div>

//       {/* View Candidate Modal */}
//       {showViewModal && viewingCandidate && (
//         <div className="modal-overlay">
//           <div className="modal-content modal-lg">
//             <div className="modal-header">
//               <h2>Candidate Details</h2>
//               <button
//                 className="modal-close"
//                 onClick={() => {
//                   setViewingCandidate(null);
//                   setShowViewModal(false);
//                 }}
//               >
//                 ×
//               </button>
//             </div>

//             <div className="modal-body">
//               <div className="view-candidate-header">
//                 <div className="view-candidate-avatar">
//                   {getInitials(viewingCandidate.name)}
//                 </div>
//                 <div className="view-candidate-title">
//                   <h3>{viewingCandidate.name || "N/A"}</h3>
//                   <p>{viewingCandidate.currentCompany || "No current company"}</p>
//                 </div>
//                 <div className="view-candidate-badges">
//                   <span className={`status-badge ${(viewingCandidate.status || "inactive").toLowerCase()}`}>
//                     {viewingCandidate.status || "Inactive"}
//                   </span>
//                   <span className={`registration-badge ${(viewingCandidate.registrationStatus || "unregistered").toLowerCase()}`}>
//                     {viewingCandidate.registrationStatus || "Unregistered"}
//                   </span>
//                 </div>
//               </div>

//               <div className="view-details-grid">
//                 <div className="view-details-section">
//                   <h4>Contact Information</h4>
//                   <div className="view-details-row">
//                     <span className="detail-label">Email:</span>
//                     <span className="detail-value">
//                       <a href={`mailto:${viewingCandidate.email}`}>{viewingCandidate.email || "-"}</a>
//                     </span>
//                   </div>
//                   <div className="view-details-row">
//                     <span className="detail-label">Primary Phone:</span>
//                     <span className="detail-value">{viewingCandidate.phone || "-"}</span>
//                   </div>
//                   <div className="view-details-row">
//                     <span className="detail-label">Alternate Phone:</span>
//                     <span className="detail-value">{viewingCandidate.alternatePhone || "-"}</span>
//                   </div>
//                   <div className="view-details-row">
//                     <span className="detail-label">Location:</span>
//                     <span className="detail-value">{viewingCandidate.location || "-"}</span>
//                   </div>
//                 </div>

//                 <div className="view-details-section">
//                   <h4>Professional Details</h4>
//                   <div className="view-details-row">
//                     <span className="detail-label">Qualification:</span>
//                     <span className="detail-value">{viewingCandidate.qualification || "-"}</span>
//                   </div>
//                   <div className="view-details-row">
//                     <span className="detail-label">Branch:</span>
//                     <span className="detail-value">
//                       <span className={`branch-badge ${viewingCandidate.branch?.toLowerCase() || ''}`}>
//                         {viewingCandidate.branch || "-"}
//                       </span>
//                     </span>
//                   </div>
//                   <div className="view-details-row">
//                     <span className="detail-label">Experience:</span>
//                     <span className="detail-value">{viewingCandidate.experience || "-"}</span>
//                   </div>
//                   <div className="view-details-row">
//                     <span className="detail-label">Current Company:</span>
//                     <span className="detail-value">{viewingCandidate.currentCompany || "-"}</span>
//                   </div>
//                   <div className="view-details-row">
//                     <span className="detail-label">Notice Period:</span>
//                     <span className="detail-value">{viewingCandidate.noticePeriod || "-"}</span>
//                   </div>
//                 </div>

//                 <div className="view-details-section">
//                   <h4>Salary Information</h4>
//                   <div className="view-details-row">
//                     <span className="detail-label">Current Salary:</span>
//                     <span className="detail-value">{formatCurrency(viewingCandidate.currentSalary)}</span>
//                   </div>
//                   <div className="view-details-row">
//                     <span className="detail-label">Expected Salary:</span>
//                     <span className="detail-value">{formatCurrency(viewingCandidate.expectedSalary)}</span>
//                   </div>
//                 </div>

//                 <div className="view-details-section full-width">
//                   <h4>Skills</h4>
//                   <div className="skills-container">
//                     {(viewingCandidate.skills || "")
//                       .split(",")
//                       .map(s => s.trim())
//                       .filter(Boolean)
//                       .map((skill, index) => (
//                         <span key={index} className="skill-tag large">
//                           {skill}
//                         </span>
//                       ))}
//                     {!viewingCandidate.skills && <span className="detail-value">No skills added</span>}
//                   </div>
//                 </div>

//                 <div className="view-details-section full-width">
//                   <h4>Additional Information</h4>
//                   <div className="view-details-row">
//                     <span className="detail-label">Resume URL:</span>
//                     <span className="detail-value">
//                       {viewingCandidate.resumeUrl ? (
//                         <a href={viewingCandidate.resumeUrl} target="_blank" rel="noopener noreferrer">
//                           View Resume ↗
//                         </a>
//                       ) : "-"}
//                     </span>
//                   </div>
//                   <div className="view-details-row">
//                     <span className="detail-label">Created Date:</span>
//                     <span className="detail-value">{formatDate(viewingCandidate.createdDate)}</span>
//                   </div>
//                 </div>
//               </div>
//             </div>

//             <div className="modal-footer">
//               <button
//                 type="button"
//                 className="btn-secondary"
//                 onClick={() => {
//                   setViewingCandidate(null);
//                   setShowViewModal(false);
//                 }}
//               >
//                 Close
//               </button>
              
//               {/* Edit button in modal - Visible to both Admin and Recruiter */}
//               {canEdit && (
//                 <button
//                   type="button"
//                   className="btn-primary"
//                   onClick={() => {
//                     setViewingCandidate(null);
//                     setShowViewModal(false);
//                     handleEdit(viewingCandidate);
//                   }}
//                 >
//                   Edit Candidate
//                 </button>
//               )}
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Add/Edit Modal */}
//       {showModal && (
//         <div className="modal-overlay">
//           <div className="modal-content modal-lg">
//             <div className="modal-header">
//               <h2>
//                 {editingCandidate ? "Edit Candidate" : "Add New Candidate"}
//               </h2>
//               <button
//                 className="modal-close"
//                 onClick={() => {
//                   resetForm();
//                   setShowModal(false);
//                 }}
//               >
//                 ×
//               </button>
//             </div>

//             <form onSubmit={handleSubmit}>
//               <div className="modal-body">
//                 <div className="form-grid">
//                   <div className="form-group">
//                     <label>Full Name *</label>
//                     <input
//                       type="text"
//                       name="name"
//                       value={formData.name}
//                       onChange={handleInputChange}
//                       className={`form-input ${formErrors.name ? 'error' : ''}`}
//                       placeholder="John Doe"
//                     />
//                     {formErrors.name && <span className="error-message">{formErrors.name}</span>}
//                   </div>

//                   <div className="form-group">
//                     <label>Email *</label>
//                     <input
//                       type="email"
//                       name="email"
//                       value={formData.email}
//                       onChange={handleInputChange}
//                       className={`form-input ${formErrors.email ? 'error' : ''}`}
//                       placeholder="john@example.com"
//                     />
//                     {formErrors.email && <span className="error-message">{formErrors.email}</span>}
//                   </div>

//                   <div className="form-group">
//                     <label>Primary Phone</label>
//                     <input
//                       type="tel"
//                       name="phone"
//                       value={formData.phone}
//                       onChange={handleInputChange}
//                       className={`form-input ${formErrors.phone ? 'error' : ''}`}
//                       placeholder="+1 234 567 890"
//                     />
//                     {formErrors.phone && <span className="error-message">{formErrors.phone}</span>}
//                   </div>

//                   <div className="form-group">
//                     <label>Alternate Phone</label>
//                     <input
//                       type="tel"
//                       name="alternatePhone"
//                       value={formData.alternatePhone}
//                       onChange={handleInputChange}
//                       className="form-input"
//                       placeholder="+1 234 567 891"
//                     />
//                   </div>

//                   {/* Qualification - DROPDOWN */}
//                   <div className="form-group">
//                     <label>Qualification *</label>
//                     <select
//                       name="qualification"
//                       value={formData.qualification}
//                       onChange={handleInputChange}
//                       className={`form-select ${formErrors.qualification ? 'error' : ''}`}
//                     >
//                       <option value="">Select Qualification</option>
//                       {qualificationOptions.map((qual, index) => (
//                         <option key={index} value={qual}>
//                           {qual}
//                         </option>
//                       ))}
//                     </select>
//                     {formErrors.qualification && <span className="error-message">{formErrors.qualification}</span>}
//                     <span className="form-hint">
//                       Select candidate's highest qualification
//                     </span>
//                   </div>

//                   <div className="form-group">
//                     <label>Branch *</label>
//                     <select
//                       name="branch"
//                       value={formData.branch}
//                       onChange={handleInputChange}
//                       className="form-select"
//                     >
//                       <option value="Ankleshwar">Ankleshwar</option>
//                       <option value="Bharuch">Bharuch</option>
//                     </select>
//                   </div>

//                   {/* Experience - DROPDOWN */}
//                   <div className="form-group">
//                     <label>Experience *</label>
//                     <select
//                       name="experience"
//                       value={formData.experience}
//                       onChange={handleInputChange}
//                       className={`form-select ${formErrors.experience ? 'error' : ''}`}
//                     >
//                       <option value="">Select Experience</option>
//                       {experienceOptions.map((exp, index) => (
//                         <option key={index} value={exp}>
//                           {exp}
//                         </option>
//                       ))}
//                     </select>
//                     {formErrors.experience && <span className="error-message">{formErrors.experience}</span>}
//                   </div>

//                   <div className="form-group">
//                     <label>Current Company</label>
//                     <input
//                       type="text"
//                       name="currentCompany"
//                       value={formData.currentCompany}
//                       onChange={handleInputChange}
//                       className="form-input"
//                       placeholder="Current Company"
//                     />
//                   </div>

//                   <div className="form-group">
//                     <label>Current Salary (LPA)</label>
//                     <input
//                       type="text"
//                       name="currentSalary"
//                       value={formData.currentSalary}
//                       onChange={handleInputChange}
//                       className="form-input"
//                       placeholder="e.g., 12"
//                     />
//                   </div>

//                   <div className="form-group">
//                     <label>Expected Salary (LPA)</label>
//                     <input
//                       type="text"
//                       name="expectedSalary"
//                       value={formData.expectedSalary}
//                       onChange={handleInputChange}
//                       className="form-input"
//                       placeholder="e.g., 15"
//                     />
//                   </div>

//                   <div className="form-group">
//                     <label>Notice Period</label>
//                     <select
//                       name="noticePeriod"
//                       value={formData.noticePeriod}
//                       onChange={handleInputChange}
//                       className="form-select"
//                     >
//                       <option value="">Select Notice Period</option>
//                       <option value="Immediate">Immediate</option>
//                       <option value="15 days">15 days</option>
//                       <option value="30 days">30 days</option>
//                       <option value="45 days">45 days</option>
//                       <option value="60 days">60 days</option>
//                       <option value="90 days">90 days</option>
//                     </select>
//                   </div>

//                   <div className="form-group">
//                     <label>Location</label>
//                     <input
//                       type="text"
//                       name="location"
//                       value={formData.location}
//                       onChange={handleInputChange}
//                       className="form-input"
//                       placeholder="City, Country"
//                     />
//                   </div>

//                   <div className="form-group">
//                     <label>Status</label>
//                     <select
//                       name="status"
//                       value={formData.status}
//                       onChange={handleInputChange}
//                       className="form-select"
//                     >
//                       <option value="Active">Active</option>
//                       <option value="Inactive">Inactive</option>
//                       <option value="Placed">Placed</option>
//                     </select>
//                   </div>

//                   <div className="form-group">
//                     <label>Registration Status</label>
//                     <select
//                       name="registrationStatus"
//                       value={formData.registrationStatus}
//                       onChange={handleInputChange}
//                       className="form-select"
//                     >
//                       <option value="">Select Registration Status</option>
//                       <option value="Registered">Registered</option>
//                       <option value="Unregistered">Unregistered</option>
//                     </select>
//                     <span className="form-hint">
//                       If not selected, "Unregistered" will be saved by default
//                     </span>
//                   </div>

//                   {editingCandidate && (
//                     <div className="form-group">
//                       <label>Created Date</label>
//                       <input
//                         type="datetime-local"
//                         name="createdDate"
//                         value={formData.createdDate}
//                         onChange={handleInputChange}
//                         className={`form-input ${formErrors.createdDate ? 'error' : ''}`}
//                       />
//                       {formErrors.createdDate && <span className="error-message">{formErrors.createdDate}</span>}
//                       <span className="form-hint">
//                         Cannot select a future date
//                       </span>
//                     </div>
//                   )}
//                 </div>

//                 {/* Skills - Optional */}
//                 <div className="form-group">
//                   <label>Skills (Optional)</label>
//                   <textarea
//                     name="skills"
//                     value={formData.skills}
//                     onChange={handleInputChange}
//                     className="form-textarea"
//                     placeholder="React, JavaScript, Node.js (comma separated)"
//                     rows="3"
//                   />
//                   <span className="form-hint">
//                     Enter skills separated by commas (optional)
//                   </span>
//                 </div>

//                 <div className="form-group">
//                   <label>Resume URL</label>
//                   <input
//                     type="url"
//                     name="resumeUrl"
//                     value={formData.resumeUrl}
//                     onChange={handleInputChange}
//                     className="form-input"
//                     placeholder="https://example.com/resume.pdf"
//                   />
//                 </div>
//               </div>

//               <div className="modal-footer">
//                 <button
//                   type="button"
//                   className="btn-secondary"
//                   onClick={() => {
//                     resetForm();
//                     setShowModal(false);
//                   }}
//                 >
//                   Cancel
//                 </button>
//                 <button type="submit" className="btn-primary">
//                   {editingCandidate ? "Update Candidate" : "Save Candidate"}
//                 </button>
//               </div>
//             </form>
//           </div>
//         </div>
//       )}

//       {/* Excel Import Modal - Only visible to Admin */}
//       {showImportModal && isAdmin && (
//         <div className="modal-overlay">
//           <div className="modal-content modal-lg">
//             <div className="modal-header">
//               <h2>Import Candidates from Excel</h2>
//               <button
//                 className="modal-close"
//                 onClick={() => {
//                   resetImport();
//                   setShowImportModal(false);
//                 }}
//               >
//                 ×
//               </button>
//             </div>

//             <div className="modal-body">
//               {importStep === 'upload' && (
//                 <div className="import-upload-section">
//                   <div className="import-instructions">
//                     <h3>Instructions:</h3>
//                     <ul>
//                       <li>Download the template file first</li>
//                       <li>Fill in your candidate data</li>
//                       <li>Required columns: Name, Email, Experience, Qualification</li>
//                       <li>Skills column is optional</li>
//                       <li>Branch must be either "Ankleshwar" or "Bharuch"</li>
//                       <li>Registration Status: Leave empty to default to "Unregistered"</li>
//                       <li>Upload the filled Excel file (.xlsx, .xls)</li>
//                     </ul>
//                   </div>

//                   <div className="import-actions">
//                     <button
//                       onClick={downloadTemplate}
//                       className="btn-secondary"
//                     >
//                       📥 Download Template
//                     </button>
                    
//                     <div className="file-upload-area">
//                       <input
//                         type="file"
//                         ref={fileInputRef}
//                         accept=".xlsx,.xls,.csv"
//                         onChange={handleFileUpload}
//                         className="file-input"
//                         id="excel-upload"
//                       />
//                       <label htmlFor="excel-upload" className="file-upload-label">
//                         {importLoading ? 'Processing...' : 'Choose Excel File'}
//                       </label>
//                     </div>
//                   </div>

//                   {importLoading && (
//                     <div className="import-loading">
//                       <div className="spinner-small"></div>
//                       <p>Processing file...</p>
//                     </div>
//                   )}
//                 </div>
//               )}

//               {importStep === 'preview' && (
//                 <div className="import-preview-section">
//                   <div className="import-summary">
//                     <h3>Import Summary</h3>
//                     <div className="summary-stats">
//                       <div className="stat-item success">
//                         <span className="stat-value">{importData.length}</span>
//                         <span className="stat-label">Valid Records</span>
//                       </div>
//                       <div className="stat-item error">
//                         <span className="stat-value">{importErrors.length}</span>
//                         <span className="stat-label">Errors</span>
//                       </div>
//                     </div>
//                   </div>

//                   {importErrors.length > 0 && (
//                     <div className="import-errors">
//                       <h4>Errors Found:</h4>
//                       <div className="errors-list">
//                         {importErrors.map((error, idx) => (
//                           <div key={idx} className="error-item">
//                             <strong>Row {error.row}:</strong> {error.name} - {error.errors.join(', ')}
//                           </div>
//                         ))}
//                       </div>
//                     </div>
//                   )}

//                   {importData.length > 0 && (
//                     <div className="import-preview">
//                       <h4>Preview (First 5 Records)</h4>
//                       <div className="preview-table-container">
//                         <table className="preview-table">
//                           <thead>
//                             <tr>
//                               <th>Name</th>
//                               <th>Email</th>
//                               <th>Qualification</th>
//                               <th>Branch</th>
//                               <th>Skills</th>
//                               <th>Experience</th>
//                               <th>Status</th>
//                               <th>Registration Status</th>
//                             </tr>
//                           </thead>
//                           <tbody>
//                             {importData.slice(0, 5).map((candidate, idx) => (
//                               <tr key={idx}>
//                                 <td>{candidate.name}</td>
//                                 <td>{candidate.email}</td>
//                                 <td>{candidate.qualification || '-'}</td>
//                                 <td>
//                                   <span className={`branch-badge ${candidate.branch?.toLowerCase()}`}>
//                                     {candidate.branch}
//                                   </span>
//                                 </td>
//                                 <td>{candidate.skills || '-'}</td>
//                                 <td>{candidate.experience}</td>
//                                 <td>
//                                   <span className={`status-badge ${candidate.status.toLowerCase()}`}>
//                                     {candidate.status}
//                                   </span>
//                                 </td>
//                                 <td>
//                                   <span className={`registration-badge ${(candidate.registrationStatus || 'unregistered').toLowerCase()}`}>
//                                     {candidate.registrationStatus || 'Unregistered'}
//                                   </span>
//                                 </td>
//                               </tr>
//                             ))}
//                           </tbody>
//                         </table>
//                       </div>
//                     </div>
//                   )}
//                 </div>
//               )}

//               {importStep === 'complete' && (
//                 <div className="import-complete">
//                   <div className="success-icon">✅</div>
//                   <h3>Import Successful!</h3>
//                   <p>{importData.length} candidates have been added.</p>
//                 </div>
//               )}
//             </div>

//             {importStep === 'preview' && (
//               <div className="modal-footer">
//                 <button
//                   type="button"
//                   className="btn-secondary"
//                   onClick={resetImport}
//                 >
//                   Back
//                 </button>
//                 <button
//                   type="button"
//                   className="btn-primary"
//                   onClick={handleImportConfirm}
//                   disabled={importData.length === 0 || importLoading}
//                 >
//                   {importLoading ? 'Importing...' : `Import ${importData.length} Candidates`}
//                 </button>
//               </div>
//             )}
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default Candidates;


































// import React, { useState, useEffect, useRef } from "react";
// import * as XLSX from "xlsx";

// import { getCandidates, createCandidate, updateCandidate, deleteCandidate } from "../../services/api";

// import { useAuth } from "../../contexts/AuthContext";

// import "./Candidates.css";

// const Candidates = () => {
//   // Get current user from AuthContext
//   const { currentUser } = useAuth();
  
//   const [candidates, setCandidates] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [showModal, setShowModal] = useState(false);
//   const [showViewModal, setShowViewModal] = useState(false);
//   const [viewingCandidate, setViewingCandidate] = useState(null);
//   const [editingCandidate, setEditingCandidate] = useState(null);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [filterSkills, setFilterSkills] = useState("all");
//   const [filterExperience, setFilterExperience] = useState("all");
//   const [filterStatus, setFilterStatus] = useState("all");
//   const [filterRegistration, setFilterRegistration] = useState("all");
//   const [filterQualification, setFilterQualification] = useState("all");
//   const [filterBranch, setFilterBranch] = useState("all");
//   const [sortOrder, setSortOrder] = useState("newest");
//   const [formErrors, setFormErrors] = useState({});
//   const [isHeaderScrolled, setIsHeaderScrolled] = useState(false);
  
//   // Pagination states
//   const [currentPage, setCurrentPage] = useState(1);
//   const [itemsPerPage, setItemsPerPage] = useState(10);
//   const [itemsPerPageOptions] = useState([5, 10, 25, 50, 100]);
  
//   // Excel import states
//   const [showImportModal, setShowImportModal] = useState(false);
//   const [importData, setImportData] = useState([]);
//   const [importErrors, setImportErrors] = useState([]);
//   const [importLoading, setImportLoading] = useState(false);
//   const [importStep, setImportStep] = useState('upload');
//   const fileInputRef = useRef(null);
//   const headerRef = useRef(null);

//   // Check user roles
//   const isAdmin = currentUser && currentUser.role === "admin";
//   const isRecruiter = currentUser && currentUser.role === "recruiter";
//   const canEdit = isAdmin || isRecruiter;
//   const canDelete = isAdmin;

//   // Qualification options
//   const qualificationOptions = [
//     "SSC (10th Pass)",
//     "HSC (12th Science)",
//     "HSC (12th Commerce)",
//     "HSC (12th Arts)",
//     "ITI AOCP Certification",
//     "ITI - Fitter",
//     "ITI - Electrician",
//     "ITI - Welder",
//     "ITI - Turner",
//     "ITI - Machinist",
//     "ITI - Instrument Mechanic",
//     "ITI - Draughtsman (Mechanical)",
//     "ITI - Draughtsman (Civil)",
//     "ITI - Diesel Mechanic",
//     "ITI - Motor Mechanic",
//     "ITI - Refrigeration & Air Conditioning",
//     "ITI - Plumber",
//     "ITI - COPA (Computer Operator & Programming Assistant)",
//     "ITI - RFM (Refinery & Maintenance Mechanic)",
//     "ITI - Pump Operator",
//     "ITI - Boiler Attendant",
//     "ITI - Fire & Safety",
//     "Diploma - Mechanical Engineering",
//     "Diploma - Electrical Engineering",
//     "Diploma - Chemical Engineering",
//     "Diploma - Instrumentation",
//     "Diploma - Civil Engineering",
//     "Diploma - Automobile Engineering",
//     "Diploma - Production Engineering",
//     "Diploma - Plastic Technology",
//     "Diploma - Petrochemical Engineering",
//     "Diploma - Industrial Safety",
//     "B.E. - Mechanical Engineering",
//     "B.E. - Electrical Engineering",
//     "B.E. - Chemical Engineering",
//     "B.E. - Instrumentation Engineering",
//     "B.E. - Civil Engineering",
//     "B.E. - Automobile Engineering",
//     "B.E. - Production Engineering",
//     "B.E. - Petrochemical Engineering",
//     "B.Sc - Chemistry",
//     "B.Sc - Physics",
//     "B.Sc - Mathematics",
//     "B.Sc - Industrial Chemistry",
//     "B.Sc - Environmental Science",
//     "B.Sc - Microbiology",
//     "B.Com (Bachelor of Commerce)",
//     "BBA (Bachelor of Business Administration)",
//     "MBA - Human Resources",
//     "MBA - Marketing",
//     "MBA - Finance",
//     "MBA - Operations",
//     "BCA (Bachelor of Computer Applications)",
//     "MCA (Master of Computer Applications)",
//     "Diploma - Computer Applications",
//     "M.Tech - Mechanical Engineering",
//     "M.Tech - Chemical Engineering",
//     "M.Tech - Electrical Engineering",
//     "M.Tech - Instrumentation Engineering",
//     "M.Sc - Chemistry",
//     "M.Sc - Environmental Science",
//     "PDIS (Professional Diploma in Industrial Safety)",
//     "ADIS (Advanced Diploma in Industrial Safety)",
//     "NEBOSH - IGC",
//     "NEBOSH - Diploma",
//     "IOSH Certification",
//     "Diploma - Fire & Safety",
//     "Industrial Safety Certification",
//     "LACP Certification",
//     "Boiler Operation Certificate",
//     "First Aid Certification",
//     "Quality Control Certification",
//     "NDT Level II",
//     "NDT Level III",
//     "PhD (Doctor of Philosophy)",
//     "Other"
//   ];

//   const experienceOptions = [
//     "Fresher",
//     "1 year",
//     "2 years",
//     "3 years",
//     "4 years",
//     "5 years",
//     "6 years",
//     "7 years",
//     "8 years",
//     "9 years",
//     "10 years",
//     "11 years",
//     "12 years",
//     "13 years",
//     "14 years",
//     "15 years"
//   ];

//   const [formData, setFormData] = useState({
//     name: "",
//     email: "",
//     phone: "",
//     alternatePhone: "",
//     skills: "",
//     experience: "",
//     qualification: "",
//     branch: "Ankleshwar",
//     currentCompany: "",
//     currentSalary: "",
//     expectedSalary: "",
//     noticePeriod: "",
//     location: "",
//     resumeUrl: "",
//     status: "Active",
//     registrationStatus: "",
//     createdDate: new Date().toISOString().slice(0, 16),
//   });

//   useEffect(() => {
//     loadCandidates();
    
//     const handleScroll = () => {
//       if (headerRef.current) {
//         const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
//         setIsHeaderScrolled(scrollTop > 50);
//       }
//     };

//     window.addEventListener('scroll', handleScroll);
//     return () => window.removeEventListener('scroll', handleScroll);
//   }, []);

//   useEffect(() => {
//     setCurrentPage(1);
//   }, [searchTerm, filterSkills, filterExperience, filterStatus, 
//       filterRegistration, filterQualification, filterBranch, sortOrder]);

//   const loadCandidates = async () => {
//     setLoading(true);
//     try {
//       const res = await getCandidates();
//       const normalizedCandidates = res.data.map(candidate => ({
//         ...candidate,
//         registrationStatus: candidate.registrationStatus || "Unregistered"
//       }));
//       setCandidates(normalizedCandidates);
//     } catch (error) {
//       console.error(error);
//     }
//     setLoading(false);
//   };

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({ ...prev, [name]: value }));
//     if (formErrors[name]) {
//       setFormErrors(prev => ({ ...prev, [name]: "" }));
//     }
//   };

//   const isDateNotInFuture = (dateString) => {
//     if (!dateString) return true;
//     const selectedDate = new Date(dateString);
//     const currentDate = new Date();
//     selectedDate.setHours(0, 0, 0, 0);
//     currentDate.setHours(0, 0, 0, 0);
//     return selectedDate <= currentDate;
//   };

//   const validateForm = () => {
//     const errors = {};
    
//     if (!formData.name || formData.name.trim() === "") {
//       errors.name = "Name is required";
//     }
    
//     if (!formData.email || formData.email.trim() === "") {
//       errors.email = "Email is required";
//     } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
//       errors.email = "Email is invalid";
//     }
    
//     if (!formData.experience || formData.experience === "") {
//       errors.experience = "Experience is required";
//     }
    
//     if (!formData.qualification || formData.qualification === "") {
//       errors.qualification = "Qualification is required";
//     }
    
//     if (formData.phone && !/^[\d\s\+\-\(\)]{10,}$/.test(formData.phone)) {
//       errors.phone = "Please enter a valid phone number";
//     }

//     if (editingCandidate && formData.createdDate) {
//       if (!isDateNotInFuture(formData.createdDate)) {
//         errors.createdDate = "Created date cannot be in the future";
//       }
//     }

//     setFormErrors(errors);
//     return Object.keys(errors).length === 0;
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (!validateForm()) {
//       return;
//     }

//     const candidateData = {
//       ...formData,
//       registrationStatus: formData.registrationStatus || "Unregistered",
//       id: editingCandidate ? editingCandidate.id : Date.now().toString(),
//       createdDate: editingCandidate ? formData.createdDate : new Date().toISOString(),
//       skills: formData.skills ? formData.skills.split(',').map(s => s.trim()).filter(Boolean).join(', ') : "",
//     };

//     if (editingCandidate) {
//       await updateCandidate(editingCandidate.id, candidateData);
//     } else {
//       await createCandidate(candidateData);
//     }

//     resetForm();
//     loadCandidates();
//     setShowModal(false);
//   };

//   const handleView = (candidate) => {
//     setViewingCandidate(candidate);
//     setShowViewModal(true);
//   };

//   const handleEdit = (candidate) => {
//     if (!canEdit) {
//       alert("You don't have permission to edit candidates");
//       return;
//     }
    
//     let formattedDate = candidate.createdDate;
//     if (candidate.createdDate) {
//       const date = new Date(candidate.createdDate);
//       if (!isNaN(date.getTime())) {
//         formattedDate = date.toISOString().slice(0, 16);
//       }
//     }
    
//     setEditingCandidate(candidate);
//     setFormData({
//       ...candidate,
//       skills: candidate.skills || "",
//       createdDate: formattedDate,
//     });
//     setShowModal(true);
//   };

//   const handleDelete = async (id) => {
//     if (!isAdmin) {
//       alert("You don't have permission to delete candidates");
//       return;
//     }
//     if (window.confirm("Are you sure you want to delete this candidate?")) {
//       await deleteCandidate(id);
//       loadCandidates();
//     }
//   };

//   const resetForm = () => {
//     setFormData({
//       name: "",
//       email: "",
//       phone: "",
//       alternatePhone: "",
//       skills: "",
//       experience: "",
//       qualification: "",
//       branch: "Ankleshwar",
//       currentCompany: "",
//       currentSalary: "",
//       expectedSalary: "",
//       noticePeriod: "",
//       location: "",
//       resumeUrl: "",
//       status: "Active",
//       registrationStatus: "",
//       createdDate: new Date().toISOString().slice(0, 16),
//     });
//     setEditingCandidate(null);
//     setFormErrors({});
//   };

//   // ===== HELPER FUNCTIONS =====
//   const findColumnIndex = (headers, possibleNames) => {
//     for (let i = 0; i < headers.length; i++) {
//       if (possibleNames.some(name => headers[i].includes(name))) {
//         return i;
//       }
//     }
//     return -1;
//   };

//   const getCellValue = (row, index) => {
//     if (index === -1 || index >= row.length) return '';
//     const value = row[index];
//     return value !== undefined && value !== null ? String(value).trim() : '';
//   };

//   const mapStatus = (value) => {
//     if (!value) return 'Active';
//     const status = value.toLowerCase();
//     if (status.includes('inactive')) return 'Inactive';
//     if (status.includes('placed')) return 'Placed';
//     return 'Active';
//   };

//   const mapRegistrationStatus = (value) => {
//     if (!value) return '';
//     const reg = value.toLowerCase();
//     if (reg.includes('unreg')) return 'Unregistered';
//     if (reg.includes('reg')) return 'Registered';
//     return '';
//   };

//   const isValidUrl = (url) => {
//     if (!url) return true;
//     try {
//       new URL(url);
//       return true;
//     } catch (e) {
//       return false;
//     }
//   };

//   // ===== EXCEL IMPORT FUNCTIONS =====
  
//   const handleFileUpload = (e) => {
//     const file = e.target.files[0];
//     if (!file) return;

//     setImportLoading(true);
//     setImportErrors([]);

//     const reader = new FileReader();
//     reader.onload = (event) => {
//       try {
//         const data = new Uint8Array(event.target.result);
//         const workbook = XLSX.read(data, { type: 'array' });
        
//         const sheetName = workbook.SheetNames[0];
//         const worksheet = workbook.Sheets[sheetName];
        
//         const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
        
//         const parsedData = parseExcelData(jsonData);
//         setImportData(parsedData.validData);
//         setImportErrors(parsedData.errors);
        
//         if (parsedData.validData.length > 0) {
//           setImportStep('preview');
//         }
//       } catch (error) {
//         setImportErrors([{ row: 0, error: 'Failed to parse Excel file: ' + error.message }]);
//       } finally {
//         setImportLoading(false);
//       }
//     };
    
//     reader.readAsArrayBuffer(file);
//   };

//   const parseExcelData = (rows) => {
//     if (rows.length < 2) {
//       return { validData: [], errors: [{ row: 0, error: 'File is empty or has no data rows' }] };
//     }

//     const headers = rows[0].map(h => String(h || '').toLowerCase().trim());
    
//     const fieldMap = {
//       name: findColumnIndex(headers, ['name', 'full name', 'candidate name']),
//       email: findColumnIndex(headers, ['email', 'e-mail', 'email address']),
//       phone: findColumnIndex(headers, ['phone', 'mobile', 'contact', 'phone number']),
//       alternatePhone: findColumnIndex(headers, ['alternate phone', 'alt phone', 'secondary phone']),
//       skills: findColumnIndex(headers, ['skills', 'skill', 'technologies']),
//       experience: findColumnIndex(headers, ['experience', 'exp', 'total experience', 'years']),
//       qualification: findColumnIndex(headers, ['qualification', 'education', 'degree']),
//       branch: findColumnIndex(headers, ['branch', 'location branch', 'office']),
//       currentCompany: findColumnIndex(headers, ['current company', 'company', 'employer']),
//       currentSalary: findColumnIndex(headers, ['current salary', 'current ctc', 'salary']),
//       expectedSalary: findColumnIndex(headers, ['expected salary', 'expected ctc', 'expectation']),
//       noticePeriod: findColumnIndex(headers, ['notice period', 'notice', 'np']),
//       location: findColumnIndex(headers, ['location', 'city', 'place']),
//       status: findColumnIndex(headers, ['status']),
//       registrationStatus: findColumnIndex(headers, ['registration status', 'registration', 'reg status']),
//       resumeUrl: findColumnIndex(headers, ['resume link', 'resume url', 'resume', 'cv link', 'cv url'])
//     };

//     const validData = [];
//     const errors = [];

//     for (let i = 1; i < rows.length; i++) {
//       const row = rows[i];
//       if (!row || row.length === 0 || row.every(cell => !cell)) continue;

//       const branchValue = getCellValue(row, fieldMap.branch);
//       const validBranch = branchValue && ['Ankleshwar', 'Bharuch'].includes(branchValue) 
//         ? branchValue 
//         : 'Ankleshwar';

//       const registrationStatusValue = getCellValue(row, fieldMap.registrationStatus);
//       const resumeUrlValue = getCellValue(row, fieldMap.resumeUrl);
      
//       const candidate = {
//         id: Date.now().toString() + i,
//         createdDate: new Date().toISOString(),
//         name: getCellValue(row, fieldMap.name) || '',
//         email: getCellValue(row, fieldMap.email) || '',
//         phone: getCellValue(row, fieldMap.phone) || '',
//         alternatePhone: getCellValue(row, fieldMap.alternatePhone) || '',
//         skills: getCellValue(row, fieldMap.skills) || '',
//         experience: getCellValue(row, fieldMap.experience) || '',
//         qualification: getCellValue(row, fieldMap.qualification) || '',
//         branch: validBranch,
//         currentCompany: getCellValue(row, fieldMap.currentCompany) || '',
//         currentSalary: getCellValue(row, fieldMap.currentSalary) || '',
//         expectedSalary: getCellValue(row, fieldMap.expectedSalary) || '',
//         noticePeriod: getCellValue(row, fieldMap.noticePeriod) || '',
//         location: getCellValue(row, fieldMap.location) || '',
//         status: mapStatus(getCellValue(row, fieldMap.status)) || 'Active',
//         registrationStatus: mapRegistrationStatus(registrationStatusValue) || "Unregistered",
//         resumeUrl: resumeUrlValue || ''
//       };

//       if (candidate.resumeUrl && !isValidUrl(candidate.resumeUrl)) {
//         console.warn(`Row ${i + 1}: Invalid URL format for resume link: ${candidate.resumeUrl}`);
//       }

//       const rowErrors = [];
//       if (!candidate.name) rowErrors.push('Name is required');
//       if (!candidate.email) rowErrors.push('Email is required');
//       else if (!/\S+@\S+\.\S+/.test(candidate.email)) rowErrors.push('Invalid email format');
//       if (!candidate.experience) rowErrors.push('Experience is required');
//       if (!candidate.qualification) rowErrors.push('Qualification is required');

//       if (rowErrors.length > 0) {
//         errors.push({
//           row: i + 1,
//           name: candidate.name || 'Unknown',
//           errors: rowErrors
//         });
//       } else {
//         validData.push(candidate);
//       }
//     }

//     return { validData, errors };
//   };

//   const handleImportConfirm = async () => {
//     setImportLoading(true);

//     try {
//       for (const candidate of importData) {
//         const candidateToSave = {
//           ...candidate,
//           registrationStatus: candidate.registrationStatus || "Unregistered"
//         };
//         await createCandidate(candidateToSave);
//       }

//       loadCandidates();
//       setImportStep('complete');

//       setTimeout(() => {
//         resetImport();
//         setShowImportModal(false);
//       }, 2000);

//     } catch (error) {
//       setImportErrors([{ row: 0, error: 'Failed to save candidates: ' + error.message }]);
//     }

//     setImportLoading(false);
//   };

//   const resetImport = () => {
//     setImportData([]);
//     setImportErrors([]);
//     setImportStep('upload');
//     if (fileInputRef.current) {
//       fileInputRef.current.value = '';
//     }
//   };

//   const downloadTemplate = () => {
//     const template = [
//       ['Name', 'Email', 'Phone', 'Alternate Phone', 'Skills', 'Experience', 'Qualification', 'Branch', 'Current Company', 'Current Salary', 'Expected Salary', 'Notice Period', 'Location', 'Status', 'Registration Status', 'Resume Link'],
//       ['John Doe', 'john@example.com', '+1234567890', '+1234567891', 'React, JavaScript, Node.js', '3 years', 'B.E. - Mechanical Engineering', 'Ankleshwar', 'Tech Corp', '12', '15', '30 days', 'New York', 'Active', 'Registered', 'https://example.com/resume/john_doe.pdf']
     
//     ];

//     const wb = XLSX.utils.book_new();
//     const ws = XLSX.utils.aoa_to_sheet(template);
    
//     ws['!cols'] = [
//       { wch: 20 }, // Name
//       { wch: 25 }, // Email
//       { wch: 15 }, // Phone
//       { wch: 15 }, // Alternate Phone
//       { wch: 30 }, // Skills
//       { wch: 12 }, // Experience
//       { wch: 30 }, // Qualification
//       { wch: 12 }, // Branch
//       { wch: 20 }, // Current Company
//       { wch: 15 }, // Current Salary
//       { wch: 15 }, // Expected Salary
//       { wch: 12 }, // Notice Period
//       { wch: 20 }, // Location
//       { wch: 10 }, // Status
//       { wch: 15 }, // Registration Status
//       { wch: 40 }  // Resume Link
//     ];
    
//     XLSX.utils.book_append_sheet(wb, ws, 'Candidate_Template');
//     XLSX.writeFile(wb, 'candidate_import_template.xlsx');
//   };

//   // Filter and sort candidates
//   const filteredCandidates = candidates
//     .filter((candidate) => {
//       const search = searchTerm.toLowerCase();
//       const name = candidate.name?.toLowerCase() || "";
//       const email = candidate.email?.toLowerCase() || "";
//       const skills = candidate.skills?.toLowerCase() || "";
//       const company = candidate.currentCompany?.toLowerCase() || "";
//       const qualification = candidate.qualification?.toLowerCase() || "";

//       const matchesSearch = !searchTerm || 
//         name.includes(search) ||
//         email.includes(search) ||
//         skills.includes(search) ||
//         company.includes(search) ||
//         qualification.includes(search);

//       const matchesSkills = filterSkills === "all" || 
//         (candidate.skills?.toLowerCase() || "").includes(filterSkills.toLowerCase());

//       const matchesExperience = filterExperience === "all" || 
//         candidate.experience === filterExperience;

//       const normalize = (val) => (val || "").toLowerCase().trim();

//       const matchesStatus =
//         filterStatus === "all" ||
//         normalize(candidate.status) === normalize(filterStatus);

//       let matchesRegistration = true;
//       if (filterRegistration !== "all") {
//         const candidateRegStatus = candidate.registrationStatus || "Unregistered";
//         matchesRegistration = normalize(candidateRegStatus) === normalize(filterRegistration);
//       }

//       const matchesQualification = filterQualification === "all" || 
//         candidate.qualification === filterQualification;

//       const matchesBranch = filterBranch === "all" || 
//         candidate.branch === filterBranch;

//       return matchesSearch && matchesSkills && matchesExperience && 
//              matchesStatus && matchesRegistration && 
//              matchesQualification && matchesBranch;
//     })
//     .sort((a, b) => {
//       const dateA = new Date(a.createdDate);
//       const dateB = new Date(b.createdDate);
//       const timeA = isNaN(dateA.getTime()) ? 0 : dateA.getTime();
//       const timeB = isNaN(dateB.getTime()) ? 0 : dateB.getTime();
//       return sortOrder === "newest" ? timeB - timeA : timeA - timeB;
//     });

//   // Pagination logic
//   const indexOfLastItem = currentPage * itemsPerPage;
//   const indexOfFirstItem = indexOfLastItem - itemsPerPage;
//   const currentItems = filteredCandidates.slice(indexOfFirstItem, indexOfLastItem);
//   const totalPages = Math.ceil(filteredCandidates.length / itemsPerPage);

//   const paginate = (pageNumber) => setCurrentPage(pageNumber);
  
//   const goToPreviousPage = () => {
//     if (currentPage > 1) {
//       setCurrentPage(currentPage - 1);
//     }
//   };
  
//   const goToNextPage = () => {
//     if (currentPage < totalPages) {
//       setCurrentPage(currentPage + 1);
//     }
//   };
  
//   const handleItemsPerPageChange = (e) => {
//     setItemsPerPage(Number(e.target.value));
//     setCurrentPage(1);
//   };

//   const allSkills = [
//     ...new Set(
//       candidates.flatMap((c) =>
//         (c.skills || "")
//           .split(",")
//           .map((s) => s.trim())
//           .filter(Boolean)
//       )
//     ),
//   ];

//   const allQualifications = [
//     ...new Set(candidates.map((c) => c.qualification).filter(Boolean)),
//   ];

//   const experienceLevels = [
//     ...new Set(candidates.map((c) => c.experience).filter(Boolean)),
//   ];

//   const activeCandidates = candidates.filter(
//     (c) => c.status === "Active"
//   ).length;
  
//   const registeredCandidates = candidates.filter(
//     (c) => (c.registrationStatus || "Unregistered") === "Registered"
//   ).length;

//   const ankleshwarCandidates = candidates.filter(
//     (c) => c.branch === "Ankleshwar"
//   ).length;

//   const bharuchCandidates = candidates.filter(
//     (c) => c.branch === "Bharuch"
//   ).length;

//   const getInitials = (name) => {
//     if (!name) return "?";
//     return name
//       .split(" ")
//       .map((n) => n[0])
//       .join("")
//       .toUpperCase()
//       .slice(0, 2);
//   };

//   const formatDate = (dateString) => {
//     if (!dateString) return "-";
//     try {
//       const date = new Date(dateString);
//       const options = { year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' };
//       return date.toLocaleDateString(undefined, options);
//     } catch (e) {
//       return dateString;
//     }
//   };

//   const formatCurrency = (value) => {
//     if (!value) return "-";
//     return `₹${value}`;
//   };

//   if (loading) {
//     return (
//       <div className="loading-container">
//         <div className="spinner"></div>
//         <p>Loading candidates...</p>
//       </div>
//     );
//   }

//   return (
//     <div className="candidates-page">
//       <div id="candidates-top"></div>

//       <div 
//         ref={headerRef}
//         className={`page-header ${isHeaderScrolled ? 'scrolled' : ''}`}
//       >
//         <div className='comp'>
//           <h1>Candidates</h1>
//           <p>Manage candidate profiles and information</p>
//           {!canEdit && (
//             <small style={{ color: '#666', fontSize: '12px' }}>View Only Mode</small>
//           )}
//           {isRecruiter && (
//             <small style={{ color: '#4CAF50', fontSize: '12px' }}>Recruiter Mode - Can Edit</small>
//           )}
//           {isAdmin && (
//             <small style={{ color: '#2196F3', fontSize: '12px' }}>Admin Mode - Full Access</small>
//           )}
//         </div>
//         {/* <div className="header-actions">
//           {isAdmin && (
//             <button
//               onClick={() => setShowImportModal(true)}
//               className="btn-secondary"
//               title="Import from Excel"
//             >
//               📥 Import Excel
//             </button>
//           )}
//           {canEdit && (
//             <button
//               onClick={() => setShowModal(true)}
//               className="btn-primary"
//             >
//               + Add Candidate
//             </button>
//           )}
//         </div> */}


// <div className="header-actions">
//   {/* Show Import button for both Admin and Recruiter */}
//   {(isAdmin || isRecruiter) && (
//     <button
//       onClick={() => setShowImportModal(true)}
//       className="btn-secondary"
//       title="Import from Excel"
//     >
//       📥 Import Excel
//     </button>
//   )}
//   {/* Show Add button for both Admin and Recruiter */}
//   {canEdit && (
//     <button
//       onClick={() => setShowModal(true)}
//       className="btn-primary"
//     >
//       + Add Candidate
//     </button>
//   )}
// </div>





//       </div>

//       {/* Stats Cards */}
//       <div className="stats-cards">
//         <div className="stat-card">
//           <div className="stat-icon">👥</div>
//           <div className="stat-content">
//             <h3>{candidates.length}</h3>
//             <p>Total Candidates</p>
//           </div>
//         </div>
//         <div className="stat-card">
//           <div className="stat-icon">✅</div>
//           <div className="stat-content">
//             <h3>{activeCandidates}</h3>
//             <p>Active Candidates</p>
//           </div>
//         </div>
//         <div className="stat-card">
//           <div className="stat-icon">📝</div>
//           <div className="stat-content">
//             <h3>{registeredCandidates}</h3>
//             <p>Registered</p>
//           </div>
//         </div>
//         <div className="stat-card">
//           <div className="stat-icon">🏢</div>
//           <div className="stat-content">
//             <h3>{ankleshwarCandidates} | {bharuchCandidates}</h3>
//             <p>Ankleshwar | Bharuch</p>
//           </div>
//         </div>
//       </div>

//       {/* Filters */}
//       <div className="filters-section">
//         <div className="search-box">
//           <span className="search-icon">🔍</span>
//           <input
//             type="text"
//             placeholder="Search candidates..."
//             value={searchTerm}
//             onChange={(e) => setSearchTerm(e.target.value)}
//             className="search-input"
//           />
//         </div>

//         <div className="filter-controls">
//           <select
//             value={filterQualification}
//             onChange={(e) => setFilterQualification(e.target.value)}
//             className="filter-select"
//           >
//             <option value="all">All Qualifications</option>
//             {allQualifications.map((qual) => (
//               <option key={qual} value={qual}>
//                 {qual}
//               </option>
//             ))}
//           </select>

//           <select
//             value={filterBranch}
//             onChange={(e) => setFilterBranch(e.target.value)}
//             className="filter-select"
//           >
//             <option value="all">All Branches</option>
//             <option value="Ankleshwar">Ankleshwar</option>
//             <option value="Bharuch">Bharuch</option>
//           </select>

//           <select
//             value={filterSkills}
//             onChange={(e) => setFilterSkills(e.target.value)}
//             className="filter-select"
//           >
//             <option value="all">All Skills</option>
//             {allSkills.map((skill) => (
//               <option key={skill} value={skill}>
//                 {skill}
//               </option>
//             ))}
//           </select>

//           <select
//             value={filterExperience}
//             onChange={(e) => setFilterExperience(e.target.value)}
//             className="filter-select"
//           >
//             <option value="all">All Experience</option>
//             {experienceLevels.map((exp) => (
//               <option key={exp} value={exp}>
//                 {exp}
//               </option>
//             ))}
//           </select>

//           <select
//             value={filterStatus}
//             onChange={(e) => setFilterStatus(e.target.value)}
//             className="filter-select"
//           >
//             <option value="all">All Status</option>
//             <option value="Active">Active</option>
//             <option value="Inactive">Inactive</option>
//             <option value="Placed">Placed</option>
//           </select>

//           <select
//             value={filterRegistration}
//             onChange={(e) => setFilterRegistration(e.target.value)}
//             className="filter-select"
//           >
//             <option value="all">All Registration</option>
//             <option value="Registered">Registered</option>
//             <option value="Unregistered">Unregistered</option>
//           </select>

//           <select
//             value={sortOrder}
//             onChange={(e) => setSortOrder(e.target.value)}
//             className="filter-select"
//           >
//             <option value="newest">Newest First</option>
//             <option value="oldest">Oldest First</option>
//           </select>
//         </div>
//       </div>

//       {/* Table */}
//       <div className="table-container">
//         {filteredCandidates.length > 0 ? (
//           <>
//             <div className="table-responsive">
//               <table className="data-table">
//                 <thead>
//                   <tr>
//                     <th>Candidate</th>
//                     <th>Qualification</th>
//                     <th>Branch</th>
//                     <th>Skills & Experience</th>
//                     <th>Contact</th>
//                     <th>Salary</th>
//                     <th>Status</th>
//                     <th>Actions</th>
//                   </tr>
//                 </thead>

//                 <tbody>
//                   {currentItems.map((candidate) => (
//                     <tr key={candidate.id}>
//                       <td>
//                         <div className="candidate-cell">
//                           <div className="candidate-avatar">
//                             {getInitials(candidate.name)}
//                           </div>
//                           <div>
//                             <div className="candidate-name">
//                               {candidate.name || "N/A"}
//                             </div>
//                             <div className="candidate-company">
//                               {candidate.currentCompany || "Not Specified"}
//                             </div>
//                             <div className="candidate-meta">
//                               📅 {formatDate(candidate.createdDate)}
//                             </div>
//                           </div>
//                         </div>
//                       </td>
                      
//                       <td>
//                         <div className="qualification-cell">
//                           <span className="qualification-badge">
//                             {candidate.qualification || "-"}
//                           </span>
//                         </div>
//                       </td>
                      
//                       <td>
//                         <div className="branch-cell">
//                           <span className={`branch-badge ${candidate.branch?.toLowerCase() || ''}`}>
//                             {candidate.branch || "-"}
//                           </span>
//                         </div>
//                       </td>
                      
//                       <td>
//                         <div className="skills-experience-cell">
//                           <span className="experience-badge">
//                             {candidate.experience || "Exp N/A"}
//                           </span>
//                           <div className="skills-cell">
//                             {(candidate.skills || "")
//                               .split(",")
//                               .map(s => s.trim())
//                               .filter(Boolean)
//                               .slice(0, 2)
//                               .map((skill, i) => (
//                                 <span key={i} className="skill-tag">
//                                   {skill}
//                                 </span>
//                               ))}
//                             {(candidate.skills || "").split(",").filter(Boolean).length > 2 && (
//                               <span className="more-tag">
//                                 +{(candidate.skills || "").split(",").filter(Boolean).length - 2}
//                               </span>
//                             )}
//                             {!candidate.skills && <span className="no-skills">No skills</span>}
//                           </div>
//                         </div>
//                       </td>
                      
//                       <td>
//                         <div className="compact-contact">
//                           <a href={`mailto:${candidate.email}`} className="email-link" title={candidate.email}>
//                             {candidate.email?.length > 20 
//                               ? candidate.email.substring(0, 18) + "..." 
//                               : candidate.email || "-"}
//                           </a>
//                           {candidate.phone && (
//                             <div className="contact-phone" title={`Primary: ${candidate.phone}${candidate.alternatePhone ? `\nAlternate: ${candidate.alternatePhone}` : ''}`}>
//                               📞 {candidate.phone}
//                             </div>
//                           )}
//                         </div>
//                       </td>
                      
//                       <td>
//                         <div className="salary-info">
//                           {candidate.currentSalary ? (
//                             <>
//                               <span className="current-salary">
//                                 💰 {formatCurrency(candidate.currentSalary)}
//                               </span>
//                               {candidate.expectedSalary && (
//                                 <span className="expected-salary" title="Expected Salary">
//                                   → {formatCurrency(candidate.expectedSalary)}
//                                 </span>
//                               )}
//                             </>
//                           ) : (
//                             <span className="salary-na">Not specified</span>
//                           )}
//                         </div>
//                       </td>
                      
//                       <td>
//                         <div className="status-group">
//                           <span className={`status-badge ${(candidate.status || "inactive").toLowerCase()}`}>
//                             {candidate.status || "Inactive"}
//                           </span>
//                           <span className={`registration-badge ${(candidate.registrationStatus || "unregistered").toLowerCase()}`}>
//                             {candidate.registrationStatus === "Registered" ? "✓" : "✗"} 
//                             {candidate.registrationStatus === "Registered" ? " Reg" : " Unreg"}
//                           </span>
//                         </div>
//                       </td>
                      
//                       <td>
//                         <div className="action-buttons">
//                           <button
//                             onClick={() => handleView(candidate)}
//                             className="action-btn view"
//                             title="View Details"
//                           >
//                             👁️
//                           </button>
                          
//                           {canEdit && (
//                             <button
//                               onClick={() => handleEdit(candidate)}
//                               className="action-btn edit"
//                               title="Edit"
//                             >
//                               ✏️
//                             </button>
//                           )}
                          
//                           {canDelete && (
//                             <button
//                               onClick={() => handleDelete(candidate.id)}
//                               className="action-btn delete"
//                               title="Delete"
//                             >
//                               🗑️
//                             </button>
//                           )}
//                         </div>
//                       </td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//             </div>

//             {/* Pagination Controls */}
//             <div className="pagination-container">
//               <div className="pagination-info">
//                 Showing {indexOfFirstItem + 1} to {Math.min(indexOfLastItem, filteredCandidates.length)} of {filteredCandidates.length} entries
//               </div>
              
//               <div className="pagination-controls">
//                 <div className="items-per-page">
//                   <label>Show:</label>
//                   <select 
//                     value={itemsPerPage} 
//                     onChange={handleItemsPerPageChange}
//                     className="items-per-page-select"
//                   >
//                     {itemsPerPageOptions.map(option => (
//                       <option key={option} value={option}>{option}</option>
//                     ))}
//                   </select>
//                 </div>
                
//                 <div className="pagination-buttons">
//                   <button 
//                     onClick={goToPreviousPage} 
//                     disabled={currentPage === 1}
//                     className="pagination-btn prev"
//                   >
//                     &laquo; Previous
//                   </button>
                  
//                   <div className="page-numbers">
//                     {[...Array(totalPages)].map((_, index) => {
//                       const pageNumber = index + 1;
//                       if (
//                         pageNumber === 1 ||
//                         pageNumber === totalPages ||
//                         (pageNumber >= currentPage - 2 && pageNumber <= currentPage + 2)
//                       ) {
//                         return (
//                           <button
//                             key={pageNumber}
//                             onClick={() => paginate(pageNumber)}
//                             className={`page-number ${currentPage === pageNumber ? 'active' : ''}`}
//                           >
//                             {pageNumber}
//                           </button>
//                         );
//                       } else if (
//                         pageNumber === currentPage - 3 ||
//                         pageNumber === currentPage + 3
//                       ) {
//                         return <span key={pageNumber} className="page-ellipsis">...</span>;
//                       }
//                       return null;
//                     })}
//                   </div>
                  
//                   <button 
//                     onClick={goToNextPage} 
//                     disabled={currentPage === totalPages}
//                     className="pagination-btn next"
//                   >
//                     Next &raquo;
//                   </button>
//                 </div>
//               </div>
//             </div>
//           </>
//         ) : (
//           <div className="empty-state">
//             <div className="empty-icon">👥</div>
//             <h3>No candidates found</h3>
//             <p>Try adjusting your search or add a new candidate</p>
//             {canEdit && (
//               <button
//                 onClick={() => setShowModal(true)}
//                 className="btn-primary"
//               >
//                 + Add Candidate
//               </button>
//             )}
//           </div>
//         )}
//       </div>

//       {/* View Candidate Modal */}
//       {showViewModal && viewingCandidate && (
//         <div className="modal-overlay">
//           <div className="modal-content modal-lg">
//             <div className="modal-header">
//               <h2>Candidate Details</h2>
//               <button
//                 className="modal-close"
//                 onClick={() => {
//                   setViewingCandidate(null);
//                   setShowViewModal(false);
//                 }}
//               >
//                 ×
//               </button>
//             </div>

//             <div className="modal-body">
//               <div className="view-candidate-header">
//                 <div className="view-candidate-avatar">
//                   {getInitials(viewingCandidate.name)}
//                 </div>
//                 <div className="view-candidate-title">
//                   <h3>{viewingCandidate.name || "N/A"}</h3>
//                   <p>{viewingCandidate.currentCompany || "No current company"}</p>
//                 </div>
//                 <div className="view-candidate-badges">
//                   <span className={`status-badge ${(viewingCandidate.status || "inactive").toLowerCase()}`}>
//                     {viewingCandidate.status || "Inactive"}
//                   </span>
//                   <span className={`registration-badge ${(viewingCandidate.registrationStatus || "unregistered").toLowerCase()}`}>
//                     {viewingCandidate.registrationStatus || "Unregistered"}
//                   </span>
//                 </div>
//               </div>

//               <div className="view-details-grid">
//                 <div className="view-details-section">
//                   <h4>Contact Information</h4>
//                   <div className="view-details-row">
//                     <span className="detail-label">Email:</span>
//                     <span className="detail-value">
//                       <a href={`mailto:${viewingCandidate.email}`}>{viewingCandidate.email || "-"}</a>
//                     </span>
//                   </div>
//                   <div className="view-details-row">
//                     <span className="detail-label">Primary Phone:</span>
//                     <span className="detail-value">{viewingCandidate.phone || "-"}</span>
//                   </div>
//                   <div className="view-details-row">
//                     <span className="detail-label">Alternate Phone:</span>
//                     <span className="detail-value">{viewingCandidate.alternatePhone || "-"}</span>
//                   </div>
//                   <div className="view-details-row">
//                     <span className="detail-label">Location:</span>
//                     <span className="detail-value">{viewingCandidate.location || "-"}</span>
//                   </div>
//                 </div>

//                 <div className="view-details-section">
//                   <h4>Professional Details</h4>
//                   <div className="view-details-row">
//                     <span className="detail-label">Qualification:</span>
//                     <span className="detail-value">{viewingCandidate.qualification || "-"}</span>
//                   </div>
//                   <div className="view-details-row">
//                     <span className="detail-label">Branch:</span>
//                     <span className="detail-value">
//                       <span className={`branch-badge ${viewingCandidate.branch?.toLowerCase() || ''}`}>
//                         {viewingCandidate.branch || "-"}
//                       </span>
//                     </span>
//                   </div>
//                   <div className="view-details-row">
//                     <span className="detail-label">Experience:</span>
//                     <span className="detail-value">{viewingCandidate.experience || "-"}</span>
//                   </div>
//                   <div className="view-details-row">
//                     <span className="detail-label">Current Company:</span>
//                     <span className="detail-value">{viewingCandidate.currentCompany || "-"}</span>
//                   </div>
//                   <div className="view-details-row">
//                     <span className="detail-label">Notice Period:</span>
//                     <span className="detail-value">{viewingCandidate.noticePeriod || "-"}</span>
//                   </div>
//                 </div>

//                 <div className="view-details-section">
//                   <h4>Salary Information</h4>
//                   <div className="view-details-row">
//                     <span className="detail-label">Current Salary:</span>
//                     <span className="detail-value">{formatCurrency(viewingCandidate.currentSalary)}</span>
//                   </div>
//                   <div className="view-details-row">
//                     <span className="detail-label">Expected Salary:</span>
//                     <span className="detail-value">{formatCurrency(viewingCandidate.expectedSalary)}</span>
//                   </div>
//                 </div>

//                 <div className="view-details-section full-width">
//                   <h4>Skills</h4>
//                   <div className="skills-container">
//                     {(viewingCandidate.skills || "")
//                       .split(",")
//                       .map(s => s.trim())
//                       .filter(Boolean)
//                       .map((skill, index) => (
//                         <span key={index} className="skill-tag large">
//                           {skill}
//                         </span>
//                       ))}
//                     {!viewingCandidate.skills && <span className="detail-value">No skills added</span>}
//                   </div>
//                 </div>

//                 <div className="view-details-section full-width">
//                   <h4>Additional Information</h4>
//                   <div className="view-details-row">
//                     <span className="detail-label">Resume URL:</span>
//                     <span className="detail-value">
//                       {viewingCandidate.resumeUrl ? (
//                         <a href={viewingCandidate.resumeUrl} target="_blank" rel="noopener noreferrer">
//                           View Resume ↗
//                         </a>
//                       ) : "-"}
//                     </span>
//                   </div>
//                   <div className="view-details-row">
//                     <span className="detail-label">Created Date:</span>
//                     <span className="detail-value">{formatDate(viewingCandidate.createdDate)}</span>
//                   </div>
//                 </div>
//               </div>
//             </div>

//             <div className="modal-footer">
//               <button
//                 type="button"
//                 className="btn-secondary"
//                 onClick={() => {
//                   setViewingCandidate(null);
//                   setShowViewModal(false);
//                 }}
//               >
//                 Close
//               </button>
              
//               {canEdit && (
//                 <button
//                   type="button"
//                   className="btn-primary"
//                   onClick={() => {
//                     setViewingCandidate(null);
//                     setShowViewModal(false);
//                     handleEdit(viewingCandidate);
//                   }}
//                 >
//                   Edit Candidate
//                 </button>
//               )}
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Add/Edit Modal */}
//       {showModal && (
//         <div className="modal-overlay">
//           <div className="modal-content modal-lg">
//             <div className="modal-header">
//               <h2>
//                 {editingCandidate ? "Edit Candidate" : "Add New Candidate"}
//               </h2>
//               <button
//                 className="modal-close"
//                 onClick={() => {
//                   resetForm();
//                   setShowModal(false);
//                 }}
//               >
//                 ×
//               </button>
//             </div>

//             <form onSubmit={handleSubmit}>
//               <div className="modal-body">
//                 <div className="form-grid">
//                   <div className="form-group">
//                     <label>Full Name *</label>
//                     <input
//                       type="text"
//                       name="name"
//                       value={formData.name}
//                       onChange={handleInputChange}
//                       className={`form-input ${formErrors.name ? 'error' : ''}`}
//                       placeholder="John Doe"
//                     />
//                     {formErrors.name && <span className="error-message">{formErrors.name}</span>}
//                   </div>

//                   <div className="form-group">
//                     <label>Email *</label>
//                     <input
//                       type="email"
//                       name="email"
//                       value={formData.email}
//                       onChange={handleInputChange}
//                       className={`form-input ${formErrors.email ? 'error' : ''}`}
//                       placeholder="john@example.com"
//                     />
//                     {formErrors.email && <span className="error-message">{formErrors.email}</span>}
//                   </div>

//                   <div className="form-group">
//                     <label>Primary Phone</label>
//                     <input
//                       type="tel"
//                       name="phone"
//                       value={formData.phone}
//                       onChange={handleInputChange}
//                       className={`form-input ${formErrors.phone ? 'error' : ''}`}
//                       placeholder="+1 234 567 890"
//                     />
//                     {formErrors.phone && <span className="error-message">{formErrors.phone}</span>}
//                   </div>

//                   <div className="form-group">
//                     <label>Alternate Phone</label>
//                     <input
//                       type="tel"
//                       name="alternatePhone"
//                       value={formData.alternatePhone}
//                       onChange={handleInputChange}
//                       className="form-input"
//                       placeholder="+1 234 567 891"
//                     />
//                   </div>

//                   <div className="form-group">
//                     <label>Qualification *</label>
//                     <select
//                       name="qualification"
//                       value={formData.qualification}
//                       onChange={handleInputChange}
//                       className={`form-select ${formErrors.qualification ? 'error' : ''}`}
//                     >
//                       <option value="">Select Qualification</option>
//                       {qualificationOptions.map((qual, index) => (
//                         <option key={index} value={qual}>
//                           {qual}
//                         </option>
//                       ))}
//                     </select>
//                     {formErrors.qualification && <span className="error-message">{formErrors.qualification}</span>}
//                     <span className="form-hint">
//                       Select candidate's highest qualification
//                     </span>
//                   </div>

//                   <div className="form-group">
//                     <label>Branch *</label>
//                     <select
//                       name="branch"
//                       value={formData.branch}
//                       onChange={handleInputChange}
//                       className="form-select"
//                     >
//                       <option value="Ankleshwar">Ankleshwar</option>
//                       <option value="Bharuch">Bharuch</option>
//                     </select>
//                   </div>

//                   <div className="form-group">
//                     <label>Experience *</label>
//                     <select
//                       name="experience"
//                       value={formData.experience}
//                       onChange={handleInputChange}
//                       className={`form-select ${formErrors.experience ? 'error' : ''}`}
//                     >
//                       <option value="">Select Experience</option>
//                       {experienceOptions.map((exp, index) => (
//                         <option key={index} value={exp}>
//                           {exp}
//                         </option>
//                       ))}
//                     </select>
//                     {formErrors.experience && <span className="error-message">{formErrors.experience}</span>}
//                   </div>

//                   <div className="form-group">
//                     <label>Current Company</label>
//                     <input
//                       type="text"
//                       name="currentCompany"
//                       value={formData.currentCompany}
//                       onChange={handleInputChange}
//                       className="form-input"
//                       placeholder="Current Company"
//                     />
//                   </div>

//                   <div className="form-group">
//                     <label>Current Salary (LPA)</label>
//                     <input
//                       type="text"
//                       name="currentSalary"
//                       value={formData.currentSalary}
//                       onChange={handleInputChange}
//                       className="form-input"
//                       placeholder="e.g., 12"
//                     />
//                   </div>

//                   <div className="form-group">
//                     <label>Expected Salary (LPA)</label>
//                     <input
//                       type="text"
//                       name="expectedSalary"
//                       value={formData.expectedSalary}
//                       onChange={handleInputChange}
//                       className="form-input"
//                       placeholder="e.g., 15"
//                     />
//                   </div>

//                   <div className="form-group">
//                     <label>Notice Period</label>
//                     <select
//                       name="noticePeriod"
//                       value={formData.noticePeriod}
//                       onChange={handleInputChange}
//                       className="form-select"
//                     >
//                       <option value="">Select Notice Period</option>
//                       <option value="Immediate">Immediate</option>
//                       <option value="15 days">15 days</option>
//                       <option value="30 days">30 days</option>
//                       <option value="45 days">45 days</option>
//                       <option value="60 days">60 days</option>
//                       <option value="90 days">90 days</option>
//                     </select>
//                   </div>

//                   <div className="form-group">
//                     <label>Location</label>
//                     <input
//                       type="text"
//                       name="location"
//                       value={formData.location}
//                       onChange={handleInputChange}
//                       className="form-input"
//                       placeholder="City, Country"
//                     />
//                   </div>

//                   <div className="form-group">
//                     <label>Status</label>
//                     <select
//                       name="status"
//                       value={formData.status}
//                       onChange={handleInputChange}
//                       className="form-select"
//                     >
//                       <option value="Active">Active</option>
//                       <option value="Inactive">Inactive</option>
//                       <option value="Placed">Placed</option>
//                     </select>
//                   </div>

//                   <div className="form-group">
//                     <label>Registration Status</label>
//                     <select
//                       name="registrationStatus"
//                       value={formData.registrationStatus}
//                       onChange={handleInputChange}
//                       className="form-select"
//                     >
//                       <option value="">Select Registration Status</option>
//                       <option value="Registered">Registered</option>
//                       <option value="Unregistered">Unregistered</option>
//                     </select>
//                     <span className="form-hint">
//                       If not selected, "Unregistered" will be saved by default
//                     </span>
//                   </div>

//                   {editingCandidate && (
//                     <div className="form-group">
//                       <label>Created Date</label>
//                       <input
//                         type="datetime-local"
//                         name="createdDate"
//                         value={formData.createdDate}
//                         onChange={handleInputChange}
//                         className={`form-input ${formErrors.createdDate ? 'error' : ''}`}
//                       />
//                       {formErrors.createdDate && <span className="error-message">{formErrors.createdDate}</span>}
//                       <span className="form-hint">
//                         Cannot select a future date
//                       </span>
//                     </div>
//                   )}
//                 </div>

//                 <div className="form-group">
//                   <label>Skills (Optional)</label>
//                   <textarea
//                     name="skills"
//                     value={formData.skills}
//                     onChange={handleInputChange}
//                     className="form-textarea"
//                     placeholder="React, JavaScript, Node.js (comma separated)"
//                     rows="3"
//                   />
//                   <span className="form-hint">
//                     Enter skills separated by commas (optional)
//                   </span>
//                 </div>

//                 <div className="form-group">
//                   <label>Resume URL</label>
//                   <input
//                     type="url"
//                     name="resumeUrl"
//                     value={formData.resumeUrl}
//                     onChange={handleInputChange}
//                     className="form-input"
//                     placeholder="https://example.com/resume.pdf"
//                   />
//                 </div>
//               </div>

//               <div className="modal-footer">
//                 <button
//                   type="button"
//                   className="btn-secondary"
//                   onClick={() => {
//                     resetForm();
//                     setShowModal(false);
//                   }}
//                 >
//                   Cancel
//                 </button>
//                 <button type="submit" className="btn-primary">
//                   {editingCandidate ? "Update Candidate" : "Save Candidate"}
//                 </button>
//               </div>
//             </form>
//           </div>
//         </div>
//       )}

//       {/* Excel Import Modal */}
//       {/* {showImportModal && isAdmin && ( */}

      
//       {/* Excel Import Modal - Visible to Admin and Recruiter */}
// {showImportModal && (isAdmin || isRecruiter) && (
//         <div className="modal-overlay">
//           <div className="modal-content modal-lg">
//             <div className="modal-header">
//               <h2>Import Candidates from Excel</h2>
//               <button
//                 className="modal-close"
//                 onClick={() => {
//                   resetImport();
//                   setShowImportModal(false);
//                 }}
//               >
//                 ×
//               </button>
//             </div>

//             <div className="modal-body">
//               {importStep === 'upload' && (
//                 <div className="import-upload-section">
//                   <div className="import-instructions">
//                     <h3>Instructions:</h3>
//                     <ul>
//                       <li>Download the template file first</li>
//                       <li>Fill in your candidate data</li>
//                       <li>Required columns: Name, Email, Experience, Qualification</li>
//                       <li>Skills column is optional</li>
//                       <li>Branch must be either "Ankleshwar" or "Bharuch"</li>
//                       <li>Registration Status: Leave empty to default to "Unregistered"</li>
//                       <li><strong>Resume Link:</strong> Optional - Add direct URL to candidate's resume (Google Drive, Dropbox, etc.)</li>
//                       <li>Upload the filled Excel file (.xlsx, .xls)</li>
//                     </ul>
//                   </div>

//                   <div className="import-actions">
//                     <button
//                       onClick={downloadTemplate}
//                       className="btn-secondary"
//                     >
//                       📥 Download Template
//                     </button>
                    
//                     <div className="file-upload-area">
//                       <input
//                         type="file"
//                         ref={fileInputRef}
//                         accept=".xlsx,.xls,.csv"
//                         onChange={handleFileUpload}
//                         className="file-input"
//                         id="excel-upload"
//                       />
//                       <label htmlFor="excel-upload" className="file-upload-label">
//                         {importLoading ? 'Processing...' : 'Choose Excel File'}
//                       </label>
//                     </div>
//                   </div>

//                   {importLoading && (
//                     <div className="import-loading">
//                       <div className="spinner-small"></div>
//                       <p>Processing file...</p>
//                     </div>
//                   )}
//                 </div>
//               )}

//               {importStep === 'preview' && (
//                 <div className="import-preview-section">
//                   <div className="import-summary">
//                     <h3>Import Summary</h3>
//                     <div className="summary-stats">
//                       <div className="stat-item success">
//                         <span className="stat-value">{importData.length}</span>
//                         <span className="stat-label">Valid Records</span>
//                       </div>
//                       <div className="stat-item error">
//                         <span className="stat-value">{importErrors.length}</span>
//                         <span className="stat-label">Errors</span>
//                       </div>
//                     </div>
//                   </div>

//                   {importErrors.length > 0 && (
//                     <div className="import-errors">
//                       <h4>Errors Found:</h4>
//                       <div className="errors-list">
//                         {importErrors.map((error, idx) => (
//                           <div key={idx} className="error-item">
//                             <strong>Row {error.row}:</strong> {error.name} - {error.errors.join(', ')}
//                           </div>
//                         ))}
//                       </div>
//                     </div>
//                   )}

//                   {importData.length > 0 && (
//                     <div className="import-preview">
//                       <h4>Preview (First 5 Records)</h4>
//                       <div className="preview-table-container">
//                         <table className="preview-table">
//                           <thead>
//                             <tr>
//                               <th>Name</th>
//                               <th>Email</th>
//                               <th>Qualification</th>
//                               <th>Branch</th>
//                               <th>Skills</th>
//                               <th>Experience</th>
//                               <th>Status</th>
//                               <th>Registration Status</th>
//                               <th>Resume Link</th>
//                             </tr>
//                           </thead>
//                           <tbody>
//                             {importData.slice(0, 5).map((candidate, idx) => (
//                               <tr key={idx}>
//                                 <td>{candidate.name}</td>
//                                 <td>{candidate.email}</td>
//                                 <td>{candidate.qualification || '-'}</td>
//                                 <td>
//                                   <span className={`branch-badge ${candidate.branch?.toLowerCase()}`}>
//                                     {candidate.branch}
//                                   </span>
//                                 </td>
//                                 <td>{candidate.skills || '-'}</td>
//                                 <td>{candidate.experience}</td>
//                                 <td>
//                                   <span className={`status-badge ${candidate.status.toLowerCase()}`}>
//                                     {candidate.status}
//                                   </span>
//                                 </td>
//                                 <td>
//                                   <span className={`registration-badge ${(candidate.registrationStatus || 'unregistered').toLowerCase()}`}>
//                                     {candidate.registrationStatus || 'Unregistered'}
//                                   </span>
//                                 </td>
//                                 <td>
//                                   {candidate.resumeUrl ? (
//                                     <a href={candidate.resumeUrl} target="_blank" rel="noopener noreferrer" style={{ fontSize: '11px' }}>
//                                       View Link ↗
//                                     </a>
//                                   ) : '-'}
//                                 </td>
//                               </tr>
//                             ))}
//                           </tbody>
//                         </table>
//                       </div>
//                     </div>
//                   )}
//                 </div>
//               )}

//               {importStep === 'complete' && (
//                 <div className="import-complete">
//                   <div className="success-icon">✅</div>
//                   <h3>Import Successful!</h3>
//                   <p>{importData.length} candidates have been added.</p>
//                 </div>
//               )}
//             </div>

//             {importStep === 'preview' && (
//               <div className="modal-footer">
//                 <button
//                   type="button"
//                   className="btn-secondary"
//                   onClick={resetImport}
//                 >
//                   Back
//                 </button>
//                 <button
//                   type="button"
//                   className="btn-primary"
//                   onClick={handleImportConfirm}
//                   disabled={importData.length === 0 || importLoading}
//                 >
//                   {importLoading ? 'Importing...' : `Import ${importData.length} Candidates`}
//                 </button>
//               </div>
//             )}
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default Candidates;






























import React, { useState, useEffect, useRef } from "react";
import * as XLSX from "xlsx";

import { getCandidates, createCandidate, updateCandidate, deleteCandidate } from "../../services/api";

import { useAuth } from "../../contexts/AuthContext";

import "./Candidates.css";

const Candidates = () => {
  // Get current user from AuthContext
  const { currentUser } = useAuth();
  
  const [candidates, setCandidates] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [showViewModal, setShowViewModal] = useState(false);
  const [viewingCandidate, setViewingCandidate] = useState(null);
  const [editingCandidate, setEditingCandidate] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [filterSkills, setFilterSkills] = useState("all");
  const [filterExperience, setFilterExperience] = useState("all");
  const [filterStatus, setFilterStatus] = useState("all");
  const [filterRegistration, setFilterRegistration] = useState("all");
  const [filterQualification, setFilterQualification] = useState("all");
  const [filterBranch, setFilterBranch] = useState("all");
  const [sortOrder, setSortOrder] = useState("newest");
  const [formErrors, setFormErrors] = useState({});
  const [isHeaderScrolled, setIsHeaderScrolled] = useState(false);
  
  // Pagination states
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [itemsPerPageOptions] = useState([5, 10, 25, 50, 100]);
  
  // Excel import states
  const [showImportModal, setShowImportModal] = useState(false);
  const [importData, setImportData] = useState([]);
  const [importErrors, setImportErrors] = useState([]);
  const [importLoading, setImportLoading] = useState(false);
  const [importStep, setImportStep] = useState('upload');
  const fileInputRef = useRef(null);
  const headerRef = useRef(null);

  // Check user roles
  const isAdmin = currentUser && currentUser.role === "admin";
  const isRecruiter = currentUser && currentUser.role === "recruiter";
  const canEdit = isAdmin || isRecruiter;
  const canDelete = isAdmin;

  // Qualification options
  const qualificationOptions = [
    "SSC (10th Pass)",
    "HSC (12th Science)",
    "HSC (12th Commerce)",
    "HSC (12th Arts)",
    "ITI AOCP ",
    "ITI - Fitter",
    "ITI - Electrician",
    "ITI - Welder",
    "ITI - Turner",
    "ITI - Machinist",
    "ITI - Instrument Mechanic",
    "ITI - Draughtsman (Mechanical)",
    "ITI - Draughtsman (Civil)",
    "ITI - Diesel Mechanic",
    "ITI - Motor Mechanic",
    "ITI - Refrigeration & Air Conditioning",
    "ITI - Plumber",
    "ITI - COPA (Computer Operator & Programming Assistant)",
    "ITI - RFM (Refinery & Maintenance Mechanic)",
    "ITI - Pump Operator",
    "ITI - Boiler Attendant",
    "ITI - LACP",
    "ITI - Fire & Safety",
    "Diploma - Mechanical Engineering",
    "Diploma - Electrical Engineering",
    "Diploma - Chemical Engineering",
    "Diploma - Instrumentation",
    "Diploma - Civil Engineering",
    "Diploma - Automobile Engineering",
    "Diploma - Production Engineering",
    "Diploma - Plastic Technology",
    "Diploma - Petrochemical Engineering",
    "Diploma - Industrial Safety",
    "B.E. - Mechanical Engineering",
    "B.E. - Electrical Engineering",
    "B.E. - Chemical Engineering",
    "B.E. - Instrumentation Engineering",
    "B.E. - Civil Engineering",
    "B.E. - Automobile Engineering",
    "B.E. - Production Engineering",
    "B.E. - Petrochemical Engineering",
    "B.Sc - Chemistry",
    "B.Sc - Physics",
    "B.Sc - Mathematics",
    "B.Sc - Industrial Chemistry",
    "B.Sc - Environmental Science",
    "B.Sc - Microbiology",
    "B.Com (Bachelor of Commerce)",
    "M.Com",
    "BBA (Bachelor of Business Administration)",
    "MBA - Human Resources",
    "MBA - Marketing",
    "MBA - Finance",
    "MBA - Operations",
    "BCA (Bachelor of Computer Applications)",
    "MCA (Master of Computer Applications)",
    "Diploma - Computer Applications",
    "M.Tech - Mechanical Engineering",
    "M.Tech - Chemical Engineering",
    "M.Tech - Electrical Engineering",
    "M.Tech - Instrumentation Engineering",
    "M.Sc - Chemistry",
    "M.Sc - Environmental Science",
    "PDIS (Professional Diploma in Industrial Safety)",
    "ADIS (Advanced Diploma in Industrial Safety)",
    "NEBOSH - IGC",
    "NEBOSH - Diploma",
    "IOSH Certification",
    "Diploma - Fire & Safety",
    "Industrial Safety Certification",
   
    "Boiler Operation Certificate",
    "First Aid Certification",
    "Quality Control Certification",
    "NDT Level II",
    "NDT Level III",
    "PhD (Doctor of Philosophy)",
    "Other"
  ];

  const experienceOptions = [
    "Fresher",
    "1 year",
    "2 years",
    "3 years",
    "4 years",
    "5 years",
    "6 years",
    "7 years",
    "8 years",
    "9 years",
    "10 years",
    "11 years",
    "12 years",
    "13 years",
    "14 years",
    "15 years"
  ];

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    alternatePhone: "",
    skills: "",
    experience: "",
    qualification: "",
    branch: "Ankleshwar",
    currentCompany: "",
    currentSalary: "",
    expectedSalary: "",
    noticePeriod: "",
    location: "",
    resumeUrl: "",
    status: "Active",
    registrationStatus: "",
    createdDate: new Date().toISOString().slice(0, 16),
  });

  useEffect(() => {
    loadCandidates();
    
    const handleScroll = () => {
      if (headerRef.current) {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        setIsHeaderScrolled(scrollTop > 50);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm, filterSkills, filterExperience, filterStatus, 
      filterRegistration, filterQualification, filterBranch, sortOrder]);

  const loadCandidates = async () => {
    setLoading(true);
    try {
      const res = await getCandidates();
      const normalizedCandidates = res.data.map(candidate => ({
        ...candidate,
        registrationStatus: candidate.registrationStatus || "Unregistered"
      }));
      setCandidates(normalizedCandidates);
    } catch (error) {
      console.error(error);
    }
    setLoading(false);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    if (formErrors[name]) {
      setFormErrors(prev => ({ ...prev, [name]: "" }));
    }
  };

  const isDateNotInFuture = (dateString) => {
    if (!dateString) return true;
    const selectedDate = new Date(dateString);
    const currentDate = new Date();
    selectedDate.setHours(0, 0, 0, 0);
    currentDate.setHours(0, 0, 0, 0);
    return selectedDate <= currentDate;
  };

  const validateForm = () => {
    const errors = {};
    
    if (!formData.name || formData.name.trim() === "") {
      errors.name = "Name is required";
    }
    
    if (!formData.email || formData.email.trim() === "") {
      errors.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      errors.email = "Email is invalid";
    }
    
    if (!formData.experience || formData.experience === "") {
      errors.experience = "Experience is required";
    }
    
    if (!formData.qualification || formData.qualification === "") {
      errors.qualification = "Qualification is required";
    }
    
    if (formData.phone && !/^[\d\s\+\-\(\)]{10,}$/.test(formData.phone)) {
      errors.phone = "Please enter a valid phone number";
    }

    if (editingCandidate && formData.createdDate) {
      if (!isDateNotInFuture(formData.createdDate)) {
        errors.createdDate = "Created date cannot be in the future";
      }
    }

    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    const candidateData = {
      ...formData,
      registrationStatus: formData.registrationStatus || "Unregistered",
      id: editingCandidate ? editingCandidate.id : Date.now().toString(),
      createdDate: editingCandidate ? formData.createdDate : new Date().toISOString(),
      skills: formData.skills ? formData.skills.split(',').map(s => s.trim()).filter(Boolean).join(', ') : "",
    };

    if (editingCandidate) {
      await updateCandidate(editingCandidate.id, candidateData);
    } else {
      await createCandidate(candidateData);
    }

    resetForm();
    loadCandidates();
    setShowModal(false);
  };

  const handleView = (candidate) => {
    setViewingCandidate(candidate);
    setShowViewModal(true);
  };

  const handleEdit = (candidate) => {
    if (!canEdit) {
      alert("You don't have permission to edit candidates");
      return;
    }
    
    let formattedDate = candidate.createdDate;
    if (candidate.createdDate) {
      const date = new Date(candidate.createdDate);
      if (!isNaN(date.getTime())) {
        formattedDate = date.toISOString().slice(0, 16);
      }
    }
    
    setEditingCandidate(candidate);
    setFormData({
      ...candidate,
      skills: candidate.skills || "",
      createdDate: formattedDate,
    });
    setShowModal(true);
  };

  const handleDelete = async (id) => {
    if (!isAdmin) {
      alert("You don't have permission to delete candidates");
      return;
    }
    if (window.confirm("Are you sure you want to delete this candidate?")) {
      await deleteCandidate(id);
      loadCandidates();
    }
  };

  const resetForm = () => {
    setFormData({
      name: "",
      email: "",
      phone: "",
      alternatePhone: "",
      skills: "",
      experience: "",
      qualification: "",
      branch: "Ankleshwar",
      currentCompany: "",
      currentSalary: "",
      expectedSalary: "",
      noticePeriod: "",
      location: "",
      resumeUrl: "",
      status: "Active",
      registrationStatus: "",
      createdDate: new Date().toISOString().slice(0, 16),
    });
    setEditingCandidate(null);
    setFormErrors({});
  };

  // ===== HELPER FUNCTIONS =====
  const findColumnIndex = (headers, possibleNames) => {
    for (let i = 0; i < headers.length; i++) {
      if (possibleNames.some(name => headers[i].includes(name))) {
        return i;
      }
    }
    return -1;
  };

  const getCellValue = (row, index) => {
    if (index === -1 || index >= row.length) return '';
    const value = row[index];
    return value !== undefined && value !== null ? String(value).trim() : '';
  };

  const mapStatus = (value) => {
    if (!value) return 'Active';
    const status = value.toLowerCase();
    if (status.includes('inactive')) return 'Inactive';
    if (status.includes('placed')) return 'Placed';
    return 'Active';
  };

  const mapRegistrationStatus = (value) => {
    if (!value) return '';
    const reg = value.toLowerCase();
    if (reg.includes('unreg')) return 'Unregistered';
    if (reg.includes('reg')) return 'Registered';
    return '';
  };

  const isValidUrl = (url) => {
    if (!url) return true;
    try {
      new URL(url);
      return true;
    } catch (e) {
      return false;
    }
  };

  // ===== EXCEL IMPORT FUNCTIONS =====
  
  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setImportLoading(true);
    setImportErrors([]);

    const reader = new FileReader();
    reader.onload = (event) => {
      try {
        const data = new Uint8Array(event.target.result);
        const workbook = XLSX.read(data, { type: 'array' });
        
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
        
        const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
        
        const parsedData = parseExcelData(jsonData);
        setImportData(parsedData.validData);
        setImportErrors(parsedData.errors);
        
        if (parsedData.validData.length > 0) {
          setImportStep('preview');
        }
      } catch (error) {
        setImportErrors([{ row: 0, error: 'Failed to parse Excel file: ' + error.message }]);
      } finally {
        setImportLoading(false);
      }
    };
    
    reader.readAsArrayBuffer(file);
  };

  const parseExcelData = (rows) => {
    if (rows.length < 2) {
      return { validData: [], errors: [{ row: 0, error: 'File is empty or has no data rows' }] };
    }

    const headers = rows[0].map(h => String(h || '').toLowerCase().trim());
    
    const fieldMap = {
      name: findColumnIndex(headers, ['name', 'full name', 'candidate name']),
      email: findColumnIndex(headers, ['email', 'e-mail', 'email address']),
      phone: findColumnIndex(headers, ['phone', 'mobile', 'contact', 'phone number']),
      alternatePhone: findColumnIndex(headers, ['alternate phone', 'alt phone', 'secondary phone']),
      skills: findColumnIndex(headers, ['skills', 'skill', 'technologies']),
      experience: findColumnIndex(headers, ['experience', 'exp', 'total experience', 'years']),
      qualification: findColumnIndex(headers, ['qualification', 'education', 'degree']),
      branch: findColumnIndex(headers, ['branch', 'location branch', 'office']),
      currentCompany: findColumnIndex(headers, ['current company', 'company', 'employer']),
      currentSalary: findColumnIndex(headers, ['current salary', 'current ctc', 'salary']),
      expectedSalary: findColumnIndex(headers, ['expected salary', 'expected ctc', 'expectation']),
      noticePeriod: findColumnIndex(headers, ['notice period', 'notice', 'np']),
      location: findColumnIndex(headers, ['location', 'city', 'place']),
      status: findColumnIndex(headers, ['status']),
      registrationStatus: findColumnIndex(headers, ['registration status', 'registration', 'reg status']),
      resumeUrl: findColumnIndex(headers, ['resume link', 'resume url', 'resume', 'cv link', 'cv url'])
    };

    const validData = [];
    const errors = [];

    for (let i = 1; i < rows.length; i++) {
      const row = rows[i];
      if (!row || row.length === 0 || row.every(cell => !cell)) continue;

      const branchValue = getCellValue(row, fieldMap.branch);
      const validBranch = branchValue && ['Ankleshwar', 'Bharuch'].includes(branchValue) 
        ? branchValue 
        : 'Ankleshwar';

      const registrationStatusValue = getCellValue(row, fieldMap.registrationStatus);
      const resumeUrlValue = getCellValue(row, fieldMap.resumeUrl);
      
      const candidate = {
        id: Date.now().toString() + i,
        createdDate: new Date().toISOString(),
        name: getCellValue(row, fieldMap.name) || '',
        email: getCellValue(row, fieldMap.email) || '',
        phone: getCellValue(row, fieldMap.phone) || '',
        alternatePhone: getCellValue(row, fieldMap.alternatePhone) || '',
        skills: getCellValue(row, fieldMap.skills) || '',
        experience: getCellValue(row, fieldMap.experience) || '',
        qualification: getCellValue(row, fieldMap.qualification) || '',
        branch: validBranch,
        currentCompany: getCellValue(row, fieldMap.currentCompany) || '',
        currentSalary: getCellValue(row, fieldMap.currentSalary) || '',
        expectedSalary: getCellValue(row, fieldMap.expectedSalary) || '',
        noticePeriod: getCellValue(row, fieldMap.noticePeriod) || '',
        location: getCellValue(row, fieldMap.location) || '',
        status: mapStatus(getCellValue(row, fieldMap.status)) || 'Active',
        registrationStatus: mapRegistrationStatus(registrationStatusValue) || "Unregistered",
        resumeUrl: resumeUrlValue || ''
      };

      if (candidate.resumeUrl && !isValidUrl(candidate.resumeUrl)) {
        console.warn(`Row ${i + 1}: Invalid URL format for resume link: ${candidate.resumeUrl}`);
      }

      const rowErrors = [];
      if (!candidate.name) rowErrors.push('Name is required');
      if (!candidate.email) rowErrors.push('Email is required');
      else if (!/\S+@\S+\.\S+/.test(candidate.email)) rowErrors.push('Invalid email format');
      if (!candidate.experience) rowErrors.push('Experience is required');
      if (!candidate.qualification) rowErrors.push('Qualification is required');

      if (rowErrors.length > 0) {
        errors.push({
          row: i + 1,
          name: candidate.name || 'Unknown',
          errors: rowErrors
        });
      } else {
        validData.push(candidate);
      }
    }

    return { validData, errors };
  };

  const handleImportConfirm = async () => {
    setImportLoading(true);

    try {
      for (const candidate of importData) {
        const candidateToSave = {
          ...candidate,
          registrationStatus: candidate.registrationStatus || "Unregistered"
        };
        await createCandidate(candidateToSave);
      }

      loadCandidates();
      setImportStep('complete');

      setTimeout(() => {
        resetImport();
        setShowImportModal(false);
      }, 2000);

    } catch (error) {
      setImportErrors([{ row: 0, error: 'Failed to save candidates: ' + error.message }]);
    }

    setImportLoading(false);
  };

  const resetImport = () => {
    setImportData([]);
    setImportErrors([]);
    setImportStep('upload');
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  };

  const downloadTemplate = () => {
    const template = [
      ['Name', 'Email', 'Phone', 'Alternate Phone', 'Skills', 'Experience', 'Qualification', 'Branch', 'Current Company', 'Current Salary', 'Expected Salary', 'Notice Period', 'Location', 'Status', 'Registration Status', 'Resume Link'],
      ['John Doe', 'john@example.com', '+1234567890', '+1234567891', 'React, JavaScript, Node.js', '3 years', 'B.E. - Mechanical Engineering', 'Ankleshwar', 'Tech Corp', '12', '15', '30 days', 'New York', 'Active', 'Registered', 'https://example.com/resume/john_doe.pdf']
     
    ];

    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.aoa_to_sheet(template);
    
    ws['!cols'] = [
      { wch: 20 }, // Name
      { wch: 25 }, // Email
      { wch: 15 }, // Phone
      { wch: 15 }, // Alternate Phone
      { wch: 30 }, // Skills
      { wch: 12 }, // Experience
      { wch: 30 }, // Qualification
      { wch: 12 }, // Branch
      { wch: 20 }, // Current Company
      { wch: 15 }, // Current Salary
      { wch: 15 }, // Expected Salary
      { wch: 12 }, // Notice Period
      { wch: 20 }, // Location
      { wch: 10 }, // Status
      { wch: 15 }, // Registration Status
      { wch: 40 }  // Resume Link
    ];
    
    XLSX.utils.book_append_sheet(wb, ws, 'Candidate_Template');
    XLSX.writeFile(wb, 'candidate_import_template.xlsx');
  };

  // Filter and sort candidates - UPDATED with phone search
  const filteredCandidates = candidates
    .filter((candidate) => {
      const search = searchTerm.toLowerCase();
      const name = candidate.name?.toLowerCase() || "";
      const email = candidate.email?.toLowerCase() || "";
      const skills = candidate.skills?.toLowerCase() || "";
      const company = candidate.currentCompany?.toLowerCase() || "";
      const qualification = candidate.qualification?.toLowerCase() || "";
      
      // Phone search handling - with null safety, numeric stripping, and partial match
      let phoneMatch = false;
      if (searchTerm && candidate.phone) {
        const searchDigits = searchTerm.replace(/\D/g, "");
        const phoneDigits = candidate.phone.toString().replace(/\D/g, "");
        if (searchDigits && phoneDigits.includes(searchDigits)) {
          phoneMatch = true;
        }
      }

      const matchesSearch = !searchTerm || 
        name.includes(search) ||
        email.includes(search) ||
        skills.includes(search) ||
        company.includes(search) ||
        qualification.includes(search) ||
        phoneMatch;

      const matchesSkills = filterSkills === "all" || 
        (candidate.skills?.toLowerCase() || "").includes(filterSkills.toLowerCase());

      const matchesExperience = filterExperience === "all" || 
        candidate.experience === filterExperience;

      const normalize = (val) => (val || "").toLowerCase().trim();

      const matchesStatus =
        filterStatus === "all" ||
        normalize(candidate.status) === normalize(filterStatus);

      let matchesRegistration = true;
      if (filterRegistration !== "all") {
        const candidateRegStatus = candidate.registrationStatus || "Unregistered";
        matchesRegistration = normalize(candidateRegStatus) === normalize(filterRegistration);
      }

      const matchesQualification = filterQualification === "all" || 
        candidate.qualification === filterQualification;

      const matchesBranch = filterBranch === "all" || 
        candidate.branch === filterBranch;

      return matchesSearch && matchesSkills && matchesExperience && 
             matchesStatus && matchesRegistration && 
             matchesQualification && matchesBranch;
    })
    .sort((a, b) => {
      const dateA = new Date(a.createdDate);
      const dateB = new Date(b.createdDate);
      const timeA = isNaN(dateA.getTime()) ? 0 : dateA.getTime();
      const timeB = isNaN(dateB.getTime()) ? 0 : dateB.getTime();
      return sortOrder === "newest" ? timeB - timeA : timeA - timeB;
    });

  // Pagination logic
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredCandidates.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredCandidates.length / itemsPerPage);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  
  const goToPreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };
  
  const goToNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };
  
  const handleItemsPerPageChange = (e) => {
    setItemsPerPage(Number(e.target.value));
    setCurrentPage(1);
  };

  const allSkills = [
    ...new Set(
      candidates.flatMap((c) =>
        (c.skills || "")
          .split(",")
          .map((s) => s.trim())
          .filter(Boolean)
      )
    ),
  ];

  const allQualifications = [
    ...new Set(candidates.map((c) => c.qualification).filter(Boolean)),
  ];

  const experienceLevels = [
    ...new Set(candidates.map((c) => c.experience).filter(Boolean)),
  ];

  const activeCandidates = candidates.filter(
    (c) => c.status === "Active"
  ).length;
  
  const registeredCandidates = candidates.filter(
    (c) => (c.registrationStatus || "Unregistered") === "Registered"
  ).length;

  const ankleshwarCandidates = candidates.filter(
    (c) => c.branch === "Ankleshwar"
  ).length;

  const bharuchCandidates = candidates.filter(
    (c) => c.branch === "Bharuch"
  ).length;

  const getInitials = (name) => {
    if (!name) return "?";
    return name
      .split(" ")
      .map((n) => n[0])
      .join("")
      .toUpperCase()
      .slice(0, 2);
  };

  const formatDate = (dateString) => {
    if (!dateString) return "-";
    try {
      const date = new Date(dateString);
      const options = { year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' };
      return date.toLocaleDateString(undefined, options);
    } catch (e) {
      return dateString;
    }
  };

  const formatCurrency = (value) => {
    if (!value) return "-";
    return `₹${value}`;
  };

  if (loading) {
    return (
      <div className="loading-container">
        <div className="spinner"></div>
        <p>Loading candidates...</p>
      </div>
    );
  }

  return (
    <div className="candidates-page">
      <div id="candidates-top"></div>

      <div 
        ref={headerRef}
        className={`page-header ${isHeaderScrolled ? 'scrolled' : ''}`}
      >
        <div className='comp'>
          <h1>Candidates</h1>
          <p>Manage candidate profiles and information</p>
          {!canEdit && (
            <small style={{ color: '#666', fontSize: '12px' }}>View Only Mode</small>
          )}
          {isRecruiter && (
            <small style={{ color: '#4CAF50', fontSize: '12px' }}>Recruiter Mode - Can Edit</small>
          )}
          {isAdmin && (
            <small style={{ color: '#2196F3', fontSize: '12px' }}>Admin Mode - Full Access</small>
          )}
        </div>

        <div className="header-actions">
          {/* Show Import button for both Admin and Recruiter */}
          {(isAdmin || isRecruiter) && (
            <button
              onClick={() => setShowImportModal(true)}
              className="btn-secondary"
              title="Import from Excel"
            >
              📥 Import Excel
            </button>
          )}
          {/* Show Add button for both Admin and Recruiter */}
          {canEdit && (
            <button
              onClick={() => setShowModal(true)}
              className="btn-primary"
            >
              + Add Candidate
            </button>
          )}
        </div>
      </div>

      {/* Stats Cards */}
      <div className="stats-cards">
        <div className="stat-card">
          <div className="stat-icon">👥</div>
          <div className="stat-content">
            <h3>{candidates.length}</h3>
            <p>Total Candidates</p>
          </div>
        </div>
        <div className="stat-card">
          <div className="stat-icon">✅</div>
          <div className="stat-content">
            <h3>{activeCandidates}</h3>
            <p>Active Candidates</p>
          </div>
        </div>
        <div className="stat-card">
          <div className="stat-icon">📝</div>
          <div className="stat-content">
            <h3>{registeredCandidates}</h3>
            <p>Registered</p>
          </div>
        </div>
        <div className="stat-card">
          <div className="stat-icon">🏢</div>
          <div className="stat-content">
            <h3>{ankleshwarCandidates} | {bharuchCandidates}</h3>
            <p>Ankleshwar | Bharuch</p>
          </div>
        </div>
      </div>

      {/* Filters */}
      <div className="filters-section">
        <div className="search-box">
          <span className="search-icon">🔍</span>
          <input
            type="text"
            placeholder="Search candidates..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="search-input"
          />
        </div>

        <div className="filter-controls">
          <select
            value={filterQualification}
            onChange={(e) => setFilterQualification(e.target.value)}
            className="filter-select"
          >
            <option value="all">All Qualifications</option>
            {allQualifications.map((qual) => (
              <option key={qual} value={qual}>
                {qual}
              </option>
            ))}
          </select>

          <select
            value={filterBranch}
            onChange={(e) => setFilterBranch(e.target.value)}
            className="filter-select"
          >
            <option value="all">All Branches</option>
            <option value="Ankleshwar">Ankleshwar</option>
            <option value="Bharuch">Bharuch</option>
          </select>

          <select
            value={filterSkills}
            onChange={(e) => setFilterSkills(e.target.value)}
            className="filter-select"
          >
            <option value="all">All Skills</option>
            {allSkills.map((skill) => (
              <option key={skill} value={skill}>
                {skill}
              </option>
            ))}
          </select>

          <select
            value={filterExperience}
            onChange={(e) => setFilterExperience(e.target.value)}
            className="filter-select"
          >
            <option value="all">All Experience</option>
            {experienceLevels.map((exp) => (
              <option key={exp} value={exp}>
                {exp}
              </option>
            ))}
          </select>

          <select
            value={filterStatus}
            onChange={(e) => setFilterStatus(e.target.value)}
            className="filter-select"
          >
            <option value="all">All Status</option>
            <option value="Active">Active</option>
            <option value="Inactive">Inactive</option>
            <option value="Placed">Placed</option>
          </select>

          <select
            value={filterRegistration}
            onChange={(e) => setFilterRegistration(e.target.value)}
            className="filter-select"
          >
            <option value="all">All Registration</option>
            <option value="Registered">Registered</option>
            <option value="Unregistered">Unregistered</option>
          </select>

          <select
            value={sortOrder}
            onChange={(e) => setSortOrder(e.target.value)}
            className="filter-select"
          >
            <option value="newest">Newest First</option>
            <option value="oldest">Oldest First</option>
          </select>
        </div>
      </div>

      {/* Table */}
      <div className="table-container">
        {filteredCandidates.length > 0 ? (
          <>
            <div className="table-responsive">
              <table className="data-table">
                <thead>
                  <tr>
                    <th>Candidate</th>
                    <th>Qualification</th>
                    <th>Branch</th>
                    <th>Skills & Experience</th>
                    <th>Contact</th>
                    <th>Salary</th>
                    <th>Status</th>
                    <th>Actions</th>
                  </tr>
                </thead>

                <tbody>
                  {currentItems.map((candidate) => (
                    <tr key={candidate.id}>
                      <td>
                        <div className="candidate-cell">
                          <div className="candidate-avatar">
                            {getInitials(candidate.name)}
                          </div>
                          <div>
                            <div className="candidate-name">
                              {candidate.name || "N/A"}
                            </div>
                            <div className="candidate-company">
                              {candidate.currentCompany || "Not Specified"}
                            </div>
                            <div className="candidate-meta">
                              📅 {formatDate(candidate.createdDate)}
                            </div>
                          </div>
                        </div>
                      </td>
                      
                      <td>
                        <div className="qualification-cell">
                          <span className="qualification-badge">
                            {candidate.qualification || "-"}
                          </span>
                        </div>
                      </td>
                      
                      <td>
                        <div className="branch-cell">
                          <span className={`branch-badge ${candidate.branch?.toLowerCase() || ''}`}>
                            {candidate.branch || "-"}
                          </span>
                        </div>
                      </td>
                      
                      <td>
                        <div className="skills-experience-cell">
                          <span className="experience-badge">
                            {candidate.experience || "Exp N/A"}
                          </span>
                          <div className="skills-cell">
                            {(candidate.skills || "")
                              .split(",")
                              .map(s => s.trim())
                              .filter(Boolean)
                              .slice(0, 2)
                              .map((skill, i) => (
                                <span key={i} className="skill-tag">
                                  {skill}
                                </span>
                              ))}
                            {(candidate.skills || "").split(",").filter(Boolean).length > 2 && (
                              <span className="more-tag">
                                +{(candidate.skills || "").split(",").filter(Boolean).length - 2}
                              </span>
                            )}
                            {!candidate.skills && <span className="no-skills">No skills</span>}
                          </div>
                        </div>
                      </td>
                      
                      <td>
                        <div className="compact-contact">
                          <a href={`mailto:${candidate.email}`} className="email-link" title={candidate.email}>
                            {candidate.email?.length > 20 
                              ? candidate.email.substring(0, 18) + "..." 
                              : candidate.email || "-"}
                          </a>
                          {candidate.phone && (
                            <div className="contact-phone" title={`Primary: ${candidate.phone}${candidate.alternatePhone ? `\nAlternate: ${candidate.alternatePhone}` : ''}`}>
                              📞 {candidate.phone}
                            </div>
                          )}
                        </div>
                      </td>
                      
                      <td>
                        <div className="salary-info">
                          {candidate.currentSalary ? (
                            <>
                              <span className="current-salary">
                                💰 {formatCurrency(candidate.currentSalary)}
                              </span>
                              {candidate.expectedSalary && (
                                <span className="expected-salary" title="Expected Salary">
                                  → {formatCurrency(candidate.expectedSalary)}
                                </span>
                              )}
                            </>
                          ) : (
                            <span className="salary-na">Not specified</span>
                          )}
                        </div>
                      </td>
                      
                      <td>
                        <div className="status-group">
                          <span className={`status-badge ${(candidate.status || "inactive").toLowerCase()}`}>
                            {candidate.status || "Inactive"}
                          </span>
                          <span className={`registration-badge ${(candidate.registrationStatus || "unregistered").toLowerCase()}`}>
                            {candidate.registrationStatus === "Registered" ? "✓" : "✗"} 
                            {candidate.registrationStatus === "Registered" ? " Reg" : " Unreg"}
                          </span>
                        </div>
                      </td>
                      
                      <td>
                        <div className="action-buttons">
                          <button
                            onClick={() => handleView(candidate)}
                            className="action-btn view"
                            title="View Details"
                          >
                            👁️
                          </button>
                          
                          {canEdit && (
                            <button
                              onClick={() => handleEdit(candidate)}
                              className="action-btn edit"
                              title="Edit"
                            >
                              ✏️
                            </button>
                          )}
                          
                          {canDelete && (
                            <button
                              onClick={() => handleDelete(candidate.id)}
                              className="action-btn delete"
                              title="Delete"
                            >
                              🗑️
                            </button>
                          )}
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {/* Pagination Controls */}
            <div className="pagination-container">
              <div className="pagination-info">
                Showing {indexOfFirstItem + 1} to {Math.min(indexOfLastItem, filteredCandidates.length)} of {filteredCandidates.length} entries
              </div>
              
              <div className="pagination-controls">
                <div className="items-per-page">
                  <label>Show:</label>
                  <select 
                    value={itemsPerPage} 
                    onChange={handleItemsPerPageChange}
                    className="items-per-page-select"
                  >
                    {itemsPerPageOptions.map(option => (
                      <option key={option} value={option}>{option}</option>
                    ))}
                  </select>
                </div>
                
                <div className="pagination-buttons">
                  <button 
                    onClick={goToPreviousPage} 
                    disabled={currentPage === 1}
                    className="pagination-btn prev"
                  >
                    &laquo; Previous
                  </button>
                  
                  <div className="page-numbers">
                    {[...Array(totalPages)].map((_, index) => {
                      const pageNumber = index + 1;
                      if (
                        pageNumber === 1 ||
                        pageNumber === totalPages ||
                        (pageNumber >= currentPage - 2 && pageNumber <= currentPage + 2)
                      ) {
                        return (
                          <button
                            key={pageNumber}
                            onClick={() => paginate(pageNumber)}
                            className={`page-number ${currentPage === pageNumber ? 'active' : ''}`}
                          >
                            {pageNumber}
                          </button>
                        );
                      } else if (
                        pageNumber === currentPage - 3 ||
                        pageNumber === currentPage + 3
                      ) {
                        return <span key={pageNumber} className="page-ellipsis">...</span>;
                      }
                      return null;
                    })}
                  </div>
                  
                  <button 
                    onClick={goToNextPage} 
                    disabled={currentPage === totalPages}
                    className="pagination-btn next"
                  >
                    Next &raquo;
                  </button>
                </div>
              </div>
            </div>
          </>
        ) : (
          <div className="empty-state">
            <div className="empty-icon">👥</div>
            <h3>No candidates found</h3>
            <p>Try adjusting your search or add a new candidate</p>
            {canEdit && (
              <button
                onClick={() => setShowModal(true)}
                className="btn-primary"
              >
                + Add Candidate
              </button>
            )}
          </div>
        )}
      </div>

      {/* View Candidate Modal */}
      {showViewModal && viewingCandidate && (
        <div className="modal-overlay">
          <div className="modal-content modal-lg">
            <div className="modal-header">
              <h2>Candidate Details</h2>
              <button
                className="modal-close"
                onClick={() => {
                  setViewingCandidate(null);
                  setShowViewModal(false);
                }}
              >
                ×
              </button>
            </div>

            <div className="modal-body">
              <div className="view-candidate-header">
                <div className="view-candidate-avatar">
                  {getInitials(viewingCandidate.name)}
                </div>
                <div className="view-candidate-title">
                  <h3>{viewingCandidate.name || "N/A"}</h3>
                  <p>{viewingCandidate.currentCompany || "No current company"}</p>
                </div>
                <div className="view-candidate-badges">
                  <span className={`status-badge ${(viewingCandidate.status || "inactive").toLowerCase()}`}>
                    {viewingCandidate.status || "Inactive"}
                  </span>
                  <span className={`registration-badge ${(viewingCandidate.registrationStatus || "unregistered").toLowerCase()}`}>
                    {viewingCandidate.registrationStatus || "Unregistered"}
                  </span>
                </div>
              </div>

              <div className="view-details-grid">
                <div className="view-details-section">
                  <h4>Contact Information</h4>
                  <div className="view-details-row">
                    <span className="detail-label">Email:</span>
                    <span className="detail-value">
                      <a href={`mailto:${viewingCandidate.email}`}>{viewingCandidate.email || "-"}</a>
                    </span>
                  </div>
                  <div className="view-details-row">
                    <span className="detail-label">Primary Phone:</span>
                    <span className="detail-value">{viewingCandidate.phone || "-"}</span>
                  </div>
                  <div className="view-details-row">
                    <span className="detail-label">Alternate Phone:</span>
                    <span className="detail-value">{viewingCandidate.alternatePhone || "-"}</span>
                  </div>
                  <div className="view-details-row">
                    <span className="detail-label">Location:</span>
                    <span className="detail-value">{viewingCandidate.location || "-"}</span>
                  </div>
                </div>

                <div className="view-details-section">
                  <h4>Professional Details</h4>
                  <div className="view-details-row">
                    <span className="detail-label">Qualification:</span>
                    <span className="detail-value">{viewingCandidate.qualification || "-"}</span>
                  </div>
                  <div className="view-details-row">
                    <span className="detail-label">Branch:</span>
                    <span className="detail-value">
                      <span className={`branch-badge ${viewingCandidate.branch?.toLowerCase() || ''}`}>
                        {viewingCandidate.branch || "-"}
                      </span>
                    </span>
                  </div>
                  <div className="view-details-row">
                    <span className="detail-label">Experience:</span>
                    <span className="detail-value">{viewingCandidate.experience || "-"}</span>
                  </div>
                  <div className="view-details-row">
                    <span className="detail-label">Current Company:</span>
                    <span className="detail-value">{viewingCandidate.currentCompany || "-"}</span>
                  </div>
                  <div className="view-details-row">
                    <span className="detail-label">Notice Period:</span>
                    <span className="detail-value">{viewingCandidate.noticePeriod || "-"}</span>
                  </div>
                </div>

                <div className="view-details-section">
                  <h4>Salary Information</h4>
                  <div className="view-details-row">
                    <span className="detail-label">Current Salary:</span>
                    <span className="detail-value">{formatCurrency(viewingCandidate.currentSalary)}</span>
                  </div>
                  <div className="view-details-row">
                    <span className="detail-label">Expected Salary:</span>
                    <span className="detail-value">{formatCurrency(viewingCandidate.expectedSalary)}</span>
                  </div>
                </div>

                <div className="view-details-section full-width">
                  <h4>Skills</h4>
                  <div className="skills-container">
                    {(viewingCandidate.skills || "")
                      .split(",")
                      .map(s => s.trim())
                      .filter(Boolean)
                      .map((skill, index) => (
                        <span key={index} className="skill-tag large">
                          {skill}
                        </span>
                      ))}
                    {!viewingCandidate.skills && <span className="detail-value">No skills added</span>}
                  </div>
                </div>

                <div className="view-details-section full-width">
                  <h4>Additional Information</h4>
                  <div className="view-details-row">
                    <span className="detail-label">Resume URL:</span>
                    <span className="detail-value">
                      {viewingCandidate.resumeUrl ? (
                        <a href={viewingCandidate.resumeUrl} target="_blank" rel="noopener noreferrer">
                          View Resume ↗
                        </a>
                      ) : "-"}
                    </span>
                  </div>
                  <div className="view-details-row">
                    <span className="detail-label">Created Date:</span>
                    <span className="detail-value">{formatDate(viewingCandidate.createdDate)}</span>
                  </div>
                </div>
              </div>
            </div>

            <div className="modal-footer">
              <button
                type="button"
                className="btn-secondary"
                onClick={() => {
                  setViewingCandidate(null);
                  setShowViewModal(false);
                }}
              >
                Close
              </button>
              
              {canEdit && (
                <button
                  type="button"
                  className="btn-primary"
                  onClick={() => {
                    setViewingCandidate(null);
                    setShowViewModal(false);
                    handleEdit(viewingCandidate);
                  }}
                >
                  Edit Candidate
                </button>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Add/Edit Modal */}
      {showModal && (
        <div className="modal-overlay">
          <div className="modal-content modal-lg">
            <div className="modal-header">
              <h2>
                {editingCandidate ? "Edit Candidate" : "Add New Candidate"}
              </h2>
              <button
                className="modal-close"
                onClick={() => {
                  resetForm();
                  setShowModal(false);
                }}
              >
                ×
              </button>
            </div>

            <form onSubmit={handleSubmit}>
              <div className="modal-body">
                <div className="form-grid">
                  <div className="form-group">
                    <label>Full Name *</label>
                    <input
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleInputChange}
                      className={`form-input ${formErrors.name ? 'error' : ''}`}
                      placeholder="John Doe"
                    />
                    {formErrors.name && <span className="error-message">{formErrors.name}</span>}
                  </div>

                  <div className="form-group">
                    <label>Email *</label>
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleInputChange}
                      className={`form-input ${formErrors.email ? 'error' : ''}`}
                      placeholder="john@example.com"
                    />
                    {formErrors.email && <span className="error-message">{formErrors.email}</span>}
                  </div>

                  <div className="form-group">
                    <label>Primary Phone</label>
                    <input
                      type="tel"
                      name="phone"
                      value={formData.phone}
                      onChange={handleInputChange}
                      className={`form-input ${formErrors.phone ? 'error' : ''}`}
                      placeholder="+1 234 567 890"
                    />
                    {formErrors.phone && <span className="error-message">{formErrors.phone}</span>}
                  </div>

                  <div className="form-group">
                    <label>Alternate Phone</label>
                    <input
                      type="tel"
                      name="alternatePhone"
                      value={formData.alternatePhone}
                      onChange={handleInputChange}
                      className="form-input"
                      placeholder="+1 234 567 891"
                    />
                  </div>

                  <div className="form-group">
                    <label>Qualification *</label>
                    <select
                      name="qualification"
                      value={formData.qualification}
                      onChange={handleInputChange}
                      className={`form-select ${formErrors.qualification ? 'error' : ''}`}
                    >
                      <option value="">Select Qualification</option>
                      {qualificationOptions.map((qual, index) => (
                        <option key={index} value={qual}>
                          {qual}
                        </option>
                      ))}
                    </select>
                    {formErrors.qualification && <span className="error-message">{formErrors.qualification}</span>}
                    <span className="form-hint">
                      Select candidate's highest qualification
                    </span>
                  </div>

                  <div className="form-group">
                    <label>Branch *</label>
                    <select
                      name="branch"
                      value={formData.branch}
                      onChange={handleInputChange}
                      className="form-select"
                    >
                      <option value="Ankleshwar">Ankleshwar</option>
                      <option value="Bharuch">Bharuch</option>
                    </select>
                  </div>

                  <div className="form-group">
                    <label>Experience *</label>
                    <select
                      name="experience"
                      value={formData.experience}
                      onChange={handleInputChange}
                      className={`form-select ${formErrors.experience ? 'error' : ''}`}
                    >
                      <option value="">Select Experience</option>
                      {experienceOptions.map((exp, index) => (
                        <option key={index} value={exp}>
                          {exp}
                        </option>
                      ))}
                    </select>
                    {formErrors.experience && <span className="error-message">{formErrors.experience}</span>}
                  </div>

                  <div className="form-group">
                    <label>Current Company</label>
                    <input
                      type="text"
                      name="currentCompany"
                      value={formData.currentCompany}
                      onChange={handleInputChange}
                      className="form-input"
                      placeholder="Current Company"
                    />
                  </div>

                  <div className="form-group">
                    <label>Current Salary (LPA)</label>
                    <input
                      type="text"
                      name="currentSalary"
                      value={formData.currentSalary}
                      onChange={handleInputChange}
                      className="form-input"
                      placeholder="e.g., 12"
                    />
                  </div>

                  <div className="form-group">
                    <label>Expected Salary (LPA)</label>
                    <input
                      type="text"
                      name="expectedSalary"
                      value={formData.expectedSalary}
                      onChange={handleInputChange}
                      className="form-input"
                      placeholder="e.g., 15"
                    />
                  </div>

                  <div className="form-group">
                    <label>Notice Period</label>
                    <select
                      name="noticePeriod"
                      value={formData.noticePeriod}
                      onChange={handleInputChange}
                      className="form-select"
                    >
                      <option value="">Select Notice Period</option>
                      <option value="Immediate">Immediate</option>
                      <option value="15 days">15 days</option>
                      <option value="30 days">30 days</option>
                      <option value="45 days">45 days</option>
                      <option value="60 days">60 days</option>
                      <option value="90 days">90 days</option>
                    </select>
                  </div>

                  <div className="form-group">
                    <label>Location</label>
                    <input
                      type="text"
                      name="location"
                      value={formData.location}
                      onChange={handleInputChange}
                      className="form-input"
                      placeholder="City, Country"
                    />
                  </div>

                  <div className="form-group">
                    <label>Status</label>
                    <select
                      name="status"
                      value={formData.status}
                      onChange={handleInputChange}
                      className="form-select"
                    >
                      <option value="Active">Active</option>
                      <option value="Inactive">Inactive</option>
                      <option value="Placed">Placed</option>
                    </select>
                  </div>

                  <div className="form-group">
                    <label>Registration Status</label>
                    <select
                      name="registrationStatus"
                      value={formData.registrationStatus}
                      onChange={handleInputChange}
                      className="form-select"
                    >
                      <option value="">Select Registration Status</option>
                      <option value="Registered">Registered</option>
                      <option value="Unregistered">Unregistered</option>
                    </select>
                    <span className="form-hint">
                      If not selected, "Unregistered" will be saved by default
                    </span>
                  </div>

                  {editingCandidate && (
                    <div className="form-group">
                      <label>Created Date</label>
                      <input
                        type="datetime-local"
                        name="createdDate"
                        value={formData.createdDate}
                        onChange={handleInputChange}
                        className={`form-input ${formErrors.createdDate ? 'error' : ''}`}
                      />
                      {formErrors.createdDate && <span className="error-message">{formErrors.createdDate}</span>}
                      <span className="form-hint">
                        Cannot select a future date
                      </span>
                    </div>
                  )}
                </div>

                <div className="form-group">
                  <label>Skills (Optional)</label>
                  <textarea
                    name="skills"
                    value={formData.skills}
                    onChange={handleInputChange}
                    className="form-textarea"
                    placeholder="React, JavaScript, Node.js (comma separated)"
                    rows="3"
                  />
                  <span className="form-hint">
                    Enter skills separated by commas (optional)
                  </span>
                </div>

                <div className="form-group">
                  <label>Resume URL</label>
                  <input
                    type="url"
                    name="resumeUrl"
                    value={formData.resumeUrl}
                    onChange={handleInputChange}
                    className="form-input"
                    placeholder="https://example.com/resume.pdf"
                  />
                </div>
              </div>

              <div className="modal-footer">
                <button
                  type="button"
                  className="btn-secondary"
                  onClick={() => {
                    resetForm();
                    setShowModal(false);
                  }}
                >
                  Cancel
                </button>
                <button type="submit" className="btn-primary">
                  {editingCandidate ? "Update Candidate" : "Save Candidate"}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Excel Import Modal - Visible to Admin and Recruiter */}
      {showImportModal && (isAdmin || isRecruiter) && (
        <div className="modal-overlay">
          <div className="modal-content modal-lg">
            <div className="modal-header">
              <h2>Import Candidates from Excel</h2>
              <button
                className="modal-close"
                onClick={() => {
                  resetImport();
                  setShowImportModal(false);
                }}
              >
                ×
              </button>
            </div>

            <div className="modal-body">
              {importStep === 'upload' && (
                <div className="import-upload-section">
                  <div className="import-instructions">
                    <h3>Instructions:</h3>
                    <ul>
                      <li>Download the template file first</li>
                      <li>Fill in your candidate data</li>
                      <li>Required columns: Name, Email, Experience, Qualification</li>
                      <li>Skills column is optional</li>
                      <li>Branch must be either "Ankleshwar" or "Bharuch"</li>
                      <li>Registration Status: Leave empty to default to "Unregistered"</li>
                      <li><strong>Resume Link:</strong> Optional - Add direct URL to candidate's resume (Google Drive, Dropbox, etc.)</li>
                      <li>Upload the filled Excel file (.xlsx, .xls)</li>
                    </ul>
                  </div>

                  <div className="import-actions">
                    <button
                      onClick={downloadTemplate}
                      className="btn-secondary"
                    >
                      📥 Download Template
                    </button>
                    
                    <div className="file-upload-area">
                      <input
                        type="file"
                        ref={fileInputRef}
                        accept=".xlsx,.xls,.csv"
                        onChange={handleFileUpload}
                        className="file-input"
                        id="excel-upload"
                      />
                      <label htmlFor="excel-upload" className="file-upload-label">
                        {importLoading ? 'Processing...' : 'Choose Excel File'}
                      </label>
                    </div>
                  </div>

                  {importLoading && (
                    <div className="import-loading">
                      <div className="spinner-small"></div>
                      <p>Processing file...</p>
                    </div>
                  )}
                </div>
              )}

              {importStep === 'preview' && (
                <div className="import-preview-section">
                  <div className="import-summary">
                    <h3>Import Summary</h3>
                    <div className="summary-stats">
                      <div className="stat-item success">
                        <span className="stat-value">{importData.length}</span>
                        <span className="stat-label">Valid Records</span>
                      </div>
                      <div className="stat-item error">
                        <span className="stat-value">{importErrors.length}</span>
                        <span className="stat-label">Errors</span>
                      </div>
                    </div>
                  </div>

                  {importErrors.length > 0 && (
                    <div className="import-errors">
                      <h4>Errors Found:</h4>
                      <div className="errors-list">
                        {importErrors.map((error, idx) => (
                          <div key={idx} className="error-item">
                            <strong>Row {error.row}:</strong> {error.name} - {error.errors.join(', ')}
                          </div>
                        ))}
                      </div>
                    </div>
                  )}

                  {importData.length > 0 && (
                    <div className="import-preview">
                      <h4>Preview (First 5 Records)</h4>
                      <div className="preview-table-container">
                        <table className="preview-table">
                          <thead>
                            <tr>
                              <th>Name</th>
                              <th>Email</th>
                              <th>Qualification</th>
                              <th>Branch</th>
                              <th>Skills</th>
                              <th>Experience</th>
                              <th>Status</th>
                              <th>Registration Status</th>
                              <th>Resume Link</th>
                            </tr>
                          </thead>
                          <tbody>
                            {importData.slice(0, 5).map((candidate, idx) => (
                              <tr key={idx}>
                                <td>{candidate.name}</td>
                                <td>{candidate.email}</td>
                                <td>{candidate.qualification || '-'}</td>
                                <td>
                                  <span className={`branch-badge ${candidate.branch?.toLowerCase()}`}>
                                    {candidate.branch}
                                  </span>
                                </td>
                                <td>{candidate.skills || '-'}</td>
                                <td>{candidate.experience}</td>
                                <td>
                                  <span className={`status-badge ${candidate.status.toLowerCase()}`}>
                                    {candidate.status}
                                  </span>
                                </td>
                                <td>
                                  <span className={`registration-badge ${(candidate.registrationStatus || 'unregistered').toLowerCase()}`}>
                                    {candidate.registrationStatus || 'Unregistered'}
                                  </span>
                                </td>
                                <td>
                                  {candidate.resumeUrl ? (
                                    <a href={candidate.resumeUrl} target="_blank" rel="noopener noreferrer" style={{ fontSize: '11px' }}>
                                      View Link ↗
                                    </a>
                                  ) : '-'}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  )}
                </div>
              )}

              {importStep === 'complete' && (
                <div className="import-complete">
                  <div className="success-icon">✅</div>
                  <h3>Import Successful!</h3>
                  <p>{importData.length} candidates have been added.</p>
                </div>
              )}
            </div>

            {importStep === 'preview' && (
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn-secondary"
                  onClick={resetImport}
                >
                  Back
                </button>
                <button
                  type="button"
                  className="btn-primary"
                  onClick={handleImportConfirm}
                  disabled={importData.length === 0 || importLoading}
                >
                  {importLoading ? 'Importing...' : `Import ${importData.length} Candidates`}
                </button>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default Candidates;